{
  "general": {
    "acceptsJpgPng": "Accepts JPG And PNG - Max (10MB)",
    "retry": "Retry",
    "chooseFile": "Choose File",
    "orDragDrop": "or drag & drop",
    "remove": "Remove",
    "unsupportedFileType": "Unsupported file type: {{name}}",
    "change": "Change",
    "optional": "optional",
    "Save": "Save",
    "SaveAndAddMore": "Save And Add More",
    "Done": "Done",
    "actions": "Actions",
    "inValid": "Invalid",
    "Valid": "Valid",
    "status": "status",
    "Comment": "Comment",
    "view": "View",
    "No_Chats": "No Chats",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "select": "Select",
    "write": "Write...",
    "print": "Print",
    "refresh": "Refresh",
    "No_Participant": "No Participants",
    "Mark_As_Open": "Mark As Open",
    "Move_To_Done": "Move To Done",
    "Filter": "Filter",
    "Password": "Password",
    "Password_is_required": "Password is required!",
    "Email": "Email",
    "Email_is_required": "Email is required!",
    "User_Name_is_required": "User Name is required!",
    "Wrong_User_Or_Password": "invalid username or password",
    "Company_Disabled": "Your subscription has ended. Please contact support to reactivate your account.",
    "Company_Disabled_Title": "Account disabled",
    "Company_Disabled_Back": "Sign in with another account",
    "Contact_Support": "Contact with support",
    "login": "login",
    "Sign_In": "Sign In",
    "Send": "Send",
    "Cancel": "Cancel",
    "Update": "Update",
    "Star_Messages": "Star Messages",
    "Username": "Username",
    "Agents": "Agents",
    "Id": "Id",
    "Subject_Name": "Subject Name",
    "Creation": "Creation",
    "Owner": "Owner",
    "Participant": "Participant",
    "close": "Close",
    "type_your_message": "type your message ...",
    "Delete": "Delete",
    "confirmDeleteItem": "Are you sure you want to delete this item?",
    "Add": "Add",
    "Edit": "Edit",
    "create": "Create",
    "submit": "Submit",
    "RequiredField": "This field is required",
    "save-changes": "Save Changes",
    "InActive": "Inactive",
    "No": "No",
    "Yes": "Yes",
    "Disable": "Disable",
    "Enable": "Enable",
    "note_is_required": "note is required!",
    "Retry_Send": "Retry Send",
    "Active": "Active",
    "addNew": "+ Add New",
    "statusUpdatedSuccess": "Status Updated Successfully",
    "statusUpdateFailed": "Failed to update status.",
    "invalidFileType": "Invalid file type. Please select an Excel or CSV file.",
    "fileTooLarge": "File is too large. Maximum size is 10MB.",
    "fileSelected": "File selected successfully. Processing...",
    "exportStarted": "Export started. You will receive the file shortly.",
    "Import": "Import",
    "all": "All",
    "selectFile": "Please select a file to upload",
    "importing": "Importing products...",
    "importingUnits": "Importing units...",
    "importSuccess": "File has been uploaded successfully",
    "importUnitsSuccess": "Units imported successfully!",
    "importError": "Failed to import products. Please try again.",
    "importUnitsError": "Failed to import units. Please try again.",
    "importValidationError": "Invalid file format or data. Please check your file and try again.",
    "serverError": "Server error occurred. Please try again later.",
    "importingBrands": "Importing brands...",
    "importBrandsSuccess": "Brands imported successfully!",
    "importBrandsError": "Failed to import brands. Please try again.",
    "importingCategories": "Importing categories...",
    "importCategoriesSuccess": "Categories imported successfully!",
    "importCategoriesError": "Failed to import categories. Please try again.",
    "downloadingSample": "Downloading sample file...",
    "sampleDownloaded": "Sample file downloaded successfully!",
    "downloadError": "Failed to download sample file. Please try again.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "By": "By",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "updating": "Updating...",
    "download": "Download",
    "back": "Back",
    "loading": "Loading...",
    "NoData": "No data available",
    "file": "File",
    "preview": "Preview",
    "thankYou": "Thank you for your order!",
    "poweredByAwfar": "Powered by Awfar",
    "to": "to"
  },
  "loading": {
    "permissions": "Loading permissions..."
  },
  "permissions": {
    "refreshPermissions": "Refresh Permissions",
    "refreshing": "Refreshing...",
    "refreshSuccess": "Permissions refreshed successfully",
    "refreshError": "Failed to refresh permissions",
    "Permissions": "Permissions"
  },
  "error": {
    "noPermissions": "Unable to load permissions"
  },
  "common": {
    "noPermission": "You don't have permission to access this section"
  },
  "unauthorized": {
    "title": "Access Denied",
    "subtitle": "You do not have permission to access this page.",
    "subtitleWithPermission": "You do not have permission to perform this action (Permission: {{permission}})",
    "goBack": "Go Back",
    "goHome": "Go Home"
  },
  "users": {
    "title": "User Management",
    "addNew": "Add New User",
    "viewUser": "View User Details",
    "editUser": "Edit User",
    "deleteUser": "Delete User",
    "deleteConfirm": "Are you sure you want to delete this user?",
    "deleteSuccess": "User deleted successfully",
    "deleteError": "Failed to delete user",
    "name": "Name",
    "email": "Email",
    "username": "Username",
    "type": "Type",
    "status": "Status",
    "roles": "Roles",
    "createdAt": "Created",
    "admin": "Admin",
    "user": "User",
    "active": "Active",
    "inactive": "Inactive",
    "totalUsers": "Total Users",
    "activeUsers": "Active Users",
    "inactiveUsers": "Inactive Users",
    "adminUsers": "Admin Users",
    "searchPlaceholder": "Search by name, email, or username",
    "selectType": "Select Type",
    "selectStatus": "Select Status",
    "view": "View User",
    "edit": "Edit User",
    "delete": "Delete User"
  },
  "manageCustomers": {
    "tableTitle": "Manage Customers",
    "noDeletePermission": "You don't have permission to delete customers",
    "blockSuccess": "Customer blocked successfully",
    "unblockSuccess": "Customer unblocked successfully",
    "blockError": "Failed to update customer status",
    "deleteSuccess": "Customer deleted successfully",
    "deleteError": "Failed to delete customer",
    "male": "Male",
    "female": "Female",
    "blockModalTitle": "Block Customer",
    "unblockModalTitle": "Unblock Customer",
    "deleteModalTitle": "Delete Customer",
    "blockConfirm": "Are you sure you want to block this customer?",
    "unblockConfirm": "Are you sure you want to unblock this customer?",
    "deleteConfirm": "Are you sure you want to delete this customer? This action cannot be undone.",
    "columns": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "birthdate": "Birthdate",
      "gender": "Gender",
      "from": "From",
      "registeredAt": "Registered At",
      "deletedAt": "Deleted At",
      "age": "Age",
      "loginWith": "Login With"
    },
    "actions": {
      "view": "View",
      "block": "Block",
      "unblock": "Unblock",
      "delete": "Delete"
    }
  },
  "validationMessages": {
    "invalidEmail": "Invalid Email",
    "invalidUrl": "Invalid URL",
    "mustBeHttpOrHttps": "Must Be Http Or Https"
  },
  "sectionList": {
    "tableTitle": "All Sections",
    "modalTitle": "Section Modal",
    "addSection": "Add Section",
    "editSection": "Edit Section",
    "columns": {
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)"
    },
    "save": "Save",
    "cancel": "Cancel",
    "sort": "Sort Order",
    "products": "Products",
    "writeNameEn": "Write name in English...",
    "writeNameAr": "Write name in Arabic...",
    "selectProducts": "Select products...",
    "enterSortNumber": "Enter sort number...",
    "imageEn": "English Image",
    "imageAr": "Arabic Image",
    "hideFromStores": "Hide From Stores",
    "selectStores": "Select stores to hide from...",
    "required": "This field is required",
    "status": "Status",
    "enable": "Enable",
    "disable": "Disable",
    "createdSuccessfully": "Section created successfully",
    "updatedSuccessfully": "Section updated successfully",
    "failedSave": "Failed to save the section",
    "write": "Write...",
    "trackingOrders": "Tracking Orders",
    "eCommerce": "e-commerce",
    "slider": "Slider",
    "cancelReasons": "Cancel Reasons",
    "uncompletedOrderReasons": "Uncompleted Reasons",
    "configuration": "Configuration",
    "activities": "Activities",
    "allTickets": "All Tickets",
    "allTypes": "All Types",
    "alwaysOpen": "Pin Sidebar"
  },
  "validation": {
    "nameEnRequired": "English name is required",
    "nameArRequired": "Arabic name is required",
    "priceRequired": "Price is required",
    "priceFormat": "Invalid price format (e.g. 10.99)",
    "barcodeRequired": "Barcode is required",
    "stockRequired": "Stock quantity is required",
    "stockMin2": "Minimum stock is 2",
    "stockMin0": "Stock can't be negative",
    "stepsRequired": "Steps is required",
    "stepsMin1": "Minimum steps is 1",
    "stepsGreaterThan0": "Steps must be greater than 0",
    "minQtyRequired": "Minimum quantity is required",
    "minQtyPositive": "Must be positive number",
    "max255": "Maximum 255 characters",
    "formError": "Please fix all errors before submitting",
    "required": "This field is required",
    "unitNameRequired": "Unit name is required",
    "unitTypeRequired": "Unit type is required",
    "priceEffectRequired": "Price effect is required",
    "stockEffectRequired": "Stock effect is required",
    "quantityRequired": "Quantity is required"
  },
  "header": {
    "awfar": "Awfar",
    "Bot_Chat": "Bot & Chat",
    "CRM": "CRM",
    "Dashboard": "Dashboard",
    "Log_out": "Log out",
    "searchCustomer": "Search customer...",
    "noCustomersFound": "No customers found",
    "darkMode": "Dark mode",
    "lightMode": "Light mode"
  },
  "sideBar": {
    "home": "Home",
    "reports": "Reports",
    "reportsDashboard": "Dashboard",
    "reportsExportLogs": "Export Logs",
    "reportsCompanies": "Companies",
    "welcome": "Welcome to the dashboard",
    "catalog": "Catalog",
    "product": "Products",
    "categories": "Categories",
    "brands": "Brands",
    "manufacturers": "Manufacturers",
    "extra": "Extras",
    "productAttributes": "Product Attributes",
    "keywords": "Keywords",
    "productReviews": "Product Reviews",
    "reviewBannedWords": "Review Banned Words",
    "sections": "Sections",
    "fileManager": "File Manager",
    "failedProductImports": "Failed Product Imports",
    "orders": "Orders",
    "addOrder": "Add Order",
    "orderList": "Order List",
    "activeOrders": "Active Orders",
    "orderTracking": "Order Tracking",
    "activities": "Activities",
    "allTickets": "All Tickets",
    "activity-types": "Activity Types",
    "activity-sections": "Activity Sections",
    "activity-reasons": "Activity Reasons",
    "activity-status": "Activity Status",
    "activityPriorities": "Activity Priorities & Closing Time",
    "eCommerce": "E-Commerce",
    "slider": "Sliders",
    "flashDeal": "Flash Deal",
    "promocode": "Promocode",
    "Setting": "Settings",
    "cancelReasons": "Cancel Reasons",
    "uncompletedOrderReasons": "Uncompleted Reasons",
    "homeStaticContent": "Static Home Content",
    "setting": {
      "company-setting": "Company Settings",
      "all-companies": "All Companies",
      "company-customizations": "Company Customizations",
      "notification-sounds": "Notification Sounds",
      "payment-settings": "Payment Settings",
      "customer-segmentation": "Customer Segmentation",
      "export-reports": "Export Reports",
      "email-settings": "Email Settings",
      "push-notifications": "Push Notifications",
      "organization": "Organization",
      "sms-templates": "SMS Templates"
    },
    "users": "Users",
    "manageCustomers": "Manage Customers",
    "alwaysOpen": "Always Open",
    "configuration": "Configuration",
    "locations": "Locations",
    "countries": "Countries",
    "cities": "Cities",
    "areas": "Areas",
    "regions": "Regions",
    "offers": "Offers",
    "allOffers": "All Offers",
    "offersGroup": "Offers Group",
    "logs": "Logs",
    "failedOfferImports": "Failed Import Offers",
    "failedCategoryImports": "Failed Import Categories",
    "integrationMonitoring": "Integration Monitoring",
    "integrations": "Integrations",
    "sms": "SMS",
    "paymentGateway": "Payment Gateway",
    "dmsSettings": "DMS setting",
    "aiDistribution": "AI distribution",
    "skills": "Skills",
    "serviceTypes": "Service Types",
    "tripTypes": "Trip Types",
    "shoppers": "Shoppers",
    "shopperOrderStatus": "Shopper Order Status",
    "custody": "Custody",
    "purchasing": "Purchasing",
    "predictProducts": "Predict Products",
    "purchasingRequests": "Purchasing Requests",
    "allPurchasingRequests": "All Purchasing Requests",
    "dmsReports": "DMS Reports",
    "dmsDashboard": "Dashboard",
    "top10Shoppers": "Top 10 Shoppers",
    "driverTracker": "Driver Trucker",
    "agentKpi": "Drivers KPI",
    "prediction": "Prediction",
    "pages": "Pages",
    "aboutPage": "About page",
    "privacyPage": "Privacy page",
    "termsPage": "Terms page",
    "faqPage": "FAQ page",
    "insurance": "Insurance",
    "insuranceCompanies": "Insurance companies",
    "insuranceOrder": "Insurance Order",
    "shortLinks": "Short Links",
    "sallaOrders": "Salla Orders",
    "sallaAllOrders": "All Orders",
    "sallaPurchasedOrders": "Purchased Orders",
    "suppliers": "Suppliers",
    "permissions": "Permissions",
    "permissionsModels": "Models",
    "permissionsPermissions": "Permissions",
    "permissionsRoles": "Roles",
    "reportsRevenue": "Revenue",
    "reportsOrderAnalytics": "Order Analytics",
    "reportsCustomers": "Customers",
    "reportsStoreCompare": "Store Compare",
    "reportsGrowth": "Growth",
    "reportsProducts": "Products",
    "pharmacistWorkspace": "Pharmacist Workspace",
    "prescriptionStatuses": "Prescription Statuses",
    "prescriptionRejectReasons": "Rx Reject Reasons",
    "refunds": "Refunds",
    "refundApprovalRules": "Refund Approval Rules"
  },
  "permissionsPanel": {
    "title": "Permissions",
    "tabs": {
      "models": "Models",
      "permissions": "Permissions",
      "roles": "Roles"
    },
    "placeholder": {
      "models": "Models management will be available here.",
      "permissions": "Permissions management will be available here.",
      "roles": "Roles management will be available here."
    }
  },
  "models": {
    "tableTitle": "Models",
    "columns": {
      "title": "Title"
    },
    "placeholders": {
      "title": "Enter title"
    },
    "addTitle": "Add Model",
    "editTitle": "Edit Model",
    "createdSuccessfully": "Created successfully",
    "updatedSuccessfully": "Updated successfully",
    "failedSave": "Failed to save",
    "awfarOnlyTitle": "Access restricted",
    "awfarOnlySubtitle": "Only Admin Awfar users can view and manage models."
  },
  "permission": {
    "tableTitle": "Permissions",
    "columns": {
      "title": "Title",
      "model": "Model",
      "status": "Status"
    },
    "placeholders": {
      "title": "Enter title",
      "model": "Enter model"
    },
    "addTitle": "Add Permission",
    "editTitle": "Edit Permission",
    "createdSuccessfully": "Created successfully",
    "updatedSuccessfully": "Updated successfully",
    "failedSave": "Failed to save",
    "awfarOnlyTitle": "Access restricted",
    "awfarOnlySubtitle": "Only Admin Awfar users can view and manage permissions."
  },
  "role": {
    "tableTitle": "Roles",
    "columns": {
      "title": "Title",
      "permission": "Permissions"
    },
    "placeholders": {
      "title": "Enter title"
    },
    "addTitle": "Add Role",
    "editTitle": "Edit Role",
    "createdSuccessfully": "Created successfully",
    "updatedSuccessfully": "Updated successfully",
    "failedSave": "Failed to save",
    "showMore": "Show all",
    "active": "Active",
    "accessRestrictedTitle": "Access restricted",
    "accessRestrictedSubtitle": "Only Admin Awfar and Admin Company users can view and manage roles.",
    "permissionsModal": {
      "title": "Role Permissions",
      "total": "Total permissions",
      "general": "General Permissions",
      "noPermissions": "No permissions assigned to this role."
    },
    "permissionsPicker": {
      "search": "Search permissions",
      "selectAll": "Select all",
      "clearAll": "Clear all",
      "selected": "Selected",
      "models": "Models",
      "noResults": "No permissions found",
      "general": "General"
    },
    "permissionGroups": {
      "odoo": "Odoo",
      "dms": "DMS",
      "refund": "Refunds"
    },
    "permissionLabels": {
      "odoo_show": "Show Odoo info",
      "odoo_not_delivered_refund": "Not delivered refund",
      "odoo_return_history": "Return history",
      "order_details_show_dms": "Show DMS info in order details",
      "manage_refund_view": "View refunds",
      "manage_refund_show": "Show refund",
      "manage_refund_create": "Request refund",
      "manage_refund_approve": "Approve / reject refunds",
      "manage_refund_process": "Settle refunds",
      "manage_refund_approval_rule_view": "View refund approval rules",
      "manage_refund_approval_rule_show": "Show refund approval rule",
      "manage_refund_approval_rule_create": "Create refund approval rules",
      "manage_refund_approval_rule_edit": "Edit refund approval rules",
      "manage_refund_approval_rule_delete": "Delete refund approval rules"
    }
  },
  "pages": {
    "about": {
      "title": "About page",
      "contentAr": "content ar",
      "contentEn": "content en",
      "saveSuccess": "About page saved"
    },
    "privacy": {
      "title": "Privacy page",
      "contentAr": "content ar",
      "contentEn": "content en",
      "saveSuccess": "Privacy page saved"
    },
    "terms": {
      "title": "Terms page",
      "contentAr": "content ar",
      "contentEn": "content en",
      "saveSuccess": "Terms page saved"
    },
    "faq": {
      "title": "FAQ page",
      "contentAr": "content ar",
      "contentEn": "content en",
      "saveSuccess": "FAQ page saved"
    },
    "insurance": {
      "title": "Insurance Companies"
    }
  },
  "insuranceCoverage": {
    "title": "Coverage",
    "addCoverage": "Add Coverage",
    "editCoverage": "Edit Coverage",
    "targetType": "Coverage applies to",
    "product": "Product",
    "category": "Category",
    "name": "Name",
    "barcode": "Barcode",
    "coveragePercent": "Coverage %",
    "startsAt": "Starts at",
    "endsAt": "Ends at",
    "window": "Active window",
    "always": "Always",
    "activeNow": "Active now",
    "outOfWindow": "Out of window",
    "endBeforeStart": "End date must be on or after the start date",
    "saveError": "Failed to save coverage",
    "searchPlaceholder": "Search by product, barcode or category",
    "importTitle": "Import Coverage",
    "uploadFile": "Upload File",
    "downloadSample": "Download Sample Template",
    "fileTooLarge": "File is too large. Maximum size is 10MB.",
    "importSuccess": "Coverage imported successfully",
    "importError": "Failed to import coverage. Please try again.",
    "importCounts": "Created: {{created}}, Updated: {{updated}}, Skipped: {{skipped}}",
    "unmatchedBarcodes": "Barcodes not found: {{barcodes}}",
    "unmatchedCategories": "Categories not found: {{categories}}",
    "importInstructions": {
      "title": "Import Instructions",
      "target": "Fill barcode for a product or category_id for a whole category — one per row",
      "percent": "coverage_percent is required (0 – 100)",
      "dates": "starts_at / ends_at are optional (YYYY-MM-DD)",
      "status": "status is optional (1 / 0, default 1)",
      "upsert": "Existing coverage for the same product or category is updated",
      "supportedFormats": "Supported formats"
    }
  },
  "insurance": {
    "nameEn": "Name (EN)",
    "nameAr": "Name (AR)",
    "phone": "Phone",
    "email": "Email",
    "sort": "Sort",
    "detailsEn": "Details (EN)",
    "detailsAr": "Details (AR)",
    "logo": "Logo",
    "files": "Files",
    "filesFor": "Files for",
    "filesNameEn": "File Name (EN)",
    "filesNameAr": "File Name (AR)",
    "filesType": "Type",
    "minFiles": "Min files",
    "maxFiles": "Max files",
    "instructionAr": "Instruction (AR)",
    "instructionEn": "Instruction (EN)",
    "uploadPrescription": "Upload prescription file",
    "showInstruction": "Show instruction",
    "image": "Image",
    "addCompany": "Add Insurance Company",
    "editCompany": "Edit Insurance Company",
    "addFile": "Add File",
    "editFile": "Edit File"
  },
  "insuranceDetails": {
    "title": "Insurance",
    "cards": "Insurance Cards",
    "companyFiles": "Company Files",
    "nationalId": "National ID",
    "prescriptions": "Prescriptions",
    "companyProfile": "Company Profile",
    "approval": "Approval",
    "company": "Insurance Company",
    "selectCompany": "Select Insurance Company",
    "attachmentType": "Attachment Type",
    "prescription": "Prescription",
    "nationalIdOption": "National ID",
    "uploadPrescriptionHint": "Click to upload prescription images (multiple allowed).",
    "uploadNationalIdHint": "Click to upload National ID images (multiple allowed).",
    "saveAttachments": "Save Attachments",
    "saveSuccess": "Insurance updated successfully",
    "saveFailed": "Failed to update insurance",
    "companyRequired": "Please select an insurance company",
    "editLocked": "This order can no longer be edited",
    "metaError": "Could not load insurance companies"
  },
  "insuranceOrder": {
    "title": "Insurance Order",
    "metaErrorTitle": "Couldn't load the order form",
    "metaError": "Stores and insurance companies could not be loaded. Please try again.",
    "allOrders": "All Orders",
    "selectStore": "Select Store",
    "selectCustomer": "Select Customer",
    "searchCustomer": "Search customer...",
    "insuranceCompany": "Insurance Company",
    "selectCompany": "Select Insurance Company",
    "insuranceProfile": "Insurance Policy",
    "noProfile": "No Policy",
    "profileAutoCreate": "A policy will be created automatically when a prescription is uploaded",
    "prescription": "Prescription",
    "optional": "(optional)",
    "upload": "Upload",
    "uploadFailed": "Failed to upload prescription images",
    "comment": "Notes",
    "commentPlaceholder": "Any additional notes...",
    "addProducts": "Add Products",
    "searchProduct": "Search product...",
    "cart": "Selected Products",
    "clear": "Clear",
    "confirmClear": "Clear all products?",
    "emptyCart": "No products yet",
    "total": "Total",
    "submit": "Confirm Order",
    "orderCreated": "Order created successfully!",
    "orderNumber": "Order #",
    "viewOrder": "View Order",
    "newOrder": "New Order",
    "error": "Something went wrong",
    "uploadPartial": "{{failed}} file(s) failed to upload; continuing with the rest."
  },
  "shortLinks": {
    "title": "Short Links",
    "name": "Name",
    "web": "Web URL",
    "android": "Android URL",
    "ios": "iOS URL",
    "hash": "Hash",
    "visitCounts": "Visit Counts",
    "uniqueVisitCounts": "Unique Visit Counts",
    "showResult": "Show Result",
    "visitors": "Visitors",
    "ipAddress": "IP Address",
    "userAgent": "User Agent",
    "country": "Country",
    "region": "Region",
    "city": "City",
    "method": "Method",
    "parameter": "Parameter",
    "countryName": "Country Name",
    "countryCode": "Country Code",
    "regionCode": "Region Code",
    "regionName": "Region Name",
    "cityName": "City Name",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "timezone": "Timezone",
    "referer": "Referer",
    "deviceType": "Device Type",
    "platform": "Platform",
    "browser": "Browser",
    "visitedAt": "Visited At",
    "addShortLink": "Add Short Link",
    "editShortLink": "Edit Short Link"
  },
  "sms": {
    "smsTypeManagement": "SMS Type Management",
    "smsTypeManagementDescription": "Create and manage different SMS service types with their logos and configurations.",
    "createNewSmsType": "Create New SMS Type",
    "editSmsType": "Edit SMS Type",
    "smsTypeName": "SMS Type Name",
    "smsTypeNameRequired": "SMS Type Name is required",
    "smsTypeNameMinLength": "Name must be at least 2 characters",
    "smsTypeNameMaxLength": "Name must not exceed 50 characters",
    "smsServiceLogo": "SMS Service Logo",
    "uploadLogo": "Upload Logo",
    "dataOfIntegration": "Data Of {{name}} Integration",
    "editCredentials": "Edit Credentials",
    "setCredentials": "Set Credentials",
    "credentialsFeature": "Credentials configuration feature coming soon",
    "smsTypeCreated": "SMS Type created successfully",
    "smsTypeCreateError": "Failed to create SMS Type",
    "smsTypeUpdated": "SMS Type updated successfully",
    "smsTypeUpdateError": "Failed to update SMS Type",
    "smsTypeDeleted": "SMS Type deleted successfully",
    "smsTypeDeleteError": "Failed to delete SMS Type",
    "deleteConfirm": "Are you sure you want to delete this SMS Type?",
    "noSmsTypes": "No SMS Types found",
    "createFirstSmsType": "Create Your First SMS Type",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "overview": "Overview",
    "smsTypes": "SMS Types",
    "overviewDescription": "Manage your SMS integration settings and send messages to customers.",
    "smsConfiguration": "SMS Configuration",
    "configure": "Configure",
    "smsConfigurationDescription": "Set up your SMS provider credentials and API settings.",
    "sendSms": "Send SMS",
    "sendMessage": "Send Message",
    "sendSmsDescription": "Send SMS messages to individual customers or groups.",
    "smsTemplates": "SMS Templates",
    "manageTemplates": "Manage Templates",
    "smsTemplatesDescription": "Create and manage SMS message templates.",
    "recentActivity": "Recent SMS Activity",
    "noRecentActivity": "No recent SMS activity to display.",
    "updateSmsIntegration": "Update SMS Integration",
    "smsType": "SMS Type",
    "selectSmsType": "Select SMS Type",
    "sender": "Sender",
    "senderRequired": "Sender is required",
    "language": "Language",
    "languageRequired": "Language is required",
    "activation": "Activation",
    "credentialsUpdated": "Credentials updated successfully",
    "credentialsUpdateError": "Failed to update credentials"
  },
  "companies": {
    "status": {
      "tableTitle": "All Companies (19)"
    },
    "fields": {
      "englishName": "English Name",
      "arabicName": "Arabic Name",
      "loginAs": "Login As",
      "logOut": "Log Out",
      "url": "URL",
      "phone": "Phone",
      "status": "Status",
      "actions": "Actions"
    },
    "LoggedinSuccessfully": "Logged in successfully",
    "LoggedOutSuccessfully": "Logged out successfully",
    "LoginAsError": "Failed to login as company. Please try again."
  },
  "companyCustomizations": {
    "title": "Company Customizations",
    "listHint": "Presets are defined in code. You can only link or unlink companies — not create or edit presets.",
    "emptyPresets": "No customization presets found.",
    "emptyAssignments": "No companies linked to this preset.",
    "active": "Active",
    "inactive": "Inactive",
    "inactiveLinkDisabled": "Inactive presets cannot be linked to companies.",
    "settingsOverrides": "Settings overrides",
    "settingsOverridesHint": "Sparse overrides applied on top of module defaults. Read-only.",
    "settingsPreview": "Merged preview (defaults + overrides)",
    "settingsPreviewHint": "Full resolved settings for this preset. Read-only.",
    "linkedCompaniesTitle": "Linked companies",
    "linkedCompaniesHint": "One preset per module per company.",
    "linkCompany": "Link company",
    "link": "Link",
    "unlink": "Unlink",
    "unlinkConfirm": "Unlink this company?",
    "unlinkConfirmHint": "The company will fall back to module defaults.",
    "linkReplaceWarning": "Linking \"{{preset}}\" will replace any existing {{module}} preset for the selected company.",
    "selectCompany": "Select a company",
    "companyRequired": "Please select a company",
    "linkSuccess": "Company linked to preset",
    "linkError": "Failed to link company",
    "unlinkSuccess": "Company unlinked from preset",
    "unlinkError": "Failed to unlink company",
    "presetNotFound": "Preset not found",
    "fields": {
      "name": "Name",
      "slug": "Slug",
      "module": "Module",
      "linkedCompanies": "Linked companies",
      "legacyCompanyId": "Legacy company ID",
      "status": "Status",
      "description": "Description",
      "company": "Company",
      "updatedAt": "Updated at"
    },
    "modules": {
      "all": "All modules",
      "activities": "Activities",
      "orders": "Orders",
      "pos": "POS"
    }
  },
  "fileManager": {
    "title": "File Manager",
    "cloudStorage": "Cloudflare R2",
    "dragDropText": "Drag & drop files here, or click to select files",
    "dropFiles": "Drop files here...",
    "supportedFormats": "Supports: Images, Documents, PDFs, Archives (Max: 100MB per file)",
    "uploading": "Uploading...",
    "uploadingFiles": "Uploading Files",
    "uploadedFiles": "Cloud Storage Files",
    "noFiles": "No files in cloud storage yet",
    "noSearchResults": "No files found matching your search",
    "cloudStored": "Cloud",
    "loading": "Loading files from cloud storage...",
    "loadError": "Failed to load files from cloud storage",
    "uploadSuccess": "uploaded successfully",
    "uploadError": "Failed to upload",
    "firebasePermissionError": "Upload failed: Cloudflare R2 permissions are not configured. Please contact your administrator.",
    "permissionDenied": "Upload failed: Permission denied. Please check your storage permissions.",
    "downloadSuccess": "File download started",
    "downloadError": "Failed to download file",
    "selectMode": "Select files",
    "exitSelection": "Exit selection",
    "selectAll": "Select all",
    "selectedCount": "{{count}} selected",
    "clearSelection": "Clear selection",
    "downloadSelected": "Download selected ({{count}})",
    "downloadFolder": "Download folder as ZIP",
    "archiveDownloadStarted": "Archive download started",
    "archiveDownloadError": "Failed to download the selected files",
    "folderDownloadError": "Failed to download this folder",
    "deleteConfirm": "Are you sure you want to delete this file?",
    "deleteWarning": "This action cannot be undone. The file will be permanently deleted from cloud storage.",
    "deleteSuccess": "File deleted successfully",
    "deleteError": "Failed to delete file",
    "textPreview": "Text file preview not available. Please download to view content.",
    "previewNotSupported": "Preview not supported for this file type",
    "searchPlaceholder": "Search files by name, type, or path...",
    "tipsTitle": "File Manager Tips",
    "folderSelectionTitle": "📁 Folder Selection:",
    "folderSelectionTip1": "Hold Ctrl/Cmd + click any folder to select it as upload target",
    "folderSelectionTip2": "Regular click expands/collapses folders",
    "folderSelectionTip3": "Selected folder will be highlighted in blue",
    "folderSelectionTip4": "Files will upload to the selected folder",
    "folderUploadTitle": "🗂️ Folder Upload:",
    "folderUploadTip1": "Click \"Upload Folder\" button to upload entire folders",
    "folderUploadTip2": "Maintains the original folder structure",
    "folderUploadTip3": "All sub-folders and files will be preserved",
    "smartUploadTitle": "🎯 Smart Upload:",
    "smartUploadTip1": "Without folder selection: Files auto-categorize by type",
    "smartUploadTip2": "With folder selection: Files go to selected folder",
    "smartUploadTip3": "Drag directly onto folders in tree view",
    "catalogFoldersTitle": "🖼️ Catalog Image Folders:",
    "catalogFoldersNote": "To use images in the catalog, the folder name must exactly match one of:",
    "catalogFoldersDetail": "Use these exact lowercase names. Plural forms or other variations (e.g. \"products\") will not link, and images will appear broken in the catalog.",
    "tips": "Tips",
    "treeView": "Tree View",
    "listView": "List View",
    "clearSearch": "Clear search",
    "uploadFilesTitle": "📁 Upload Files & Folders",
    "selectFiles": "Select Files",
    "uploadFolder": "Upload Folder",
    "uploadTo": "Upload to:",
    "clear": "Clear",
    "clickToExpand": "Click to expand/collapse, Ctrl+Click to select as upload target",
    "selectedFolder": "📁 Selected folder: \"{folderPath}\" for uploads",
    "selectedVirtualFolder": "✨ Selected virtual folder: \"{folderPath}\" for uploads. This folder will become permanent when you upload files to it.",
    "imageTag": "📷 Image",
    "company": "Company:",
    "user": "User",
    "uploadTargetReset": "Upload target reset to auto-categorize",
    "switchedToCompany": "Switched to company {companyId} (manual override)",
    "switchBackToUser": "↻ Use {companyId}",
    "switchedBackToUser": "Switched back to user company {companyId}",
    "filesText": "files",
    "of": "of",
    "connectionActive": "Cloudflare R2 connection active!",
    "bucketAccessRestricted": "R2 storage access restricted. Using demo mode.",
    "gcsNotAccessible": "R2 not accessible ({{status}}). Using demo mode.",
    "gcsNotAvailable": "R2 not available. Using demo mode with localStorage.",
    "refresh": "Refresh",
    "noCompanyId": "No company ID found. Please set a company ID to use the file manager.",
    "createFolder": "Create Folder",
    "folderNameRequired": "Folder name is required",
    "folderCreated": "Folder created successfully",
    "folderCreateError": "Failed to create folder",
    "parentFolder": "Parent Folder",
    "rootFolder": "Root",
    "folderNamePlaceholder": "Enter folder name...",
    "rename": "Rename",
    "file": "File",
    "folder": "Folder",
    "nameRequired": "Name is required",
    "renameSuccess": "Renamed successfully",
    "renameError": "Failed to rename",
    "currentName": "Current Name",
    "newNamePlaceholder": "Enter new name...",
    "deleteFolderConfirm": "Are you sure you want to delete this folder?",
    "deleteFolderWarning": "This action cannot be undone. The folder and all its contents will be permanently deleted from cloud storage.",
    "uploadBatchSummary": "{{uploaded}} files uploaded successfully. {{failed}} failed.",
    "uploadBatchFailure": "{{failed}} files failed to upload. First error: {{message}}",
    "uploadSessionFailed": "Upload session failed before completion. Please retry.",
    "uploadQueueSummary": "{{active}} active, {{failed}} failed, {{total}} total",
    "uploadQueueMore": "+{{count}} more files in queue"
  },
  "attribute": {
    "title": "Product Attributes",
    "englishName": "English Name",
    "arabicName": "Arabic Name",
    "status": "Status",
    "type": "Type",
    "write": "Write...",
    "active": "Active",
    "inactive": "Inactive",
    "edit": "Edit Attribute",
    "add": "New Attribute",
    "noCreatePermission": "You don't have permission to create product attributes",
    "searchPlaceholder": "Search by name or ID",
    "createOptions": {
      "title": "Add New Product Attribute",
      "subtitle": "Add your product attributes easily in simple steps",
      "description": "You can add attributes one by one or upload multiple attributes using an Excel file",
      "typeHint": "Type column: {{mapping}}",
      "uploadGroup": {
        "title": "Upload Group Of Attributes",
        "description": "Upload All Attributes Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Attribute",
        "description": "Easily Add One Attribute One By One"
      },
      "downloadSample": "Download Sample File"
    },
    "importSuccess": "Attributes imported successfully!",
    "importError": "Failed to import attributes. Please try again.",
    "savedSuccessfully": "Product Attribute Saved Successfully",
    "failedSave": "Failed to save the product attribute",
    "updatedSuccessfully": "Product Attribute Updated Successfully",
    "failedUpdate": "Failed to update the product attribute",
    "required": "This Field is required",
    "id": "ID"
  },
  "attributeTypeOptions": {
    "colorSelect": "Color Select",
    "select": "Select",
    "text": "Text",
    "number": "Number",
    "date": "Date"
  },
  "callChannel": {
    "noCreatePermission": "You don't have permission to create call channels",
    "noEditPermission": "You don't have permission to edit call channels",
    "noDeletePermission": "You don't have permission to delete call channels",
    "savedSuccessfully": "Call Channel Saved Successfully",
    "failedSave": "Failed to save the channel",
    "editCallChannel": "Edit Call Channel",
    "addCallChannel": "Add Call Channel",
    "arabicName": "Arabic Name",
    "englishName": "English Name",
    "tableTitle": "Call Channels",
    "id": "ID",
    "actions": "Actions",
    "activation": "Activation",
    "callChannel": "Call Channel"
  },
  "apiKeys": {
    "tableTitle": "API Keys",
    "addApiKey": "Add API Key",
    "editApiKey": "Edit API Key",
    "id": "ID",
    "name": "Name",
    "selectName": "Select key type",
    "value": "Value",
    "actions": "Actions",
    "activation": "Activation",
    "confirmDelete": "Delete this API key?",
    "savedSuccessfully": "API Key Saved Successfully",
    "deletedSuccessfully": "API Key Deleted Successfully",
    "failedSave": "Failed to save the API key",
    "failedDelete": "Failed to delete the API key"
  },
  "orderStatus": {
    "noCreatePermission": "You don't have permission to create order status",
    "noEditPermission": "You don't have permission to edit order status",
    "noDeletePermission": "You don't have permission to delete order status",
    "orderStatus": "Order Status",
    "arabicName": "Arabic Name",
    "englishName": "English Name",
    "OrderType": "Order Type",
    "StatusGroup": "Status Group",
    "Sort": "Sort",
    "Status": "Status",
    "Background": "Background",
    "Delivery": "Delivery",
    "Pickup": "Pickup",
    "Both": "Both",
    "tableTitle": "Order Statuses",
    "id": "ID",
    "actions": "Actions",
    "activation": "Activation",
    "savedSuccessfully": "Order status saved successfully",
    "failedSave": "Failed to save order status",
    "OrderStarted": "Order Started",
    "SendToCollector": "Send To Collector",
    "SendToDriver": "Send To Driver",
    "OrderFinished": "Order Finished",
    "OrderCanceled": "Order Canceled",
    "CanCancel": "Can Cancel",
    "CanEdit": "Can Edit",
    "CanReorder": "Can Reorder",
    "CanReturn": "Can Return",
    "CanRefund": "Can Refund",
    "WithDriver": "With Driver",
    "WithCollector": "With Collector",
    "OrderModified": "Order Modified"
  },
  "loyaltySettings": {
    "hasLoyalty": "Has Loyalty",
    "loyaltyFrom": "Loyalty From",
    "cashToPoint": "Cash to Point",
    "pointToCash": "Point to Cash",
    "expiredAfter": "Expired After (Days)",
    "expireNotificationTime": "Expire notification Time",
    "expireNotificationTimeInfo": "Send notification to customer before points expire (time in days).",
    "expireNotificationTimePlaceholder": "e.g. 3",
    "days": "days",
    "usePercentage": "Use Percentage",
    "savedSuccessfully": "Loyalty Settings Saved Successfully",
    "failedSave": "Failed to save the loyalty settings",
    "notificationApiPending": "Notification API integration will be added later.",
    "notificationTitle": "Notification Title (EN / AR)",
    "notificationsTitle": "Loyalty Notifications",
    "notificationsSubTitle": "Manage and schedule bilingual customer alerts.",
    "createNotification": "Create Notification",
    "generalDetails": "General Details",
    "titleEnglish": "Title (English)",
    "titleEnglishPlaceholder": "Enter title in English",
    "titleArabic": "Title (Arabic)",
    "titleArabicPlaceholder": "Enter title in Arabic",
    "bodyEnglish": "Body Message (English)",
    "bodyEnglishPlaceholder": "Craft your message...",
    "bodyArabic": "Body Message (Arabic)",
    "bodyArabicPlaceholder": "Write your message...",
    "notificationBanner": "Notification Banner",
    "bannerHint": "Click or drag image to upload (1200x600px recommended)",
    "saveNotification": "Save Notification",
    "activeNotifications": "Active Notifications",
    "sendVia": "Send Via",
    "sendViaNotification": "Notification",
    "sendViaSms": "SMS",
    "sendViaBoth": "Notification & SMS",
    "orderTotal": "Order Total",
    "productPoints": "Product Points"
  },
  "store": {
    "AddStore": "Add Store",
    "EditStore": "Edit Store",
    "DeleteStore": "Delete Store",
    "StoreList": "Store List",
    "StoreDetails": "Store Details",
    "StoreName": "Store Name",
    "StoreDescription": "Store Description",
    "StoreImage": "Store Image",
    "status": "Status",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "savedSuccessfully": "Store saved successfully",
    "updatedSuccessfully": "Store updated successfully",
    "deletedSuccessfully": "Store deleted successfully",
    "failedSave": "Failed to save store",
    "failedUpdate": "Failed to update store",
    "failedDelete": "Failed to delete store",
    "confirmDelete": "Are you sure you want to delete this store?",
    "noStoresFound": "No stores found",
    "StoreContent": "Store Content",
    "phone": "Phone",
    "phone2": "Alternate Phone",
    "storePhoneForShopper": "Store Phone for Shopper",
    "emails": "Emails",
    "sendEmail": "Send Email",
    "reportMail": "Report Email",
    "activityEmails": "Activity Emails",
    "activity_cc_emails": "Activity CC Emails",
    "inquiry_emails": "Inquiry Emails",
    "inquiry_cc_emails": "Inquiry CC Emails",
    "compliant_emails": "Complaint Emails",
    "compliant_cc_emails": "Complaint CC Emails",
    "MainData": "Main Data",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "IsMainStore": "Is this the main store?",
    "storeType": "Store Type",
    "Branch": "Branch",
    "slugEn": "Slug (English)",
    "slugAr": "Slug (Arabic)",
    "internalId": "Internal ID",
    "odooDeliveryFeesId": "Odoo Delivery Fees ID",
    "url": "URL",
    "enLogo": "English Logo",
    "arLogo": "Arabic Logo",
    "enImage": "English Image",
    "arImage": "Arabic Image",
    "DeliveryLocation": "Delivery Location",
    "areaStock": "Area Stock",
    "mapColor": "Map Color",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "kilometer": "Kilometer",
    "feesByKilo": "Fees By Kilo",
    "shippingFees": "Shipping Fees",
    "fixedPrice": "Fixed Price",
    "deliveryFeesPricingOption": "Delivery fees pricing option",
    "fixedFeesAfterXKilo": "Fixed fees after X kilo",
    "Pharmacy": "Pharmacy",
    "Grocery": "Grocery",
    "select_working_days": "Select Working Days & Times For Pickup",
    "select_all_days": "Select All Days",
    "select_all_times": "Select All Times",
    "deliveryType": "delivery Type",
    "PickUp": "PickUp",
    "Delivery": "Delivery",
    "Both": "Both",
    "sat": "Saturday",
    "sun": "Sunday",
    "mon": "Monday",
    "tue": "Tuesday",
    "wed": "Wednesday",
    "thu": "Thursday",
    "fri": "Friday",
    "From": "From",
    "To": "To",
    "AM": "AM",
    "PM": "PM",
    "fixedPriceOption": "Fixed Price Option",
    "Fixed fees after X kilo": "Fixed fees after X kilo",
    "noCreatePermission": "You don't have permission to create stores",
    "noEditPermission": "You don't have permission to edit stores",
    "noDeletePermission": "You don't have permission to delete stores",
    "collectorTime": "Collector Time",
    "collectorTimeNote": "time of collecting order"
  },
  "TableEditDelete": {
    "msgDeleteSuccess": "Deleted Successfully",
    "msgDeleteFailed": "failed to delete",
    "msgRestoreSuccess": "resotred Successfully",
    "msgRestoreFailed": "failed to restore",
    "edit": "Edit",
    "delete": "Delete",
    "restore": "Restore",
    "deleteConfirm": "Are you sure you want to delete?",
    "resotreConfirm": "Are you sure you want to restore?",
    "ok": "Yes",
    "no": "No",
    "noPermission": "You don't have permission to perform this action",
    "noEditPermission": "You don't have permission to edit",
    "noDeletePermission": "You don't have permission to delete"
  },
  "bulkActions": {
    "selectedCount": "{{count}} selected",
    "clearSelection": "Clear selection",
    "deleteSelected": "Delete Selected",
    "deleteConfirm": "Are you sure you want to delete {{count}} selected items?",
    "deleteSuccess": "Selected items deleted successfully",
    "deletePartial": "Deleted {{deleted}} items, {{failed}} could not be deleted",
    "deleteFailed": "Failed to delete selected items",
    "categoryLinkedWarning": "{{count}} of the selected categories still have sub-categories or products linked to them."
  },
  "activityTypes": {
    "tableTitle": "All Types",
    "addActivityTypes": "Create New Type",
    "editActivityTypes": "Edit  Type",
    "failedSave": "Failed to save the activity type",
    "savedSuccessfully": "Activity Types Saved Successfully",
    "fields": {
      "forProduct": "For Product",
      "main_type": "Main Type",
      "cc": "CC"
    },
    "noCreatePermission": "You don't have permission to create activity types"
  },
  "activityPriority": {
    "tab": "Priorities & Closing Time",
    "tableTitle": "Ticket Priorities",
    "add": "Create New Priority",
    "edit": "Edit Priority",
    "savedSuccessfully": "Priority saved successfully",
    "failedSave": "Failed to save the priority",
    "noCreatePermission": "You don't have permission to create priorities",
    "fields": {
      "name": "Priority",
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "slaHours": "Closing Time (hours)",
      "slaDays": "≈ {{days}} day(s)",
      "warningPercent": "Warn at (% of closing time)",
      "warningPercentHint": "The team is alerted once this share of the closing time has passed and the ticket is still open.",
      "isDefault": "Default for new tickets",
      "isDefaultHint": "Tickets created without a priority get this one, and its closing time starts right away.",
      "notifyUsers": "Notify users",
      "notifyUsersHint": "Alerted on top of the ticket's agent when the ticket is at risk or past its closing time.",
      "color": "Priority Color",
      "sort": "Sort",
      "ticketHint": "Optional. Picking a priority fills in its closing time.",
      "changeHint": "Changing the priority keeps the original start time; only the closing time is recalculated.",
      "noClosingTimeHint": "0 = tickets never close: no warning and no automatic closing.",
      "ticketSlaHours": "Closing Time (hours)",
      "ticketSlaHoursHint": "Optional, with or without a priority. Picking a priority fills it in; you can change it. 0 = the ticket never closes.",
      "ticketSlaHoursEditHint": "Changing it recalculates the deadline and the warning from the original start time. 0 = the ticket never closes."
    },
    "sla": {
      "title": "Closing Time",
      "on_track": "On track",
      "at_risk": "At risk",
      "breached": "Overdue",
      "met": "Closed on time",
      "missed": "Closed late",
      "none": "No priority",
      "left": "{{time}} left",
      "overdueBy": "{{time}} late",
      "dueAt": "Closing time",
      "closedAt": "Closed at",
      "no_limit": "No closing time",
      "auto_closed": "Closed automatically"
    }
  },
  "activityStatus": {
    "noColor": "No color",
    "Types": "Types",
    "Sections": "Sections",
    "Reasons": "Reasons",
    "Status": "Status",
    "editActivityStatus": "Edit Activity Status",
    "addActivityStatus": " Add Activity Status ",
    "savedSuccessfully": "Activity Status Saved Successfully",
    "failedSave": "FailedS TO Save Activity Status",
    "status": {
      "tableTitle": "All Activities Status"
    },
    "fields": {
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "sendMail": "Send Mail",
      "email": "Email",
      "type": "Type",
      "status": "Status",
      "actions": "Actions",
      "isOpening": "Is Opening",
      "isClosed": "Is Closed",
      "color": "Status Color"
    },
    "types": {
      "activity": "Activity",
      "inquiry": "Inquiry",
      "complaint": "Complaint"
    },
    "noCreatePermission": "You don't have permission to create activity status"
  },
  "paymentSetting": {
    "visaOnline": "Visa Online",
    "visaOnDelivery": "visa On Delivery",
    "cashOnDelivery": "cash On Delivery",
    "title1": "Check Out",
    "title2": "Check Out Insurance"
  },
  "invoiceLinkSettings": {
    "title": "Invoice Link Settings",
    "provider": "Provider",
    "invoiceBaseUrl": "Invoice Base URL",
    "enabled": "Enabled",
    "preview": "Preview",
    "configured": "Configured",
    "notConfigured": "Invoice link is not configured yet. Fill in the form below to enable invoice links.",
    "notFullyConfigured": "Not fully configured",
    "savedSuccessfully": "Invoice link settings saved",
    "failedSave": "Failed to save invoice link settings",
    "deletedSuccessfully": "Invoice link settings deleted",
    "deleteFailed": "Failed to delete settings",
    "deleteConfirm": "Delete invoice link settings?",
    "statusUpdated": "Invoice link status updated",
    "statusUpdateFailed": "Failed to update status",
    "urlTrailingSlashWarning": "Base URL should end with /",
    "providerRequired": "Provider is required",
    "providerMaxLength": "Provider must be at most 100 characters",
    "baseUrlRequired": "Invoice base URL is required",
    "baseUrlInvalid": "Enter a valid URL"
  },
  "smsTemplates": {
    "pageTitle": "SMS Templates",
    "subtitle": "Configure the SMS sent to customers after they place an order",
    "infoBanner": "When active, this SMS is sent to the customer once their order is placed. Leave a language blank to skip it.",
    "orderThankYou": "Order Thank-You SMS",
    "orderThankYouSub": "Sent automatically after an order is created.",
    "savedSuccessfully": "SMS template saved successfully",
    "failedSave": "Failed to save SMS template",
    "fields": {
      "content_en": "Message (English)",
      "content_ar": "Message (Arabic)"
    },
    "placeholders": {
      "content_en": "Thanks for your order",
      "content_ar": "شكراً لطلبك"
    },
    "buttons": {
      "save": "Save Template",
      "back": "Back to Settings"
    }
  },
  "emailSettings": {
    "pageTitle": "Email Settings",
    "subtitle": "Configure your company's SMTP settings for ticket emails",
    "infoBanner": "Note: When configured, all ticket-related emails will be sent using your company's SMTP server and email address instead of the default Awfar email.",
    "smtpSection": "SMTP Configuration",
    "senderSection": "Sender Details",
    "advancedSection": "Advanced Settings",
    "ticketNotificationSection": "Ticket Email Notification Mode",
    "ticketNotificationDescription": "Choose when ticket-related emails should be sent to customers. You can send emails on every ticket update, or only when a ticket is closed.",
    "ticketFieldSection": "Ticket Email Field Configuration",
    "ticketFieldBanner": "Note: Configure which fields are included in ticket emails. Ticket ID is always included and cannot be disabled. If all fields are disabled, emails will contain only Ticket ID and system signature.",
    "fields": {
      "smtp_host": "SMTP Host",
      "smtp_port": "SMTP Port",
      "smtp_username": "SMTP Username",
      "smtp_password": "SMTP Password",
      "smtp_encryption": "Encryption",
      "from_email": "From Email Address",
      "from_name": "From Name",
      "reply_to": "Reply-To Email",
      "is_enabled": "Enabled",
      "use_fallback": "Use Fallback",
      "ticket_email_mode": "Ticket Email Mode",
      "include_customer_name": "Include Customer Name",
      "include_phone": "Include Customer Phone",
      "include_order_id": "Include Order ID",
      "include_ticket_description": "Include Ticket Description",
      "include_ticket_status": "Include Ticket Status",
      "include_assigned_agent": "Include Assigned Agent",
      "include_additional_fields": "Include Additional Fields"
    },
    "placeholders": {
      "smtp_host": "smtp-host.example.com",
      "smtp_port": "587",
      "smtp_username": "Enter SMTP username",
      "smtp_password": "Leave blank to keep current password",
      "from_email": "from-email@example.com",
      "from_name": "Your Company Name",
      "reply_to": "support@example.com"
    },
    "hints": {
      "smtp_host": "Your SMTP server hostname",
      "smtp_port": "Common ports: 587 (TLS), 465 (SSL), 25",
      "smtp_encryption": "TLS is recommended for port 587, SSL for port 465",
      "from_email": "This will appear as the sender email",
      "from_name": "Display name for the sender",
      "reply_to": "Optional: Where replies should be sent"
    },
    "encryptionOptions": {
      "tls": "TLS",
      "ssl": "SSL",
      "none": "None"
    },
    "companyEmailCard": {
      "title": "Company Email Settings",
      "description": "When enabled, all ticket-related emails will be sent using your company's SMTP configuration. When disabled, the system will use the default Awfar email settings."
    },
    "fallbackCard": {
      "title": "Fallback Protection",
      "description": "When enabled, if your SMTP fails to send an email, the system will automatically fallback to the default Awfar mailer to ensure email delivery."
    },
    "ticketModeOptions": {
      "on_update": "Send email on every ticket update",
      "on_update_sub": "Customers will receive an email notification whenever the ticket status is updated.",
      "on_close": "Send email only when ticket is closed",
      "on_close_sub": "Customers will receive an email notification only when the ticket status is changed to closed."
    },
    "fieldCards": {
      "customerInfo": "Customer Information",
      "orderInfo": "Order Information",
      "ticketContent": "Ticket Content",
      "additionalFields": "Additional Fields",
      "additionalFieldsSub": "Include custom fields like Priority, Category, Notes, etc. (if available)"
    },
    "buttons": {
      "save": "Save Configuration",
      "testEmail": "Test Email",
      "back": "Back to Settings"
    },
    "testEmailModal": {
      "title": "Send Test Email",
      "label": "Test Email Address",
      "placeholder": "Enter email address to send test",
      "send": "Send Test Email",
      "cancel": "Cancel"
    },
    "savedSuccessfully": "Email settings saved successfully",
    "failedSave": "Failed to save email settings",
    "testEmailSuccess": "Test email sent successfully",
    "testEmailFailed": "Failed to send test email",
    "fetchFailed": "Failed to load email settings",
    "validation": {
      "smtpHostRequired": "SMTP Host is required",
      "smtpPortRequired": "SMTP Port is required",
      "smtpPortInvalid": "SMTP Port must be a valid number",
      "encryptionRequired": "Encryption type is required",
      "fromEmailRequired": "From Email is required",
      "fromEmailInvalid": "Please enter a valid email address",
      "replyToInvalid": "Please enter a valid email address",
      "testEmailRequired": "Test email address is required",
      "testEmailInvalid": "Please enter a valid email address"
    }
  },
  "pushNotifications": {
    "pageTitle": "Push Notifications",
    "addNew": "Add New",
    "tableTitle": "All Notifications",
    "columns": {
      "id": "ID",
      "tags": "Tags",
      "title": "Notification Title",
      "successCount": "Success Count",
      "invalidCount": "Invalid Count",
      "unknownCount": "Unknown Count",
      "totalCount": "Total Count",
      "actions": "Actions"
    },
    "sendModal": {
      "title": "Send Notification",
      "sendType": "Send Type",
      "notificationTitle": "Notification Title",
      "notificationTitlePlaceholder": "Notification Title",
      "body": "Body",
      "bodyPlaceholder": "Jot something down...",
      "image": "Image",
      "chooseFile": "Choose File",
      "authType": "Auth Type",
      "authTypePlaceholder": "Select Auth type",
      "gender": "Gender",
      "genderPlaceholder": "Select Gender",
      "offerType": "Offer Type",
      "selectItem": "Select Item",
      "send": "Send",
      "cancel": "Cancel"
    },
    "genderOptions": {
      "male": "Male",
      "female": "Female"
    },
    "authTypeOptions": {
      "verified": "Verified",
      "unverified": "Unverified",
      "all": "All"
    },
    "offerTypeOptions": {
      "product": "Product",
      "brand": "Brand",
      "category": "Category",
      "offer": "Offers",
      "favorite": "Favorite",
      "insurance": "Insurance",
      "prescription": "Prescription"
    },
    "actions": {
      "view": "View",
      "resend": "Resend",
      "delete": "Delete"
    },
    "confirmDelete": "Are you sure you want to delete this notification?",
    "confirmResend": "Are you sure you want to resend this notification?",
    "sentSuccessfully": "Notification sent successfully",
    "sendFailed": "Failed to send notification",
    "deletedSuccessfully": "Notification deleted successfully",
    "deleteFailed": "Failed to delete notification",
    "resentSuccessfully": "Notification resent successfully",
    "resendFailed": "Failed to resend notification",
    "fetchFailed": "Failed to load notifications",
    "validation": {
      "titleRequired": "Notification title is required",
      "bodyRequired": "Body is required",
      "offerItemRequired": "Please select an item"
    }
  },
  "organization": {
    "tableTitle": "All Organizations",
    "noCreatePermission": "You don't have permission to create organizations",
    "noEditPermission": "You don't have permission to edit organizations",
    "noDeletePermission": "You don't have permission to delete organizations",
    "savedSuccessfully": "Organization Saved Successfully",
    "failedSave": "Failed to save the organization",
    "editOrganization": "Edit Organization",
    "addOrganization": "Add Organization",
    "columns": {
      "id": "ID",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "status": "Status",
      "actions": "Actions"
    },
    "fields": {
      "name_ar": "Arabic Name",
      "name_en": "English Name",
      "description_ar": "Description (Arabic)",
      "description_en": "Description (English)",
      "status": "Status",
      "sort": "Sort"
    },
    "placeholders": {
      "name_ar": "Enter name in Arabic...",
      "name_en": "Enter name in English...",
      "description_ar": "Enter description in Arabic...",
      "description_en": "Enter description in English...",
      "sort": "Enter sort order..."
    },
    "activation": "Activation",
    "validation": {
      "nameArRequired": "Arabic name is required",
      "nameEnRequired": "English name is required",
      "descriptionArRequired": "Arabic description is required",
      "descriptionEnRequired": "English description is required"
    }
  },
  "deliveryTime": {
    "noCreatePermission": "You don't have permission to create delivery time",
    "noEditPermission": "You don't have permission to edit delivery time",
    "noDeletePermission": "You don't have permission to delete delivery time",
    "tableTitle": "Delivery Time",
    "from": "From",
    "to": "To",
    "title": "Title",
    "fees": "Fees",
    "closeTime": "Close Time",
    "capacity": "Capacity",
    "actions": "Actions",
    "activation": "Activation",
    "savedSuccessfully": "Delivery time saved successfully",
    "failedSave": "Failed to save delivery time",
    "titlePlaceholder": "Enter delivery time title...",
    "feesPlaceholder": "Enter delivery fees...",
    "closeTimePlaceholder": "Enter close time in minutes...",
    "capacityPlaceholder": "Enter maximum capacity...",
    "timeFormat": "h:mm a"
  },
  "stores": {
    "tableTitle": "Stores",
    "name": "Name",
    "activation": "Activation",
    "actions": "Actions",
    "editStoreAreasFees": "Edit Store Areas Fees",
    "deleteStore": "Delete Store",
    "deleteConfirmTitle": "Delete this store?",
    "deleteConfirmContent": "The store will be removed from the stores list and deactivated. Its orders and reports are kept.",
    "deletedSuccessfully": "Store deleted successfully",
    "deleteFailed": "Failed to delete the store",
    "deleted": "Deleted",
    "restoreStore": "Restore Store",
    "restore": "Restore",
    "restoreConfirmTitle": "Restore this store?",
    "restoreConfirmContent": "The store comes back inactive and counts toward the company's store limit again.",
    "restoredSuccessfully": "Store restored successfully",
    "restoreFailed": "Failed to restore the store",
    "mainCannotDelete": "The main store cannot be deleted",
    "onlyStoreCannotDelete": "The company's only store cannot be deleted",
    "hasBranchesCannotDelete": "Other stores use this store as their main store, so it cannot be deleted",
    "outboundDeliveryFeesId": "Outbound Fees ID",
    "outboundDeliveryFeesIdInfo": "Odoo product ID used as the delivery fee line for this region. Leave empty to clear the mapping.",
    "editStoreAreas": "Edit Store Areas",
    "editStoreSetting": "Edit Store Settings",
    "editStoreDelivery": "Edit Store Delivery Times",
    "setStoreDeliveryLocation": "Set Store Delivery Location",
    "deliveryZones": "Delivery Zones",
    "addZone": "Add Zone",
    "newZone": "New Delivery Zone",
    "editZone": "Edit Delivery Zone",
    "noZones": "No delivery zones yet",
    "zoneSaved": "Delivery zone saved successfully",
    "zoneDeleted": "Delivery zone deleted successfully",
    "zoneSaveFailed": "Failed to save the delivery zone",
    "zoneDeleteFailed": "Failed to delete the delivery zone",
    "zoneLoadFailed": "Failed to load the delivery zone",
    "zonesLoadFailed": "Failed to load delivery zones",
    "timeSlotsLoadFailed": "Failed to load delivery times",
    "deleteZoneConfirm": "Delete this delivery zone?",
    "drawShapeRequired": "Draw a shape on the map first",
    "drawShapeHint": "Use the toolbar to draw the delivery zone",
    "feeTiers": "Delivery Fees",
    "addFeeTier": "Add Fee Tier",
    "kmRange": "KM Range",
    "deliveryFees": "Delivery Fees",
    "additionalFees": "Additional Fees",
    "shape": {
      "circle": "Circle",
      "polygon": "Polygon",
      "rectangle": "Rectangle",
      "marker": "Marker",
      "polyline": "Polyline"
    },
    "StoreDelivery": "Store Delivery Times",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "AllStores": "All Stores",
    "fees": "Fees",
    "areasUpdatedSuccessfully": "Store areas updated successfully",
    "areasUpdateFailed": "Failed to update store areas",
    "noCreatePermission": "You don't have permission to create stores",
    "noEditPermission": "You don't have permission to edit stores",
    "noDeletePermission": "You don't have permission to delete stores",
    "deliveryTimes": "Delivery Times",
    "selectTimesForDelivery": "Select Times For Delivery"
  },
  "companySettings": {
    "nameEN": "Name (English)",
    "currencyEn": "Currency (English)",
    "phone": "Phone",
    "url": "URL",
    "nameAr": "Name (Arabic)",
    "currencyAr": "Currency (Arabic)",
    "whatsappNumber": "WhatsApp Number",
    "sallaId": "Salla ID",
    "Email": "Email",
    "ReportMail": "Report Mail",
    "shareMessageAr": "Share Message (Arabic)",
    "shareMessageEr": "Share Message (English)",
    "descriptionAr": "Description Arabic",
    "descriptionEn": "Description English",
    "Company Information": "Company Information",
    "Main Setting": "Main Setting",
    "arLogo": "Company Logo (Arabic)",
    "enLogo": "Company Logo (English)",
    "favIcon": "Favicon",
    "notificationSound": "Notification Sound",
    "Company Setting": "Company Setting",
    "Call Chanel": "Call Channel",
    "Order Status": "Order Status",
    "Delivery Times": "Delivery Times",
    "Stores": "Stores",
    "Delivery Management": "Delivery Management",
    "Loyalty Settings": "Loyalty Settings",
    "Loyalty Disabled": "Loyalty program is not enabled for your company",
    "Api Keys": "API Keys",
    "Payment Settings": "Payment Settings",
    "Customer Segmentation": "Customer Segmentation",
    "Notification Sounds": "Notification Sounds",
    "userLimit": "User Limit",
    "storeLimit": "Store Limit",
    "shopperUserLimit": "Shopper User Limit",
    "shopperUserLimitInfo": "Maximum number of Shopper users. Counted separately from the User Limit. 0 means no Shopper users can be added.",
    "expireDate": "Expire Date",
    "selectExpireDate": "Select expiration date",
    "loyalityNotifcationExpireTime": "Expire notification Time",
    "loyalityNotifcationExpireTimeInfo": "Send notification to customer before points expire (time in days).",
    "loyalityNotifcationExpireTimePlaceholder": "e.g. 3",
    "days": "days",
    "Status": "Status",
    "savedSuccessfully": "Company settings saved successfully",
    "createdSuccessfully": "Company created successfully",
    "failedSave": "Failed to save company settings",
    "setupRequired": {
      "title": "Dear Admin",
      "message": "You need to complete the settings before you can start using the system..",
      "cta": "Start Now"
    },
    "enableDelayedOrderNotification": "Enable Delayed Order Reminders",
    "delayedOrderNotificationDescription": "Automatically send push notification reminders to customers whose orders remain unprocessed after 15 and 30 days",
    "invalidLogoType": "Logo must be a file of type: jpeg, png, jpg, svg.",
    "Company Shipping fees": "Company Shipping Fees",
    "Prescription Doc": "Prescription Document",
    "Notional Id Doc": "National ID Document",
    "Company Id Doc": "Company ID Document",
    "Insurances Id Doc": "Insurance ID Document",
    "MainSetting": {
      "Docs": "Documents",
      "permissions": "Permissions",
      "assign product base on": "Assign Product Based On",
      "assign product base on ( API )": "Assign Product Based On ( API )",
      "assign product base on ( CRM )": "Assign Product Based On ( CRM )",
      "delivery fees base on": "Delivery Fees Based On",
      "CategoryType": "Category Type",
      "GlobalModels": "Models",
      "WithChat": "With Chat",
      "manual verification": "Manual Verification",
      "reportMail": "Report Mail",
      "BasicInfo": "Basic Information",
      "Links": "Links",
      "CompanyType": "Company Type",
      "StockDetails": "Stock Details",
      "Country": "Country",
      "DeliveryType": "Delivery Type",
      "StoreLocation": "Store Location",
      "showNotPaidOrders": "Show Unpaid Orders",
      "WithStore": "With Store",
      "MainStore": "Main Store",
      "HasMainStore": "Has Main Store",
      "CanOpenOrderFirstTime": "Allow Initial Order Opening",
      "changeStatusFrom": "Change Status From",
      "changeStatusTo": "Change Status To",
      "changeStatusFromRequired": "Status from is required",
      "changeStatusToRequired": "Status to is required",
      "fetchOrderStatus": "Fetch Order Status",
      "minimumOrderAmount": "Minimum Order Amount",
      "Ordering Days Limit": "Daily Order Limit",
      "minimumOrderAmountRequired": "Minimum order amount is required",
      "firstColor": "Primary Color",
      "secondColor": "Secondary Color",
      "StoreLocationSetting": "Store Location Setting",
      "MoreSetting": "More Settings",
      "Company Shipping fees": "Company Shipping Fees",
      "userShopper": "Use Shopper",
      "Assign Product base on": "Assign Product base on",
      "GetProductFromCrm": "Get Product From CRM",
      "GetProductFromApi": "Get Product From API",
      "price from": "Price from",
      "integration from": "Integration from",
      "Upload Magazine": "Upload Magazine",
      "Stop Transfer After Minutes": "Stop Transfer After (Minutes)",
      "Use Polygon Delivery": "Use Polygon Delivery",
      "Min Prescription Doc": "Minimum Prescription Document",
      "Max Prescription Doc": "Maximum Prescription Document",
      "Max Notional Id Doc": "Maximum National ID Document",
      "Min Notional Id Doc": "Minimum National ID Document",
      "Max Insurances Doc": "Maximum Insurances Document",
      "Min Insurances Doc": "Minimum Insurances Document",
      "Max Company Doc": "Maximum Company Document",
      "Min Company Doc": "Minimum Company Document",
      "Max Company Id Doc": "Maximum Company ID Document",
      "Min Company Id Doc": "Minimum Company ID Document",
      "Max Insurances Id Doc": "Maximum Insurance ID Document",
      "Min Insurances Id Doc": "Minimum Insurance ID Document",
      "Home Category Limit": "Home Category Limit",
      "stock_level_1": "Stock Level 1",
      "stock_level_2": "Stock Level 2",
      "stock_level_3": "Stock Level 3",
      "stockLevel1": "Stock Level 1 Color",
      "stockLevel2": "Stock Level 2 Color",
      "stockLevel3": "Stock Level 3 Color",
      "hide out of stock product": "Hide Out of Stock Products",
      "makeOrderOutOfStockCrm": "Allow orders for out-of-stock products (CRM)",
      "makeOrderOutOfStockCrmInfo": "When enabled, CRM agents can add and checkout products even when stock is zero.",
      "enableCartStockReservation": "Cart stock reservation",
      "enableCartStockReservationInfo": "When enabled, quantities already in other open carts are subtracted from the available stock. When disabled, only the customer's own cart counts against stock.",
      "StockFrom": "Stock From",
      "CompanyProductType": "Company Product Type",
      "Terms View is HTML": "Terms View is HTML",
      "Privacy View is HTML": "Privacy View is HTML",
      "About View is HTML": "About View is HTML",
      "domain": "Domain",
      "Share app link": "Share app link",
      "ios_app_link": "iOS App Link",
      "android_app_link": "Android App Link",
      "website_version": "Website Version",
      "companyTypes": {
        "retail": "Retail",
        "wholesale": "Wholesale",
        "ecommerce": "E-commerce"
      },
      "countries": {
        "sa": "Saudi Arabia",
        "ae": "United Arab Emirates",
        "eg": "Egypt"
      },
      "deliveryTypes": {
        "standard": "Standard Delivery",
        "express": "Express Delivery"
      },
      "CompanyTypeOptions": {
        "MAIN_STORE": "Main Store",
        "MARKETPLACE": "Market Place",
        "MULTI_STORE": "Multi Store",
        "BOX": "BOX",
        "LINE": "LINE",
        "default": "Default",
        "type": "Type",
        "market place": "Market Place"
      },
      "CountryOptions": {
        "Egypt": "Egypt",
        "Syria": "Syria",
        "SaudiArabia": "Saudi Arabia",
        "Iraq": "Iraq"
      },
      "DeliveryTypeOptions": {
        "Company": "Company",
        "Store": "Store",
        "DeliveryTimes": "Delivery Times",
        "Region": "Region",
        "FeesByDistance": "Fees By Distance"
      },
      "ProductTypeOptions": {
        "Grocery": "Grocery",
        "Pharmacy": "Pharmacy",
        "Both": "Both"
      },
      "StoreLocationSettingOptions": {
        "NearestStore": "Nearest Store",
        "MainStore": "Main Store"
      },
      "IntegrationFromOptions": {
        "Database": "Database",
        "File": "File",
        "Mongo": "Mongo"
      },
      "StockFromOptions": {
        "Offline": "Offline",
        "Inventory": "Inventory",
        "Integration": "Integration"
      },
      "ProductBaseOptions": {
        "Company": "Company",
        "Store": "Store"
      },
      "PriceFromTypeOptions": {
        "Offline": "Offline",
        "Integration": "Integration"
      },
      "FetchOrderStatusOptions": {
        "AllAvailableStatuses": "Select all available statuses",
        "NextComingStatusOnly": "Select only the next coming status (ONLY ONE)",
        "AllNextAvailableStatuses": "Select all the next available statuses"
      },
      "CompanyTypeInfo": "Company classification: Main Store, Marketplace, or Multi Store.",
      "DeliveryTypeInfo": "Where deliveries are fulfilled from: the Company, the Store, or scheduled Delivery Times.",
      "CompanyProductTypeInfo": "Catalog type: Grocery, Pharmacy, or Both. Pharmacy enables document requirements such as prescriptions.",
      "StoreLocationSettingInfo": "How a customer's store is selected: the Nearest Store by location, or always the Main Store.",
      "showNotPaidOrdersInfo": "Show orders that have not been paid yet in order lists.",
      "WithStoreInfo": "Enable if the company operates with multiple stores or branches.",
      "HasMainStoreInfo": "Enable if the company has a designated main store, then select it.",
      "MainStoreInfo": "Select the store that acts as the company's main store.",
      "CanOpenOrderFirstTimeInfo": "When enabled, the Change Status From and Change Status To options are displayed.\nWhen an agent opens an order, the order status will automatically change:\n• From the status selected in Change Status From\n• To the status selected in Change Status To.",
      "changeStatusFromInfo": "Status the order must be in when an agent opens it for the change to apply.",
      "changeStatusToInfo": "Status the order is moved to automatically when an agent opens it.",
      "fetchOrderStatusInfo": "Which statuses appear when changing an order: all available, only the next one, or all upcoming statuses.",
      "minimumOrderAmountInfo": "Smallest order total a customer must reach to check out.",
      "OrderingDaysLimitInfo": "Number of days used as the ordering window.",
      "GetProductFromCrmInfo": "Product catalog scope from the CRM: Company (all stores share one catalog) or Store (each store has its own products).",
      "GetProductFromApiInfo": "Pull products from an external API (e.g. Odoo): Company-level or Store-level.",
      "CompanyShippingFeesInfo": "Default shipping fee applied to orders.",
      "priceFromInfo": "Source of product prices: Offline (local database) or Integration (an external system such as Odoo).",
      "integrationFromInfo": "Where integration data is read from. Offline stock uses Database; Integration stock uses File or Mongo.",
      "integrationFromNotAllowed": "This option is not available for the selected Stock From.",
      "HomeCategoryLimitInfo": "Maximum number of categories shown on the homepage.",
      "StopTransferAfterInfo": "Stop transferring or assigning an order after this many minutes.",
      "UsePolygonDeliveryInfo": "When enabled, stores define their delivery area by drawing a polygon instead of using a distance radius.",
      "UsePolygonDeliveryConfirmTitle": "Change delivery area mode?",
      "UsePolygonDeliveryConfirmContent": "This changes how stores define their delivery area (polygon vs. distance radius). Are you sure you want to continue?",
      "StockFromInfo": "Source of stock quantities: Offline (local database), Inventory (manual), or Integration (an external system such as Odoo).",
      "stockLevelInfo": "Quantity threshold for this stock alert level; the color marks products at or below it.",
      "hideOutOfStockInfo": "Hide out-of-stock products from customers.",
      "TermsViewIsHTMLInfo": "When on, the Terms page content is rendered as HTML instead of plain text.",
      "PrivacyViewIsHTMLInfo": "When on, the Privacy page content is rendered as HTML instead of plain text.",
      "AboutViewIsHTMLInfo": "When on, the About page content is rendered as HTML instead of plain text.",
      "domainInfo": "Custom domain for the company storefront.",
      "websiteVersionInfo": "Version number of the website or app interface."
    },
    "sallaIdInfo": "Unique Salla integration ID used to link this company with Salla.",
    "ReportMailInfo": "Send periodic report emails to the company."
  },
  "companyDetails": {
    "title": "Show Company",
    "englishName": "English Name",
    "arabicName": "Arabic Name",
    "url": "URL",
    "phone": "Phone",
    "userLimit": "User Limit",
    "shopperUserLimit": "Shopper User Limit",
    "status": "Status",
    "email": "Email",
    "reportMail": "Report Mail",
    "expiredDate": "Expired Date"
  },
  "productReviews": {
    "tableTitle": "Product Reviews",
    "searchPlaceholder": "Search comment, customer or product",
    "approve": "Approve",
    "reject": "Reject",
    "approveSelected": "Approve selected",
    "rejectSelected": "Reject selected",
    "selected": "{{count}} selected",
    "approveSuccess": "Review approved",
    "rejectSuccess": "Review rejected",
    "actionError": "Something went wrong",
    "bulkPartial": "{{done}} approved, {{skipped}} flagged reviews skipped",
    "approveAnyway": "Approve anyway",
    "flaggedTitle": "Flagged content",
    "flaggedBody": "This review contains flagged words. Pharmacy content policy does not allow medical claims. Approve anyway?",
    "flaggedManyBody": "{{count}} selected reviews contain flagged words. Approve them anyway?",
    "rejectTitle": "Reject review",
    "rejectManyTitle": "Reject {{count}} reviews",
    "reason": "Reason",
    "reasonRequired": "Please choose a reason",
    "note": "Note",
    "noteRequired": "Please add a note",
    "noComment": "Rating only",
    "dateFrom": "From",
    "dateTo": "To",
    "columns": {
      "product": "Product",
      "productId": "Product ID",
      "customer": "Customer",
      "rating": "Rating",
      "comment": "Review",
      "order": "Order",
      "status": "Status",
      "createdAt": "Submitted"
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "flags": {
      "profanity": "Profanity",
      "medical_claim": "Medical claim"
    },
    "reasons": {
      "profanity": "Profanity / abusive language",
      "medical_claim": "Medical claim (pharmacy policy)",
      "irrelevant": "Not about the product",
      "spam": "Spam / advertising",
      "personal_info": "Contains personal information",
      "other": "Other"
    }
  },
  "reviewBannedWords": {
    "tableTitle": "Review Banned Words",
    "noCreatePermission": "You don't have permission to add words",
    "word": "Word / phrase",
    "type": "Type",
    "createdAt": "Created Date",
    "add": "Add Word",
    "edit": "Edit Word",
    "created": "Word added successfully",
    "updated": "Word updated successfully",
    "saveFailed": "Failed to save the word",
    "wordRequired": "Please enter a word"
  },
  "keywordsList": {
    "tableTitle": "All Keywords",
    "addKeyword": "Add Keyword",
    "editKeyword": "Edit Keyword",
    "exportKeywords": "Export Keywords",
    "exportSuccess": "Export completed successfully",
    "exportError": "Failed to export keywords. Please try again.",
    "importing": "Importing keywords...",
    "importSuccess": "Keywords imported successfully!",
    "importError": "Failed to import keywords. Please try again.",
    "fileTooLarge": "File is too large. Maximum size is 2MB.",
    "noCreatePermission": "You don't have permission to create keywords",
    "noImportPermission": "You don't have permission to import keywords",
    "createOptions": {
      "title": "Add New Keyword",
      "uploadGroup": {
        "title": "Upload Group Of Keywords",
        "description": "Upload All Keywords Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Keyword",
        "description": "Easily Add One Keyword One By One"
      },
      "downloadSample": "Download Sample Template"
    },
    "importInstructions": {
      "title": "Import Instructions",
      "nameRequired": "Keyword name is required",
      "statusOptional": "Status is optional (Active/Inactive)",
      "barcodesOptional": "Product barcodes are optional",
      "barcodesCommaSeparated": "Product barcodes should be comma-separated",
      "supportedFormats": "Supported formats"
    },
    "columns": {
      "name": "Keyword Name / Title",
      "status": "Status",
      "productsCount": "Products Count",
      "createdAt": "Created Date"
    },
    "fields": {
      "title": "Keyword Title (Optional)",
      "titlePlaceholder": "Enter group title for keywords",
      "titleHint": "Title to group multiple keywords together",
      "name": "Keyword Name",
      "namePlaceholder": "Enter keywords separated by commas",
      "nameHint": "Enter keywords separated by commas",
      "products": "Assign to Products (Optional)",
      "productsHint": "Search and select products to assign to this keyword",
      "barcodes": "Product Barcodes (Optional)",
      "barcodesPlaceholder": "Enter product barcodes separated by commas (example: 123,321,456,645)",
      "barcodesHint": "Barcodes are matched against this company's products"
    },
    "importCounts": {
      "created": "Created",
      "updated": "Updated",
      "deleted": "Deleted"
    },
    "messages": {
      "created": "Keyword created successfully",
      "updated": "Keyword updated successfully",
      "createFailed": "Failed to save the keyword",
      "updateFailed": "Failed to update the keyword",
      "unmatchedBarcodes": "Some barcodes matched no product: {{barcodes}}",
      "loadFailed": "Failed to load the keyword"
    }
  },
  "manufacturersList": {
    "importing": "Importing manufacturers...",
    "importSuccess": "Manufacturers imported successfully!",
    "importError": "Failed to import manufacturers. Please try again.",
    "noImportPermission": "You don't have permission to import manufacturers",
    "createOptions": {
      "title": "Add New Manufacturer",
      "uploadGroup": {
        "title": "Upload Group Of Manufacturers",
        "description": "Upload All Manufacturers Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Manufacturer",
        "description": "Easily Add Manufacturers One By One"
      },
      "downloadSample": "Download Sample File"
    },
    "tableTitle": "All manufacturers",
    "noCreatePermission": "You don't have permission to create manufacturers",
    "details": "Manufacturer Details",
    "savedSuccessfully": "Manufacturer saved successfully",
    "failedSave": "Failed to save the manufacturer",
    "nameRequired": "Name is required",
    "deleteConfirmDescription": "Products of deleted manufacturers become unassigned.",
    "columns": {
      "logo": "Logo",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "productsCount": "Products",
      "sort": "Sort Order",
      "status": "Status"
    }
  },
  "brandsList": {
    "createOptions": {
      "title": "Add New Brand",
      "subtitle": "Add your brands easily in simple steps",
      "description": "Build your brand catalog and manage your product brands efficiently.",
      "uploadGroup": {
        "title": "Upload Group Of Brands",
        "description": "Upload All Brands Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Brand",
        "description": "Easily Add One Brand One By One"
      },
      "downloadSample": "Download Sample File"
    },
    "noCreatePermission": "You don't have permission to create brands",
    "noImportPermission": "You don't have permission to import brands",
    "importSuccess": "Brands imported successfully!",
    "importError": "Failed to import brands. Please try again.",
    "tableTitle": "All brands",
    "columns": {
      "id": "Id",
      "nameEn": "Name En",
      "actions": "Actions",
      "BrandDetails": "Brand Details",
      "nameEN": "Name (English)",
      "nameAr": "Name (Arabic)",
      "content_en": "Content (English)",
      "content_ar": "Content (Arabic)",
      "logo": "Logo",
      "sort": "Sort Order",
      "Hide From Stores": "Hide From Stores",
      "savedSuccessfully": "Brand saved successfully",
      "failedSave": "Failed to save the Brand",
      "show in home?": "Show in home?"
    }
  },
  "products": {
    "products": "Products",
    "categories": "Categories",
    "loadingMoreProducts": "Loading more products...",
    "noMoreProductsToLoad": "No more products to load",
    "filterBy": "Filter By",
    "searchProducts": "Search Products",
    "mostCustomerProducts": "previously purchased",
    "storeMostSales": "Store Most Sales",
    "offers": "Offers",
    "customers": "Customers",
    "unavailableProducts": "Unavailable Products",
    "withBrand": "Products with Brand",
    "withCategory": "Products with Category",
    "withPhoto": "Products with Photo",
    "withoutBrand": "Products without Brand",
    "withoutCategory": "Products without Category",
    "withoutPhoto": "Products without Photo",
    "applyFilter": "Apply Filter",
    "cancel": "Cancel",
    "id": "Id",
    "nameEn": "Name - EN",
    "nameAr": "Name - AR",
    "barcode": "Barcode",
    "category": "Category",
    "price": "Price",
    "productLink": "Product Link",
    "status": "Status",
    "actions": "Actions",
    "deleteSelected": "Delete Selected",
    "bulkDeleteConfirm": "Are you sure you want to delete {{count}} selected products?",
    "bulkDeleteSuccess": "Selected products deleted successfully",
    "bulkDeleteFailed": "Failed to delete selected products",
    "noBulkDeletePermission": "You don't have permission to delete products",
    "changeStatusSelected": "Change Status",
    "activateSelected": "Activate",
    "deactivateSelected": "Deactivate",
    "bulkStatusSuccess": "Status updated for selected products",
    "bulkStatusFailed": "Failed to update status for selected products",
    "noBulkStatusPermission": "You don't have permission to change product status",
    "assignManufacturer": "Set manufacturer",
    "assignManufacturerTitle": "Set manufacturer for {{count}} selected products",
    "selectManufacturer": "Select manufacturer",
    "removeManufacturer": "Remove manufacturer from selected products",
    "bulkManufacturerSuccess": "Manufacturer updated for selected products",
    "bulkManufacturerPartial": "Updated {{updated}} products, {{failed}} could not be updated",
    "bulkManufacturerFailed": "Failed to update manufacturer for selected products",
    "filterByManufacturer": "Manufacturer",
    "selectedCount": "{{count}} selected",
    "clearSelection": "Clear selection"
  },
  "productList": {
    "mainDetails": "Main Details",
    "createOptions": {
      "title": "Add New Product",
      "subtitle": "Add your products easily in simple steps",
      "description": "Build your own product catalog, track your stock inventory, and easily sell your product with a direct link.",
      "uploadGroup": {
        "title": "Upload Group Of Products",
        "description": "Upload All Products Easily By Excel File"
      },
      "addSingle": {
        "title": "Add Single Product",
        "description": "Add One Product With Full Details"
      },
      "exportProducts": "Export Products",
      "downloadSample": "Download Sample File"
    },
    "noImportPermission": "You don't have permission to import products",
    "noCreatePermission": "You don't have permission to create products",
    "noExportPermission": "You don't have permission to export products",
    "ProductDetails": "Product Details",
    "SeoSearch": "SEO & Search",
    "importOptions": {
      "title": "Import Products",
      "selectSection": "Select Import Section",
      "selectSectionRequired": "Please select an import section",
      "selectSectionPlaceholder": "Choose what to import",
      "selectSectionFirst": "Please select an import section first",
      "selectFile": "Select File",
      "dragFileText": "Click or drag file to this area to upload",
      "fileHint": "Support for Excel (.xlsx, .xls) or CSV files. Maximum file size: 10MB",
      "info": "Select the section you want to import and upload your file. The file should match the selected import type.",
      "downloadSample": "Download Sample File"
    }
  },
  "orderSummary": {
    "statusChangeSuccess": "Status changed successfully",
    "statusChangeError": "Failed to change status",
    "driverAssignSuccess": "Driver assigned successfully",
    "driverAssignError": "Failed to assign driver",
    "shopperAssignSuccess": "Shopper assigned successfully",
    "shopperAssignError": "Failed to assign shopper",
    "itemDeleteSuccess": "Item deleted successfully",
    "itemDeleteError": "Failed to delete item",
    "itemUpdateSuccess": "Item updated successfully",
    "itemUpdateError": "Failed to update item",
    "itemReturnSuccess": "Item returned successfully",
    "itemReturnError": "Failed to return item",
    "reportedWeightUpdateSuccess": "Collected weight updated",
    "reportedWeightUpdateError": "Failed to update collected weight",
    "offerDeleteSuccess": "Offer deleted successfully",
    "offerDeleteError": "Failed to delete offer",
    "offerUpdateSuccess": "Offer updated successfully",
    "offerUpdateError": "Failed to update offer",
    "offerLoadError": "Failed to load offer details",
    "itemAddedSuccess": "Item added successfully.",
    "itemAddError": "Failed to add item. Please try again.",
    "weightAdjustmentsBanner": "Shopper has reported new weights for {{count}} item(s). Totals were updated automatically.",
    "updateOrderModifySuccess": "Order updated successfully",
    "updateOrderModifyError": "Failed to update order"
  },
  "editProduct": {
    "title": "Edit Product",
    "addNewProductTitle": "Add New Product",
    "selectProduct": "Select Product",
    "quantity": "Quantity",
    "price": "Price",
    "comment": "Product Comment",
    "cancel": "Cancel",
    "submit": "Submit",
    "quantityRequired": "Quantity is required",
    "quantityMustBePositive": "Quantity must be greater than 0",
    "quantityMustBeInteger": "Quantity must be a whole number",
    "quantityBelowMin": "Minimum quantity is {{min}}",
    "quantityExceedsStock": "Quantity exceeds available stock ({{stock}})"
  },
  "productAlternatives": {
    "title": "Alternatives",
    "activeIngredient": "Active ingredient",
    "activeIngredientHint": "Products with the same active ingredient are suggested as generic alternatives",
    "types": {
      "brand": "Brand alternative",
      "generic": "Generic alternative"
    },
    "columns": {
      "product": "Product",
      "barcode": "Barcode",
      "price": "Price",
      "type": "Type"
    },
    "searchProducts": "Search products to add",
    "add": "Add",
    "save": "Save alternatives",
    "confirmSave": "Save alternatives?",
    "saved": "Alternatives saved",
    "saveFailed": "Failed to save alternatives",
    "loadFailed": "Failed to load alternatives",
    "confirmDelete": "Remove this alternative?",
    "deleted": "Alternative removed",
    "deleteFailed": "Failed to remove alternative",
    "empty": "No alternatives yet",
    "suggest": "Suggest by active ingredient",
    "suggestionsTitle": "Same active ingredient",
    "suggestionsFailed": "Failed to load suggestions",
    "noSuggestions": "No other products share this active ingredient. Set the active ingredient on the product first.",
    "addAllGeneric": "Add all as generic",
    "importSuccess": "Alternatives imported. Created {{created}}, updated {{updated}}, skipped {{skipped}}.",
    "unmatchedBarcodes": "Barcodes not found: {{barcodes}}"
  },
  "productsList": {
    "videos": "Videos",
    "leaflets": "Leaflets (PDF)",
    "uploadVideo": "Upload video",
    "videoUploadRestrictions": "MP4, WebM or MOV, up to 100 MB",
    "addVideoUrl": "Add YouTube/Vimeo link",
    "videoUrlPlaceholder": "https://www.youtube.com/watch?v=...",
    "invalidVideoUrl": "Enter a valid YouTube or Vimeo link",
    "videoAdded": "Video added successfully",
    "videoTypeError": "Video must be an MP4, WebM or MOV file",
    "videoMaxSizeError": "Video must be 100 MB or smaller",
    "noVideos": "No videos yet",
    "leafletUploadRestrictions": "PDF only, up to 10 MB, one per language",
    "leafletPdfOnly": "Leaflet must be a PDF file",
    "leafletMaxSizeError": "Leaflet must be 10 MB or smaller",
    "uploadLeaflet": "Upload PDF",
    "replaceLeaflet": "Replace",
    "viewLeaflet": "View leaflet",
    "noLeaflet": "No leaflet",
    "allLanguages": "All languages",
    "arabic": "Arabic",
    "english": "English",
    "mediaUploaded": "File uploaded successfully",
    "mediaUploadFailed": "Failed to upload file",
    "mediaDeleted": "Deleted successfully",
    "mediaDeleteFailed": "Failed to delete",
    "mediaSortFailed": "Failed to reorder videos",
    "deleteMediaConfirm": "Are you sure you want to delete this file?",
    "rating": "Rating",
    "nameEN": "Name (English)",
    "nameAr": "Name (Arabic)",
    "description_en": "Description (English)",
    "description_ar": "Description (Arabic)",
    "mainImage": "Main Image",
    "moreImages": "More Images",
    "tagKeyWords": "Tag Keywords",
    "internal_parcode": "Internal Barcode",
    "optional": "(Optional)",
    "salla_id": "Salla ID",
    "metaEn": "Meta Description (English)",
    "metaAr": "Meta Description (Arabic)",
    "metaDescEn": "Meta Description (English)",
    "metaDescAr": "Meta Description (Arabic)",
    "keywordsHelpText": "Keywords will help you and your customers find this product faster.",
    "savedSuccessfully": "Product Saved Successfully",
    "failedSave": "Failed to save the Product",
    "imageUploadBillingError": "Failed to upload image to Cloudflare R2. Please contact administrator.",
    "nameENPlaceholder": "Enter the product name in English",
    "nameArPlaceholder": "Enter the product name in Arabic",
    "descriptionEnPlaceholder": "Enter the product description in English",
    "descriptionArPlaceholder": "Enter the product description in Arabic",
    "tagKeyWordsPlaceholder": "Enter keywords for the product",
    "internalParcodePlaceholder": "Enter the Internal Barcode",
    "sallaIdPlaceholder": "Enter the Salla ID",
    "SeoEN": "SEO Title (English)",
    "SeoAr": "SEO Title (Arabic)",
    "metaEnPlaceholder": "Enter the SEO title in English",
    "metaArPlaceholder": "Enter the SEO title in Arabic",
    "metaDescriptionEn": "Meta Description (English)",
    "metaDescriptionAr": "Meta Description (Arabic)",
    "metaDescEnPlaceholder": "Enter the meta description in English",
    "metaDescArPlaceholder": "Enter the meta description in Arabic",
    "price": "Price",
    "barcode1": "Barcode 1",
    "barcode2": "Barcode 2 (Optional)",
    "quantityAvailable": "Quantity Available",
    "minQty": "Minimum Quantity",
    "maxQty": "Maximum Quantity (Optional)",
    "steps": "Steps",
    "showInApi": "Show in App (Optional)",
    "HideFromStores": "Hide From Stores",
    "meta_desc_en": "Meta Description (English)",
    "meta_desc_ar": "Meta Description (Arabic)",
    "meta_en": "Meta Title (English)",
    "meta_ar": "Meta Title (Arabic)",
    "ProductDetails": "Product Details",
    "suppliers": "Suppliers",
    "sort": "Sort Order (Optional)",
    "SeoSearch": "SEO & Search",
    "unitTypes": "Unit Types",
    "Brand": "Brand",
    "Manufacturer": "Manufacturer",
    "Steps": "Steps",
    "StockDetails": "Stock Details",
    "Pricing": "Pricing",
    "storeVisibilityHelpText": "Show this product in your own store, and activate the magic link for this order.",
    "imageUploadRestrictions": "Accepts JPG, JPEG, PNG, GIF, SVG — Max 800 KB per image",
    "imageMaxSizeError": "Image must be 800 KB or smaller",
    "imageTypeError": "Image must be JPG, JPEG, PNG, GIF, or SVG",
    "UnitEN": "Unit (EN)",
    "UnitAR": "Unit (AR)",
    "UnitType": "Unit Type",
    "PriceEffect": "Price Effect",
    "StockEffect": "Stock Effect",
    "Quantity": "Quantity",
    "None": "None",
    "Increase": "Increase",
    "Decrease": "Decrease",
    "productUnits": "Product Units",
    "ProductUnits": "Product Units",
    "AddUnit": "Add Unit",
    "SaveUnits": "Save Units",
    "confirmSaveUnits": "Are you sure you want to save these units?",
    "confirmDeleteUnit": "Are you sure you want to delete this unit?",
    "unitDeletedSuccessfully": "Unit deleted successfully",
    "unitDeleteFailed": "Failed to delete unit",
    "saveProductFirst": "Please save the product first before adding units",
    "noValidUnits": "No valid units to save. Please fill all required fields.",
    "unitsSavedSuccessfully": "Units saved successfully",
    "unitsFailedSave": "Failed to save units",
    "UnitENPlaceholder": "Enter unit name in English...",
    "UnitARPlaceholder": "Enter unit name in Arabic...",
    "productExtra": "Product Extra",
    "AddExtra": "Add Extra",
    "SaveExtras": "Save Extras",
    "confirmSaveExtras": "Are you sure you want to save extras?",
    "confirmDeleteExtra": "Are you sure you want to delete this extra?",
    "extraDeletedSuccessfully": "Extra deleted successfully",
    "extraDeleteFailed": "Failed to delete extra",
    "extrasSavedSuccessfully": "Extras saved successfully",
    "extrasFailedSave": "Failed to save extras",
    "noValidExtras": "No valid extras to save. Please fill all required fields.",
    "AddAttribute": "Add Attribute",
    "AddValue": "Add Value",
    "selectAttribute": "Select Attribute",
    "SaveAttributes": "Save Attributes",
    "confirmSaveAttributes": "Are you sure you want to save attributes?",
    "attributeValueDeletedSuccessfully": "Attribute value deleted successfully",
    "attributeValueDeleteFailed": "Failed to delete attribute value",
    "attributesSavedSuccessfully": "Attributes saved successfully",
    "attributesFailedSave": "Failed to save attributes",
    "noValidAttributes": "No valid attributes to save. Please fill all required fields.",
    "confirmDeleteAttributeValue": "Are you sure you want to delete this value?",
    "attribute": "Attribute",
    "valueAr": "Value Ar",
    "valueEn": "Value En",
    "priceEffect": "Price Effect",
    "changeType": "Change Type",
    "sku": "Sku",
    "value": "Value",
    "addValue": "Add Value",
    "Extra": "Extra",
    "selectExtra": "Select Extra"
  },
  "categoryList": {
    "createOptions": {
      "title": "Add New Category",
      "subtitle": "Add your categories easily in simple steps",
      "description": "You must add the main category first, then you can add a subcategory from the first or second level",
      "uploadGroup": {
        "title": "Upload Group Of Categories",
        "description": "Upload All Categories Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Category",
        "description": "Easily Add One Category One By One"
      },
      "downloadSample": "Download Sample File"
    },
    "noCreatePermission": "You don't have permission to create categories",
    "noImportPermission": "You don't have permission to import categories",
    "tableTitle": "All Main Categories",
    "subCategoriesTitle": "Sub Categories",
    "CategoryDetails": "Category Details",
    "SubCategoryDetails": "Sub Category Details",
    "columns": {
      "nameEn": "Name En",
      "nameAr": "Name Ar",
      "subCategories": "Sub-Categories",
      "subSubCategories": "Sub-Sub-Categories"
    },
    "addSubSubCategoryButton": "+ Add New Sub-Sub Category",
    "addSubCategoryButton": "+ Add New Sub Category"
  },
  "categoriesList": {
    "savedSuccessfully": "Category saved successfully",
    "Category": "Category",
    "failedSave": "Failed to save category",
    "CategoryDetails": "Category Details",
    "MainCategory": "Main Category",
    "nameEN": "Name (English)",
    "nameAr": "Name (Arabic)",
    "description_en": "Description (English)",
    "description_ar": "Description (Arabic)",
    "imageAr": "Image Ar",
    "imageEn": "Image En",
    "SeoEn": "SEO Slug (English)",
    "SeoAr": "SEO Slug (Arabic)",
    "sort": "Sort Order",
    "HideFromStores": "Hide From Stores",
    "showInHome": "Show in Home",
    "content_en": "Content (English)",
    "content_ar": "Content (Arabic)"
  },
  "e-commerce": {
    "slider": {
      "tableTitle": "All Sliders",
      "savedSuccessfully": "Slider Saved Successfully",
      "failedSave": "Failed to save the slider",
      "editSlider": "Edit Slider",
      "addSlider": "Add Slider",
      "fields": {
        "id": "Id",
        "company": "Company",
        "image": "Image",
        "imageAlt": "Slider Image",
        "type": "Type",
        "link": "Link",
        "status": "Status",
        "sliderType": "Slider Type",
        "product": "Product",
        "brands": "Brands",
        "categories": "Categories",
        "fromDate": "From Date",
        "expireDate": "Expire Date",
        "fromDatePlaceholder": "Select start date",
        "expireDatePlaceholder": "Select expire date",
        "sort": "Sort",
        "platforms": "Platforms",
        "platformsPlaceholder": "All platforms"
      },
      "platformsHint": "Leave empty to show the slider on all platforms.",
      "allPlatforms": "All platforms",
      "platforms": {
        "ios": "iOS",
        "android": "Android",
        "website": "Website"
      },
      "options": {
        "link": "Link",
        "product": "Product",
        "Multi product": "Multi Product",
        "Brand": "Brand",
        "Category": "Category",
        "Offers": "Offers",
        "Insurance": "Insurance"
      }
    },
    "flashDeal": {
      "tableTitle": "All Flash Deals",
      "savedSuccessfully": "Flash Deal Saved Successfully",
      "failedSave": "Failed to save the flash deal",
      "editFlashDeal": "Edit Flash Deal",
      "addFlashDeal": "Add Flash Deal",
      "fields": {
        "id": "ID",
        "nameEn": "Name (EN)",
        "nameAr": "Name (AR)",
        "btnTextEn": "Button Text (EN)",
        "btnTextAr": "Button Text (AR)",
        "type": "Type",
        "product": "Product",
        "brand": "Brand",
        "category": "Category",
        "expiredDate": "Expired Date",
        "fromDate": "From Date",
        "toDate": "To Date",
        "image": "Image",
        "status": "Status"
      },
      "types": {
        "product": "Product",
        "brand": "Brand",
        "category": "Category"
      }
    },
    "cancelReasons": {
      "tableTitle": "All Cancel Reasons",
      "noCreatePermission": "You don't have permission to create cancel reasons",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "fields": {
        "id": "ID",
        "arabicName": "Arabic Name",
        "englishName": "English Name",
        "status": "Status",
        "showInApp": "Show in App",
        "showInCrm": "Show in CRM",
        "actions": "Actions"
      },
      "enable": "Enable",
      "disable": "Disable"
    },
    "uncompletedOrderReasons": {
      "tableTitle": "All Uncompleted Order Reasons",
      "noCreatePermission": "You don't have permission to create uncompleted order reasons",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "fields": {
        "id": "ID",
        "arabicName": "Arabic Name",
        "englishName": "English Name",
        "status": "Status",
        "actions": "Actions"
      },
      "enable": "Enable",
      "disable": "Disable"
    },
    "promocode": {
      "allCustomers": "All customers",
      "createOptions": {
        "title": "Add New Promocode",
        "uploadGroup": {
          "title": "Upload Group Of Promocodes",
          "description": "Upload Promocodes And Their Customers By Excel File"
        },
        "addSingle": {
          "title": "Add One Promocode",
          "description": "Easily Add One Promocode One By One"
        },
        "downloadSample": "Download Sample Template"
      },
      "importInstructions": {
        "title": "Import Instructions",
        "oneRowPerCustomer": "One row per customer, grouped by code",
        "firstRowFields": "Promocode fields are read from the first row of each code",
        "customerColumns": "Fill customer_id or internal_id (Odoo id); leave both empty for all customers",
        "existingCode": "An existing code is updated and its customer list is replaced",
        "commaSeparated": "stores, products, brands and categories are comma-separated ids",
        "supportedFormats": "Supported formats"
      },
      "import": {
        "importing": "Importing promocodes...",
        "success": "Promocodes imported successfully!",
        "created": "Created",
        "updated": "Updated",
        "failed": "Failed",
        "failedRows": "Some rows were not imported:",
        "rowError": "Row {{row}}{{code}}: {{message}}",
        "moreErrors": "...and {{count}} more",
        "error": "Failed to import promocodes. Please try again.",
        "fileTooLarge": "File is too large. Maximum size is 10MB."
      },
      "tableTitle": "All Promocodes",
      "noCreatePermission": "You don't have permission to create promocodes",
      "noEditPermission": "You don't have permission to edit promocodes",
      "noDeletePermission": "You don't have permission to delete promocodes",
      "savedSuccessfully": "Promocode Saved Successfully",
      "failedSave": "Failed to save the promocode",
      "editPromocode": "Edit Promocode",
      "addPromocode": "Add Promocode",
      "fields": {
        "customers": "Customers",
        "id": "ID",
        "code": "Code",
        "discount_type": "Discount Type",
        "type": "Type",
        "amount": "Amount",
        "startdate": "Start Date",
        "enddate": "End Date",
        "minimum": "Minimum",
        "max_count": "Max Count",
        "max_use_per_customer": "Max Use Per Customer",
        "max_discount_amount": "Max Discount Amount",
        "status": "Status",
        "first_order_only": "First Order Only",
        "promo_store": "Promo Store",
        "stores": "Stores",
        "all": "All",
        "custom_stores": "Custom Stores",
        "product": "Product",
        "brand": "Brand",
        "category": "Category",
        "medicine_discount": "Medicine Discount",
        "cosmetic_discount": "Cosmetic Discount",
        "accessory_discount": "Accessory Discount",
        "actions": "Actions",
        "maximum": "Maximum Order Value"
      },
      "discountTypes": {
        "fixAmount": "Fix Amount",
        "percentage": "Percentage"
      },
      "types": {
        "general": "General",
        "product": "Product",
        "brand": "Brand",
        "category": "Category",
        "firstorder": "First Order",
        "shipping": "Shipping"
      },
      "noLimit": "No limit",
      "validation": {
        "maxGreaterThanMin": "Maximum must be greater than or equal to Minimum"
      },
      "enable": "Enable",
      "disable": "Disable"
    },
    "homeStaticContent": {
      "tableTitle": "All Static Home Contents",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "enable": "Enable",
      "disable": "Disable",
      "fields": {
        "id": "ID",
        "arabicName": "Arabic Name",
        "englishName": "English Name",
        "sortOrder": "Sort Order",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "prescriptionStatuses": {
      "tableTitle": "Prescription Statuses",
      "noCreatePermission": "You don't have permission to create prescription statuses",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "enable": "Enable",
      "disable": "Disable",
      "fields": {
        "code": "Code",
        "arabicName": "Arabic Name",
        "englishName": "English Name",
        "sort": "Sort",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "prescriptionRejectReasons": {
      "tableTitle": "Prescription Reject Reasons",
      "noCreatePermission": "You don't have permission to create reject reasons",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "enable": "Enable",
      "disable": "Disable",
      "fields": {
        "arabicName": "Arabic Name",
        "englishName": "English Name",
        "status": "Status",
        "actions": "Actions"
      }
    }
  },
  "homeStaticContentModal": {
    "createContent": "Create Static Home Content",
    "editContent": "Edit Static Home Content",
    "savedSuccessfully": "Static Content Saved Successfully",
    "failedSave": "Failed to save the static content",
    "fields": {
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "arabicContent": "Arabic Content",
      "englishContent": "English Content",
      "sortOrder": "Sort Order",
      "status": "Status"
    }
  },
  "cancelReasonModal": {
    "createCancelReason": "Create Cancel Reason",
    "editCancelReason": "Edit Cancel Reason",
    "savedSuccessfully": "Cancel Reason Saved Successfully",
    "failedSave": "Failed to save the cancel reason",
    "noCreatePermission": "You don't have permission to create cancel reasons",
    "noEditPermission": "You don't have permission to edit cancel reasons",
    "fields": {
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "status": "Status",
      "showInApp": "Show In App",
      "showInCrm": "Show In Crm"
    }
  },
  "uncompletedOrderReasonModal": {
    "createReason": "Create Uncompleted Order Reason",
    "editReason": "Edit Uncompleted Order Reason",
    "savedSuccessfully": "Uncompleted Order Reason Saved Successfully",
    "failedSave": "Failed to save the uncompleted order reason",
    "noCreatePermission": "You don't have permission to create uncompleted order reasons",
    "noEditPermission": "You don't have permission to edit uncompleted order reasons",
    "fields": {
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "status": "Status"
    }
  },
  "sliderList": {
    "noCreatePermission": "You don't have permission to create sliders",
    "noEditPermission": "You don't have permission to edit sliders",
    "noDeletePermission": "You don't have permission to delete sliders"
  },
  "sliderModal": {
    "noCreatePermission": "You don't have permission to create sliders",
    "noEditPermission": "You don't have permission to edit sliders"
  },
  "trackingOrder": {
    "order tracking": "order tracking",
    "employee": "employee",
    "timing": "timing",
    "value": "value",
    "orderNumber": "Order #",
    "timeline": "Timeline",
    "customer": "Customer",
    "phone": "Phone",
    "store": "Store",
    "createdAt": "Created at",
    "total": "Total",
    "currentStatus": "Current status",
    "eventsCount": "{{value}} events",
    "totalDuration": "Total duration",
    "from": "From",
    "to": "To",
    "after": "after",
    "first": "Start",
    "latest": "Latest",
    "roleUser": "Employee",
    "roleShopper": "Shopper",
    "roleCustomer": "Customer",
    "roleUnknown": "Unknown",
    "unitDay": "day",
    "unitHour": "hour",
    "unitMinute": "minute",
    "unitSecond": "second",
    "and": "and",
    "genericEvent": "Order event",
    "noEvents": "No events recorded for this order",
    "noViewPermission": "You do not have permission to view this order's tracking.",
    "loadFailed": "Failed to load order tracking",
    "opCreateOrder": "Create new Order",
    "opAssignShopper": "Assign Shopper",
    "opItemRefund": "Item Refund",
    "opChangeDeliveryTime": "Change Delivery Time",
    "opChangeStatus": "Change Order Status",
    "opSettleOrder": "Settle Order",
    "opTransferStore": "Transfer Order Store",
    "opUpdateShippingFees": "Update Shipping Fees",
    "opChangePaymentType": "Change Payment Type",
    "opUpdateDiscount": "Update Discount",
    "opOpenOrder": "Open Order",
    "opUpdateAddress": "Update Address",
    "opUpdateComments": "Update Comments",
    "opAddProduct": "Add Product",
    "opUpdateProduct": "Update Product",
    "opDeleteProduct": "Delete Product",
    "opReturnItem": "Return Item",
    "valCreateOrder": "Create new Order",
    "valShopperAssigned": "Shopper name: {{name}}",
    "valStatusChangedTo": "Status changed to: {{status}}",
    "valItemRefundUpdated": "Item refund updated: {{item}}",
    "valOpenOrderFirstTime": "Order opened for the first time",
    "valOrderSettled": "Order settled in branch",
    "valAddressUpdated": "Order address updated",
    "valCommentsUpdated": "Comments updated",
    "valTransferBetweenStores": "Transferred from store {{fromId}} ({{fromName}}) to store {{toId}} ({{toName}})",
    "valTransferToStore": "Order transferred to store {{toId}}",
    "valShippingFeesChanged": "Shipping fees changed from {{from}} to {{to}}",
    "valDiscountChanged": "Discount changed from {{from}} to {{to}}",
    "valPaymentChanged": "Payment type changed from {{from}} to {{to}}",
    "valStatusChanged": "Order status changed from {{from}} to {{to}}",
    "valDeliveryTimeChanged": "Delivery time changed from {{from}} to {{to}}",
    "valProductAdded": "Added product {{id}}, customer comment: {{comment}}",
    "valProductUpdated": "Updated product {{id}}, customer comment: {{comment}}",
    "valOfferProductUpdated": "Updated offer product {{id}}",
    "valGroupOfferUpdated": "Updated group offer {{id}}",
    "valAlternativeAdded": "Added alternative product: {{name}}",
    "valProductDeleted": "Deleted product {{id}}",
    "valItemReturned": "Returned {{qty}} of product {{id}}, amount: {{amount}}",
    "valServiceCommentChanged": "Customer service comment changed from \"{{from}}\" to \"{{to}}\"",
    "valAgentCommentChanged": "Delivery agent comment changed from \"{{from}}\" to \"{{to}}\""
  },
  "units": {
    "PCS": "PCS",
    "BOX": "Box",
    "KG": "KG",
    "GM": "GM",
    "LTR": "Liter",
    "ML": "ML",
    "PACK": "Pack",
    "CARTON": "Carton",
    "STRIP": "Strip",
    "BOTTLE": "Bottle"
  },
  "orderFilter": {
    "orderDateFrom": "Order Date From",
    "orderDateTo": "Order Date To",
    "deliveryDateFrom": "Delivery Date From",
    "deliveryDateTo": "Delivery Date To",
    "paymentMethod": "Payment Method",
    "orderStatus": "Order Status",
    "store": "Store",
    "orderCreator": "Order Creator",
    "customerPhone": "Customer Phone",
    "customerName": "Customer Name",
    "barcode": "Barcode",
    "callChannel": "Call Channel",
    "area": "Area",
    "region": "Region",
    "createdFrom": "Created From",
    "totalAmount": "Total Amount",
    "orderId": "Order ID",
    "deliveryTime": "Delivery Time",
    "crm": "CRM",
    "app": "App",
    "website": "Website",
    "deliveryDate": "Delivery Date",
    "phoneOrName": "Phone / Name"
  },
  "tableFiltersModal": {
    "filter": "Filter",
    "filterBy": "Filter By",
    "apply": "Apply",
    "cancel": "Cancel",
    "reset": "Reset"
  },
  "table": {
    "search": "Search",
    "id": "Id",
    "edit": "Edit",
    "exportExcel": " Export Excel",
    "of": "Of",
    "entries": "Entries"
  },
  "alternativeProducts": {
    "title": "Alternative Products",
    "id": "ID",
    "name": "Name",
    "price": "Price",
    "quantity": "Quantity",
    "comment": "Comment",
    "select": "Select"
  },
  "orderItems": {
    "name": "Name",
    "quantity": "Quantity",
    "returned": "Returned",
    "unit": "Unit",
    "attributes": "Attributes",
    "extras": "Extras",
    "status": "Status",
    "barcode": "Barcode",
    "unitPrice": "Unit Price",
    "totalPrice": "Total Price",
    "remove_offer": "Remove Offer",
    "edit_offer": "Edit Offer",
    "add-more-products": "+ Add More Products",
    "clickToViewAll": "Click to view all",
    "productDetails": "Product Details",
    "noAttributesOrExtras": "No attributes or extras available for this product",
    "adjustedByShopper": "Adjusted by shopper",
    "weightTooltipOriginal": "Original: {{quantity}} {{unit}}",
    "weightTooltipReported": "Reported: {{weight}} {{unit}}",
    "originalQuantity": "Originally ordered: {{quantity}}",
    "remainingQuantity": "Quantity after return",
    "pickedQuantity": "Picked quantity",
    "returnedTooltip": "Returned: {{returned}}\nRemaining: {{remaining}}",
    "returnedAmount": "Refunded: {{amount}}",
    "viewComments": "View comments",
    "comments": "Comments",
    "customerComment": "Customer comment",
    "shopperComment": "Shopper comment",
    "returnItem": "Return",
    "returnItemTitle": "Return Item",
    "returnedQty": "Returned Quantity",
    "returnRemaining": "Remaining: {{qty}}",
    "returnQtyRequired": "Enter the quantity to return",
    "returnQtyPositive": "Quantity must be greater than zero",
    "returnQtyExceeds": "Cannot return more than {{qty}}",
    "returnReason": "Reason",
    "returnReasonPlaceholder": "Optional",
    "editCollectedWeight": "Edit collected weight",
    "collectedWeight": "Collected weight",
    "collectedWeightRequired": "Enter the collected weight",
    "collectedWeightPositive": "Weight must be greater than zero",
    "clearCollectedWeight": "Clear weight",
    "saveCollectedWeight": "Save",
    "orderedQuantity": "Ordered: {{qty}} {{unit}}"
  },
  "shippingModal": {
    "shippingFee": "shipping Fee"
  },
  "discountModal": {
    "modalTitle": "Add Discount",
    "discountType": "Discount Type",
    "fixedAmount": "fixed",
    "percentage": "percentage",
    "discountValue": "Value"
  },
  "orders": {
    "tableTitle": "Orders",
    "activeTableTitle": "Active Orders",
    "order": "Order",
    "items": "items",
    "columns": {
      "id": "Id",
      "creator": "Creator",
      "customerName": "Customer Name",
      "customerSegment": "Customer Segment",
      "telephone": "Telephone",
      "store": "Store",
      "region": "Region",
      "area": "Area",
      "orderStatus": "Order Status",
      "createdFrom": "Created From",
      "createdAt": "Created At",
      "deliveryDate": "Delivery Date",
      "actions": "Actions",
      "call_channel": "Call Channel",
      "order_timer": "Order Age",
      "pickup": "Pickup",
      "transferred": "Transferred",
      "item_count": "Items",
      "total": "Total",
      "sub_total": "Subtotal",
      "total_after_discount": "Total After Discount",
      "loyalty_discount": "Loyalty Discount",
      "delivery_time": "Delivery Time",
      "address": "Street / Address"
    },
    "actions": {
      "track": "Track",
      "print": "Print",
      "transferSelected": "Transfer",
      "show": "View",
      "assign": "Assign"
    },
    "noAssignPermission": "You don't have permission to assign orders",
    "selectOrdersToTransfer": "Select orders to transfer",
    "noTransferAllowed": "Transfer not allowed (needs permission, open order, within 30 min)",
    "transferOrderClosed": "Order is cancelled or finished — transfer not allowed",
    "transferWindowExpired": "Transfer window has expired for this order",
    "noTrackPermission": "You don't have permission to track orders",
    "noShowPermission": "You don't have permission to view order details",
    "noPrintPermission": "You don't have permission to print orders",
    "noChangeStatusPermission": "You don't have permission to change order status",
    "noChangeAddressPermission": "You don't have permission to change order address",
    "noChangeDeliveryTimePermission": "You don't have permission to change delivery time",
    "noShippingUpdatePermission": "You don't have permission to update shipping information",
    "noTransferPermission": "You don't have permission to transfer orders",
    "noUpdatePermission": "You don't have permission to update orders",
    "pdfDownloadError": "There was an error downloading the PDF. Please try again.",
    "popupBlocked": "Please allow popups to preview the order.",
    "noTokenError": "Authentication token not found. Please log in again.",
    "noDeletePermission": "You don't have permission to delete order items",
    "noEditPermission": "You don't have permission to edit order items",
    "noAddProductPermission": "You don't have permission to add products to orders",
    "noAddDiscountPermission": "You don't have permission to add discount to orders",
    "errorLoadingOrder": "Error Loading Order",
    "errorLoadingOrderDescription": "There was an error loading the order details. Please try again.",
    "orderStatusGroupProgress": "Status group progress",
    "orderStatusGroupSection": "Order status group",
    "printPreview": "Print Preview",
    "printA4": "Print A4 Paper",
    "printReceipt": "Print Receipt"
  },
  "orderDetails": {
    "orderId": "Order ID",
    "customerId": "Customer ID",
    "customerName": "Customer Name",
    "phone": "Phone",
    "phone2": "Phone 2",
    "orderStatus": "Order Status",
    "customerAddress": "Customer Address",
    "storeName": "Store Name",
    "registeredPhone": "Registered Phone",
    "deliveryDate": "Delivery Date",
    "createdAt": "Created At",
    "orderBuilder": "Order Builder",
    "pickup": "Pickup",
    "requiredCalling": "Required Calling",
    "customerSegment": "Customer Segment",
    "chooseCustomerSegment": "Choose Customer Segment",
    "segmentUpdateSuccess": "Customer segment updated successfully",
    "segmentUpdateError": "Failed to update customer segment",
    "customerComment": "Customer Comment",
    "collectorComment": "Collector Comment",
    "driverComment": "Driver Comment",
    "agentComment": "Agent Comment",
    "paymentType": "Payment Type",
    "billingComment": "Billing Comment",
    "transferOrder": "Transfer Order",
    "transferTimeRemaining": "Time left to transfer",
    "yes": "Yes",
    "no": "No",
    "image": "IMAGE",
    "productName": "PRODUCT NAME",
    "qty": "QTY",
    "barcode": "BARCODE",
    "unitPrice": "UNIT PRICE",
    "total": "TOTAL",
    "notes": "NOTES",
    "products": "Products",
    "printA4": "Print A4",
    "finalTotal": "Final Total",
    "dms": "DMS",
    "odoo": "Odoo",
    "odooId": "ID",
    "odooPosReference": "Reference",
    "thanksSmsSentAt": "Thanks SMS Date",
    "viewRefund": "View Refund",
    "odooRefund": "Odoo Refund",
    "refundFullOrder": "Refund Full Order",
    "odooRefundConfirm": "Refund the full order to Odoo?",
    "odooRefundSuccess": "Order refunded to Odoo successfully",
    "odooRefundFailed": "Failed to refund order to Odoo",
    "refundSummaryFetchFailed": "Failed to fetch refund summary",
    "noRefunds": "No refunds",
    "refundCount": "Refund Count",
    "totalRefundedQty": "Total Refunded Qty",
    "refundId": "Refund ID",
    "refundState": "State",
    "refundedAt": "Refunded At",
    "refundTotalQty": "Total Qty",
    "refundProduct": "Product",
    "refundQty": "Qty",
    "refundOrderItemId": "Order Item ID",
    "refundLineId": "Refund Line ID",
    "refundHistoryNoPermission": "You don't have permission to view the return history",
    "collectorName": "Collector Name",
    "driverName": "Driver Name",
    "invoiceLink": "Invoice Link",
    "attachInvoiceLink": "Attach Invoice Link",
    "invoiceNumber": "Invoice Number",
    "invoiceNumberRequired": "Invoice number is required",
    "invoiceUrl": "Invoice URL",
    "invoiceUrlOptionalHelp": "Leave blank to auto-build from settings",
    "viewInvoice": "View Invoice",
    "copyInvoiceLink": "Copy Invoice Link",
    "invoicePaid": "Paid",
    "invoiceUnpaid": "Unpaid",
    "invoiceProvider": "Provider",
    "noInvoiceYet": "No invoice yet",
    "invoiceLinkAttached": "Invoice link attached successfully",
    "invoiceLinkAttachFailed": "Failed to attach invoice link",
    "invoiceLinkCopied": "Invoice link copied",
    "invoiceLinkCopyFailed": "Failed to copy invoice link",
    "customerInfo": "Customer Info",
    "communications": "Communications",
    "addressPhone": "Address Phone",
    "additionalAddressPhone": "Additional Address Phone",
    "orderInfo": "Order Info",
    "deliveryTime": "Delivery Time",
    "comments": "Comments",
    "rateComment": "Rate Comment",
    "transferComment": "Transfer Comment",
    "customerServiceComment": "Customer Service Comment",
    "branchComment": "Branch Comment",
    "receiptNumber": "Receipt Number",
    "viewDriverRoute": "View route on map",
    "viewOnOdoo": "View on Odoo",
    "redirectingToOdoo": "Redirecting to Odoo...",
    "paymentInfo": "Payment Info",
    "refundRequested": "Refund requested",
    "refundFailed": "Refund request failed",
    "refund": "Refund",
    "attachments": "Attachments",
    "updateOrderAction": "Update Order",
    "updateOrderSuccess": "Order updated successfully",
    "updateOrderFailed": "Failed to update order",
    "calculateOrderTotalAction": "Recalculate Total",
    "calculateOrderTotalSuccess": "Order total recalculated successfully",
    "calculateOrderTotalFailed": "Failed to recalculate order total",
    "orderType": "Order Type",
    "orderTypePickup": "Pickup",
    "orderTypeDelivery": "Delivery",
    "street": "Street",
    "buildingNumber": "Building Number",
    "floorNumber": "Floor Number",
    "flatNumber": "Flat Number",
    "landMark": "Land Mark",
    "address": "Address",
    "paymentMethod": "Payment Method"
  },
  "invoiceDetails": {
    "title": "Invoice Details",
    "firstTotal": "First Total",
    "subTotal": "Sub Total",
    "minimumOrder": "Minimum Order",
    "deliveryFees": "Delivery Fees",
    "serviceFees": "Service Fees",
    "discount": "Discount",
    "loyaltyAmount": "Loyalty Amount",
    "codeAmount": "Code Amount",
    "promoCode": "Promo Code",
    "youSave": "You Save",
    "total": "Total",
    "collectorTotal": "Collector Total",
    "missingTotal": "Missing Total",
    "refundTotal": "Refund Total",
    "deletedTotal": "Deleted Total",
    "addDiscount": "Add Discount",
    "updateShippingFees": "Update Shipping Fees",
    "errorFetching": "Error fetching invoice details",
    "stockInformation": "Stock Information",
    "stockDescription": "Number of products in branches",
    "totalStock": "Total Stock",
    "stockByBranch": "Stock by Branch",
    "loadingStockInfo": "Loading stock information...",
    "noStockInfo": "No stock information available",
    "stockInfoError": "Failed to load stock information"
  },
  "orderTabs": {
    "orderDetails": "Order Details",
    "shippingDetails": "Shipping Details"
  },
  "paymentTypes": {
    "cashOnDelivery": "Cash On Delivery",
    "visaOnDelivery": "Visa On Delivery",
    "visaOnline": "Visa Online",
    "unknown": "Unknown Payment Type"
  },
  "paymentModal": {
    "updateError": "Error updateing payment",
    "modalTitle": "Change Payment ",
    "required": "required",
    "label": "change payment Method",
    "updateSuccess": "Successfully updateing payment",
    "noPermission": "You don't have permission to change payment method"
  },
  "headerBar": {
    "updateOrderStatus": "Update Order Status",
    "assignTo": "Assign To",
    "assignDeliveryRep": "Assign To Driver",
    "assignShopper": "Assign To Collector",
    "refreshSuccess": "Order refreshed successfully!",
    "refreshFailed": "Failed to refresh order.",
    "updateOrderModify": "Update Order Modify"
  },
  "status": {
    "title": "Update Order Status",
    "selectStatus": "Select Status",
    "cancel": "Cancel",
    "updateStatus": "Update Status",
    "pending": "Pending",
    "processing": "Processing",
    "assigned": "Assigned",
    "inTransit": "In Transit",
    "delivered": "Delivered",
    "cancelled": "Cancelled"
  },
  "modal": {
    "updateStatusTitle": "Update Status",
    "selectStatus": "Select Status",
    "updateStatus": "Update Status",
    "assignDeliveryRepTitle": "Assign To Driver",
    "assignRep": "Assign Rep",
    "assignShopperTitle": "Assign To Collector",
    "assignShopper": "Assign Collector",
    "selectCancelReason": "Select cancel reason",
    "cancelReason": "Cancel Reason",
    "canceledBy": "Canceled By",
    "comment": "Comment",
    "cancelReasonRequired": "Cancel reason is required",
    "canceledByRequired": "Canceled by is required",
    "enterCancelReason": "Enter cancel reason",
    "enterCanceledBy": "Enter who canceled",
    "enterComments": "Enter comments"
  },
  "transfer": {
    "order": {
      "title": "Transfer Order"
    },
    "bulk": {
      "title": "Transfer Orders",
      "selectedOrders": "Selected Orders"
    },
    "branch": {
      "label": "Branch",
      "required": "Please select a branch",
      "placeholder": "Select branch to transfer to",
      "current": "Current",
      "main": "Main store",
      "help": "The order's current branch is marked and can't be selected."
    },
    "reason": {
      "label": "Reason",
      "required": "Please enter the reason",
      "placeholder": "Enter transfer reason"
    },
    "actionBy": {
      "label": "Action Taken By",
      "required": "Please select who is taking this action",
      "placeholder": "Select action taker",
      "options": {
        "admin": "Administrator",
        "manager": "Manager",
        "operator": "Operator"
      }
    },
    "error": "Error transferring order",
    "success": "Order transferred successfully!"
  },
  "time": {
    "days": "d",
    "hours": "h",
    "minutes": "m",
    "seconds": "s"
  },
  "setting": {
    "Restart": "Restart",
    "sync_chats": "Sync Chats",
    "Unlink_Device": "Unlink Device",
    "Status": "Status"
  },
  "chatFilter": {
    "All": "All",
    "Admin": "Admin",
    "Agent": "Agent",
    "Supervisor": "Supervisor",
    "Unknown_Contacts": "Unknown Contacts",
    "Unread_Messages": "Unread Messages",
    "Status_Count": "Status Count",
    "Chats": "Chats",
    "Comments": "Comments",
    "Groups": "Groups",
    "search_for": "Search For",
    "Messages": "Messages",
    "Users": "Users",
    "Cancel": "Cancel",
    "Manage": "Manage"
  },
  "chatContent": {
    "Move_To_Done": "Move To Done",
    "Assign_conversation": "Assign conversation",
    "conversations_selected": "conversations selected",
    "Mark_as_Follow_up": "Mark as Follow up",
    "Mark_as_Unread": "Mark as Unread",
    "Remove_Follow_up": "Remove Follow up",
    "Delete_Conversation": "Delete Conversation",
    "Mark_As_Follow_up": "Mark As Follow up"
  },
  "chatHeader": {
    "Contact_Updated_Successfully": "Contact Updated Successfully",
    "Are_sure_restore_contact": "Are You sure yo want to restore this contact",
    "Restore_Contact": "Restore Contact",
    "Are_sure_delete_contact": "Are You sure yo want to delete this contact",
    "Delete_Contact": "Delete Contact",
    "Contact_Info": "Contact Info",
    "Remove_Pin": "Remove Pin",
    "Pin": "Pin",
    "Unmute": "Unmute",
    "mute": "mute",
    "Mark_as_Processing": "Mark as Processing",
    "Pending": "Pending",
    "Mark_as_Pending": "Mark as Pending",
    "Follow_up": "Follow up",
    "Mark_as_Follow_up": "Mark as Follow up",
    "Move_to_done": "Move to done",
    "Add_Tags": "Add Tags",
    "Deleted": "Deleted",
    "successfully": "successfully",
    "Contact": "Contact",
    "Processing": "Processing",
    "Unassigned": "Unassigned",
    "Done": "Done",
    "Follow_Up": "Follow Up",
    "Group": "Group"
  },
  "moveToDone": {
    "Chat_Reason": "Chat Reason",
    "Chat_Type_is_required": "Chat_Type_is_required!",
    "Select_Chat_Type": "Select Chat Type",
    "Leave_a_Comment": "Leave a Comment",
    "Status_Change_to": "Status Change to",
    "Chat_Type": "Chat Type"
  },
  "CustomerInfo": {
    "Customer_Info": "Customer Info",
    "User_Name": "Contact Name",
    "Excel_Name": "Excel Name",
    "Whatsapp_Name": "WhatsApp Name",
    "Conversation_Phone": "conversation Phone",
    "Customer_Phone": "Customer Phone",
    "Customer_Email": "Customer Email",
    "Customer_Address": "Customer Address",
    "Customer_Comment": "Customer Comment",
    "Customer_New_Location": "Customer New Location",
    "Drop_location_here": "Drop location Url here",
    "location_updated": "Location Updated Successfully",
    "Customer_Location": "Customer Location",
    "Customer_Tags": "Customer Tags",
    "Star_Messages": "Star Messages"
  },
  "SettingSideMenu": {
    "WhatsApp": "WhatsApp",
    "Facebook": "Facebook"
  },
  "SendNewNumber": {
    "Send_New_Message": "Send New Message",
    "Enter_Phone_Message_Send": "Enter the Phone Number And The Message You Want To Send.",
    "Phone_is_required": "Phone is required!",
    "Must_valid_number": "Must be a valid number",
    "Must_be_required": "Must be required!",
    "Leave_a_Comment": "Leave a Comment"
  },
  "MessagesMenuActions": {
    "delete_message": "Delete Message",
    "Star": "Star",
    "Click_To_Copy": "Click To Copy",
    "Save_Location": "Save Location",
    "Reply": "Reply",
    "Add_Note": "Add Note",
    "Forward": "Forward",
    "Copied_to_Clipboard": "Copied To Clipboard",
    "reaction_success": "reacted successfully",
    "reaction_fail": "failed to react",
    "Save_All": "Save All"
  },
  "SendToDriver": {
    "Send_To_Driver": "Send To Driver",
    "Driver_is_required": "Driver is required!",
    "Order_type_required": "orderType is required!",
    "Payment_required": "payment method is required!",
    "price_required": "price is required",
    "subtotal_required": "subtotal is required",
    "orderId_required": "Order Id is required",
    "Select_Driver": "Select Driver",
    "comment": "comment",
    "price": "price",
    "Order_Id": "Order Id",
    "subtotal": "subtotal",
    "BRANCH": "BRANCH",
    "ONLINE": "ONLINE",
    "WASFATY": "WASFATY",
    "SHIPPING": "SHIPPING",
    "Cash": "Cash",
    "Visa": "Visa",
    "Paid": "Paid",
    "Note_This_doesnt_saved_Location": "Note: This Contact doesn't has saved Location"
  },
  "ChatFooter": {
    "attach": "Attach",
    "file": "File",
    "send_ex_file": "Send Ex File",
    "Stop_Recording": "Stop Recording",
    "type_your_message": "Type Your Message ...",
    "choose_template": "choose from template messages to send",
    "send_template_failed": "failed to send the template",
    "not_connected_instance": "this phone number is not connected"
  },
  "MessageNoteModal": {
    "attach": "",
    "Note_Added_Successfully": "Note Added Successfully",
    "Note_From": "Note From",
    "Add_Note": "Add Note",
    "note_is_required": "note is required!"
  },
  "SelectImageModal": {
    "select_one": "select one image to reply"
  },
  "CommentComponent": {
    "See_Chat": "See Chat",
    "send_message": "send message",
    "Tag": "Tag",
    "Like": "Like",
    "Delete_Comment": "Delete Comment",
    "Hide_Comment": "Hide Comment",
    "Block_User": "Block User",
    "User_Blocked_Successfully": "User Blocked Successfully",
    "Comment_Updated_Successfully": "Comment Updated Successfully"
  },
  "trackingOrderTabs": {
    "orders": "Orders",
    "collectors": "Collectors",
    "drivers": "Drivers",
    "applySearch": "Search"
  },
  "extrasList": {
    "tableTitle": "All extras",
    "addExtra": "Add Extra",
    "noCreatePermission": "You don't have permission to create extras",
    "createOptions": {
      "title": "Add New Extra",
      "subtitle": "Add your extras easily in simple steps",
      "description": "You can add extras one by one or upload multiple extras using an Excel file",
      "uploadGroup": {
        "title": "Upload Group Of Extras",
        "description": "Upload All Extras Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Extra",
        "description": "Easily Add One Extra One By One"
      },
      "downloadSample": "Download Sample File"
    },
    "importSuccess": "Extras imported successfully!",
    "importError": "Failed to import extras. Please try again.",
    "columns": {
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "enterNameEn": "Enter name in English",
      "enterNameAr": "Enter name in Arabic",
      "price": "Price",
      "enterPrice": "Enter price",
      "actions": "Actions",
      "savedSuccessfully": "Extra saved successfully",
      "updatedSuccessfully": "Extra updated successfully",
      "failedSave": "Failed to save extra",
      "failedUpdate": "Failed to update extra"
    },
    "editExtra": "Edit Extra"
  },
  "usersList": {
    "tableTitle": "All Users",
    "addUser": "Add User",
    "editUser": "Edit User",
    "noCreatePermission": "You don't have permission to create users",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "stores": "stores",
    "roles": "roles",
    "customizeColumns": "Customize Columns",
    "columns": {
      "name": "Name",
      "email": "Email",
      "username": "Username",
      "password": "Password",
      "type": "User Type",
      "showOwnOrdersOnly": "Show Own Orders Only",
      "showStoreTicketsOnly": "Show store tickets only",
      "showStoreTicketsOnlyDescription": "When enabled, this agent can only see tickets that belong to their assigned stores and cannot view tickets from other stores.",
      "showReportsOnlyForAssignedStores": "Show reports only for assigned stores",
      "showReportsOnlyForAssignedStoresDescription": "When enabled, this agent can only view reports for their assigned stores and cannot access reports from other stores.",
      "assignedStores": "Assigned Stores",
      "assignedRoles": "Assigned Roles",
      "enterName": "Enter name",
      "enterEmail": "Enter email",
      "enterUsername": "Enter username",
      "enterPassword": "Enter password",
      "selectType": "Select user type",
      "selectStores": "Select stores",
      "selectRoles": "Select roles",
      "rolesRequired": "Please select at least one role",
      "storesRequired": "Please select at least one store",
      "invalidUserType": "Selected user type is not allowed",
      "cannotCreateAdminAwfar": "You cannot create Admin Awfar users",
      "invalidEmail": "Please enter a valid email",
      "passwordMinLength": "Password must be at least 8 characters",
      "updatedSuccessfully": "User Updated Successfully",
      "savedSuccessfully": "User Saved Successfully",
      "failedUpdate": "Failed to update the User",
      "failedSave": "Failed to save the User"
    },
    "types": {
      "adminAwfar": "Admin Awfar",
      "adminCompany": "Admin Company",
      "agent": "Agent",
      "store": "Store"
    },
    "loadingStores": "Loading stores...",
    "selectedStores": "Selected {count} stores",
    "failedLoadStores": "Failed to load stores. Please try again.",
    "deselectedAllStores": "Deselected all stores",
    "loadingRoles": "Loading roles...",
    "selectedRoles": "Selected {count} roles",
    "failedLoadRoles": "Failed to load roles. Please try again.",
    "deselectedAllRoles": "Deselected all roles"
  },
  "customizeColumns": {
    "pageTitle": "Customize Columns",
    "previewTitle": "Preview: what this user will see",
    "views": {
      "orders": "Orders",
      "categories": "Categories"
    },
    "idAlwaysIncluded": "ID (always included)",
    "confirmEmptyTitle": "Save empty column selection?",
    "confirmEmpty": "This will hide almost all columns — only ID will remain visible. Continue?",
    "save": "Save",
    "cancel": "Cancel",
    "saveSuccess": "Column settings updated",
    "errors": {
      "forbidden": "You don't have permission to manage custom views for this user",
      "loadFailed": "Failed to load column settings",
      "invalidColumn": "One or more selected columns are not valid for this view",
      "saveFailed": "Failed to save column settings"
    }
  },
  "activities": {
    "type": "Type",
    "activity": "Activity",
    "complain": "Complain",
    "inquiry": "Inquiry",
    "tableTitle": "All Tickets",
    "noCreatePermission": "You don't have permission to create activities",
    "noShowPermission": "You don't have permission to view activities",
    "noTrackPermission": "You don't have permission to track activities",
    "noViewPermission": "You don't have permission to view activities",
    "id": "ID",
    "customerName": "Customer Name",
    "customer_phone": "Customer Phone",
    "agent": "Agent",
    "status": "Status",
    "department": "Department",
    "channel": "Channel",
    "details": "Details",
    "created_at": "Created At",
    "created_from": "Created From",
    "created_to": "Created To",
    "actions": "Actions",
    "show": "Show",
    "track": "Track",
    "previousComments": "Previous Comments",
    "By": " By",
    "all": "All",
    "search_customer": "Phone / Name",
    "search_product": "Product Name / Barcode",
    "store": "Store",
    "trackingInformation": "Tracking Information",
    "employer": "Employer",
    "timing": "Timing",
    "action": "Action",
    "value": "Value",
    "callChannel": {
      "actions": "Actions"
    },
    "modal": {
      "title": "Activity Details",
      "submit": "Submit",
      "cancel": "Cancel"
    },
    "fields": {
      "order_number": "Order Number",
      "customer_number": "Customer Number",
      "reason": "Reason",
      "section": "Section",
      "validity": "Validity",
      "branch": "Branch",
      "productBarcode": "Product Barcode",
      "productName": "Product Name",
      "last_date": "Last Date",
      "addReply": "Add Reply",
      "replyPlaceholder": "Enter your reply...",
      "attachFile": "Attach File",
      "attachment": "Attachment"
    },
    "statusOptions": {
      "open": "Open",
      "in_progress": "In Progress",
      "resolved": "Resolved"
    },
    "changeStatus": {
      "action": "Change Status",
      "title": "Change Status of Selected Tickets",
      "selectTickets": "Select tickets to change their status",
      "selectedTickets": "Selected Tickets",
      "mixedTypes": "Only tickets of the same type can be changed together",
      "unknownType": "This ticket's type is unknown, so its status cannot be changed in bulk",
      "statusRequired": "Please select a status",
      "success": "Ticket status updated successfully",
      "partialSuccess": "{{updated}} ticket(s) updated, {{failed}} failed",
      "selectedCount": "Selected tickets: {{total}}",
      "moreTickets": "and {{total}} more",
      "tooMany": "Up to {{max}} tickets can be changed at once. Narrow the selection and try again.",
      "error": "Failed to change the status of the selected tickets"
    }
  },
  "countries": {
    "noCreatePermission": "You don't have permission to create countries",
    "addModalTitle": "Add Country",
    "editModalTitle": "Edit Country",
    "createdSuccessfully": "Country created successfully",
    "updatedSuccessfully": "Country updated successfully",
    "failedSave": "Failed to save the country"
  },
  "cities": {
    "noCreatePermission": "You don't have permission to create cities",
    "addModalTitle": "Add City",
    "editModalTitle": "Edit City",
    "createdSuccessfully": "City created successfully",
    "updatedSuccessfully": "City updated successfully",
    "failedSave": "Failed to save the city",
    "importSuccess": "Cities imported successfully!",
    "importError": "Failed to import cities. Please try again.",
    "createOptions": {
      "title": "Add New City",
      "uploadGroup": {
        "title": "Upload Group Of Cities",
        "description": "Upload All Cities Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One City",
        "description": "Easily Add One City One By One"
      },
      "downloadSample": "Download Sample File"
    }
  },
  "areas": {
    "noCreatePermission": "You don't have permission to create areas",
    "addModalTitle": "Add Area",
    "editModalTitle": "Edit Area",
    "createdSuccessfully": "Area created successfully",
    "updatedSuccessfully": "Area updated successfully",
    "failedSave": "Failed to save the area",
    "importSuccess": "Areas imported successfully!",
    "importError": "Failed to import areas. Please try again.",
    "createOptions": {
      "title": "Add New Area",
      "uploadGroup": {
        "title": "Upload Group Of Areas",
        "description": "Upload All Areas Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Area",
        "description": "Easily Add One Area One By One"
      },
      "downloadSample": "Download Sample File"
    }
  },
  "regions": {
    "noCreatePermission": "You don't have permission to create regions",
    "addModalTitle": "Add Region",
    "editModalTitle": "Edit Region",
    "createdSuccessfully": "Region created successfully",
    "updatedSuccessfully": "Region updated successfully",
    "failedSave": "Failed to save the region",
    "showInApp": "Show In App",
    "importSuccess": "Regions imported successfully!",
    "importError": "Failed to import regions. Please try again.",
    "createOptions": {
      "title": "Add New Region",
      "uploadGroup": {
        "title": "Upload Group Of Regions",
        "description": "Upload All Regions Easily By Excel File"
      },
      "addSingle": {
        "title": "Add One Region",
        "description": "Easily Add One Region One By One"
      },
      "downloadSample": "Download Sample File"
    }
  },
  "locations": {
    "country": {
      "nameEn": "English Name",
      "nameAr": "Arabic Name",
      "code": "Country Code",
      "flag": "Flag"
    },
    "city": {
      "nameEn": "English Name",
      "nameAr": "Arabic Name"
    },
    "area": {
      "nameEn": "English Name",
      "nameAr": "Arabic Name"
    },
    "region": {
      "nameEn": "English Name",
      "nameAr": "Arabic Name"
    }
  },
  "offers": {
    "pageTitle": "All Offers",
    "createNew": "Create New Offer",
    "noCreatePermission": "You don't have permission to create offers",
    "offer_for": "Offer For",
    "for": "Offer For",
    "upload": {
      "title": "Upload Offers",
      "selectFile": "Select File",
      "fileRequired": "Please upload a file",
      "dragText": "Click or drag file to this area to upload",
      "hint": "Support for Excel and CSV files only",
      "upload": "Upload"
    },
    "import": {
      "success": "Offers import queued successfully",
      "partialSuccess": "{{imported}} offers imported, {{failed}} rows failed",
      "viewErrors": "View errors",
      "allFailed": "Import failed — no valid rows processed"
    },
    "columns": {
      "id": "Offer ID",
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "percentage": "Percentage",
      "expDate": "Exp Date",
      "type": "Type",
      "offerFor": "Offer For",
      "activation": "Activation",
      "actions": "Actions"
    },
    "filter": {
      "sortBy": "Sort By",
      "oldest": "Oldest",
      "newest": "Newest",
      "allBranches": "All Branches",
      "fromDate": "From Date",
      "expOfferDate": "Exp Offer Date",
      "activeOffersOnly": "Active Offers Only",
      "inactiveOffersOnly": "Inactive Offers Only",
      "offerType": "Offer Type",
      "allTypes": "All Types",
      "offerFor": "Offer For",
      "all": "All",
      "products": "Products",
      "categories": "Categories",
      "brands": "Brands",
      "group": "Group"
    },
    "types": {
      "special": "Special Offer",
      "percentage": "Percentage",
      "buyOneGetOne": "Buy One Get One",
      "buyOneGetPercentageOther": "Buy One Get Percentage Other",
      "buyOneGetOther": "Buy One Get Other One",
      "amount": "Amount",
      "buyOneGetPercentage": "Buy One Get Percentage"
    },
    "offerFor": {
      "product": "Product",
      "brand": "Brand",
      "category": "Category",
      "group": "Group",
      "for": "Offer For"
    },
    "activation": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "form": {
      "offerForRequired": "Please select offer for",
      "selectOfferFor": "Select Offer For",
      "arabicNameRequired": "Arabic name is required",
      "englishNameRequired": "English name is required",
      "arabicNamePlaceholder": "Enter Arabic name",
      "englishNamePlaceholder": "Enter English name",
      "startDateRequired": "Start date is required",
      "startDatePlaceholder": "Select start date",
      "expiredDateRequired": "Expired date is required",
      "expiredDatePlaceholder": "Select expired date",
      "totalOrderAmount": "Minimum Amount",
      "showInApp": "Show In App",
      "showInCrm": "Show In Crm",
      "allBranches": "All Branches",
      "status": "Status",
      "products": "Products",
      "productsRequired": "Please select products",
      "selectProducts": "Select Products",
      "type": "Type",
      "typeRequired": "Please select type",
      "typeNotAllowedForOfferFor": "This offer type is only available when the offer is for products or groups",
      "selectType": "Select Type",
      "percentage": "Percentage",
      "buyOneGetOne": "Buy One Get One",
      "buyOneGetPercentage": "Buy One Get Percentage",
      "buyOneGetOther": "Buy One Get Other One",
      "buyOneGetPercentageOther": "Buy One Get Percentage Other",
      "offerFor": "Offer For",
      "arabicName": "Arabic Name",
      "englishName": "English Name",
      "startDate": "Start Date",
      "expiredDate": "Expired Date",
      "amount": "Amount",
      "amountRequired": "Amount is required",
      "minAmount": "Min Amount",
      "minAmountRequired": "Min amount is required",
      "related": "Related",
      "lowPrice": "Low Price",
      "lowPriceRequired": "Low price is required",
      "groups": "Groups",
      "groupsRequired": "Please select groups",
      "selectGroups": "Select Groups",
      "categories": "Categories",
      "categoriesRequired": "Please select categories",
      "selectCategories": "Select Categories",
      "brands": "Brands",
      "brandsRequired": "Please select brands",
      "selectBrands": "Select Brands",
      "relatedProducts": "Related Products",
      "relatedProductsRequired": "Please select related products",
      "selectRelatedProducts": "Select Related Products",
      "relatedGroups": "Related Groups",
      "relatedGroupsRequired": "Please select related groups",
      "selectRelatedGroups": "Select Related Groups",
      "buyCount": "Buy Count",
      "buyCountRequired": "Please enter buy count",
      "buyCountPlaceholder": "Enter buy count",
      "getCount": "Get Count",
      "getCountRequired": "Please enter get count",
      "getCountPlaceholder": "Enter get count",
      "for": "Offer For"
    },
    "sections": {
      "offerDetails": "Offer Details",
      "buyDetails": "Buy Details"
    },
    "createGroupModal": {
      "title": "Create Offer Using Group",
      "offerFor": "Offer For",
      "offerType": "Offer Type",
      "uploadFile": "Upload File",
      "offerForRequired": "Please select offer for",
      "offerTypeRequired": "Please select offer type",
      "fileRequired": "Please upload a file",
      "selectOfferFor": "Select Offer For",
      "selectOfferType": "Select Offer Type",
      "dragFileText": "Click or drag file to this area to upload",
      "fileHint": "Support for Excel and CSV files only",
      "fileSelected": "File selected successfully",
      "fileUploadSuccess": "File uploaded successfully",
      "invalidFileType": "You can only upload Excel or CSV files!",
      "cancel": "Cancel",
      "create": "Create",
      "success": "Offers created successfully from group",
      "error": "Failed to create offers from group",
      "downloadSample": "Download Sample",
      "downloadSampleFile": "Download Sample File",
      "downloadSampleForType": "Download {{type}} Sample",
      "sampleDescription": "Download a sample Excel file based on the selected offer type to see the required format",
      "sampleDownloaded": "Sample file downloaded successfully",
      "sampleDownloadError": "Failed to download sample file",
      "selectBothFields": "Please select both Offer For and Offer Type before downloading sample",
      "invalidOfferType": "Invalid offer type selected"
    },
    "createOptions": {
      "title": "Add New Offers",
      "uploadFile": {
        "title": "Upload Group Of Offers",
        "description": "Upload All Offers Easily By Excel File"
      },
      "createOne": {
        "title": "Add One Offer",
        "description": "Easily Add One Offer One By One"
      },
      "createGroup": {
        "title": "Create Offer Using Group",
        "description": "Create offers by selecting offer type and uploading sheet"
      }
    },
    "updateSuccess": "Offer updated successfully!",
    "createSuccess": "Offer created successfully!",
    "updateError": "Failed to update offer",
    "createError": "Failed to create offer"
  },
  "offersGroup": {
    "pageTitle": "Offers Groups",
    "createNew": "Create New Offers Group",
    "editTitle": "Edit Offers Group",
    "noCreatePermission": "You don't have permission to create offers groups",
    "noEditPermission": "You don't have permission to edit offers groups",
    "columns": {
      "id": "Group ID",
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "productCount": "Product Count",
      "status": "Status",
      "actions": "Actions"
    },
    "form": {
      "name": "Name",
      "nameAr": "Name (Arabic)",
      "nameEn": "Name (English)",
      "nameArRequired": "Arabic name is required",
      "nameEnRequired": "English name is required",
      "nameArPlaceholder": "Enter Arabic name",
      "nameEnPlaceholder": "Enter English name",
      "productSelectionMethod": "Product Selection Method",
      "productSelection": "Product Selection Method",
      "selectProductMethod": "Select how to add products",
      "multiselect": "Multi-select Products",
      "fileUpload": "Upload File",
      "status": "Status",
      "products": "Products",
      "selectProducts": "Select Products",
      "productsRequired": "Please select products",
      "uploadFile": "Upload File",
      "downloadSample": "Download Sample",
      "downloadSampleFile": "Download Sample File",
      "sampleDescription": "Download the sample Excel file to see the required format for the products file",
      "dragFileText": "Click or drag file to this area to upload",
      "fileHint": "Support for Excel and CSV files only",
      "fileRequired": "Please upload a file",
      "fileSelected": "File selected successfully",
      "save": "Save",
      "cancel": "Cancel",
      "categories": "Categories",
      "categoriesRequired": "Please select categories",
      "selectCategories": "Select Categories",
      "brands": "Brands",
      "brandsRequired": "Please select brands",
      "selectBrands": "Select Brands",
      "relatedProducts": "Related Products",
      "relatedProductsRequired": "Please select related products",
      "selectRelatedProducts": "Select Related Products",
      "relatedGroups": "Related Groups",
      "relatedGroupsRequired": "Please select related groups",
      "selectRelatedGroups": "Select Related Groups"
    },
    "productSelectionOptions": {
      "multiselect": "Multi-select Products",
      "file": "Upload File"
    },
    "activation": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "messages": {
      "createdSuccessfully": "Offers group created successfully",
      "updatedSuccessfully": "Offers group updated successfully",
      "failedSave": "Failed to save offers group",
      "importing": "Importing products…",
      "importDone": "Products imported successfully",
      "importFailed": "Failed to import products",
      "invalidFileType": "Invalid file type. Please select an Excel or CSV file.",
      "fileTooLarge": "File is too large. Maximum size is 10MB."
    }
  },
  "customers": {
    "customerDetails": "Customer Details",
    "customerInformation": "Customer Information",
    "customerId": "Customer ID",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "birthdate": "Birthdate",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "registeredAt": "Registered At",
    "status": "Status",
    "blocked": "Blocked",
    "active": "Active",
    "addresses": "Addresses",
    "address": "Address",
    "default": "Default",
    "orders": "Orders",
    "actions": "Actions",
    "viewDetails": "View Details",
    "orderId": "Order ID",
    "orderDate": "Date",
    "orderStatus": "Status",
    "orderTotal": "Total",
    "activities": "Activities",
    "activityId": "ID",
    "activityDate": "Date",
    "activityType": "Type",
    "activityReason": "Reason",
    "activityNote": "Note",
    "inquiries": "Inquiries",
    "complaints": "Complaints",
    "loyaltyHistory": "Loyalty History",
    "loyaltyPoints": "Points",
    "loyaltyActivatedAt": "Activated At",
    "loyaltyExpiresAt": "Expires At",
    "mostOrderedProducts": "Most Ordered Products",
    "productImage": "Image",
    "productName": "Name",
    "productQuantity": "Total Quantity",
    "noOrders": "No orders found",
    "noActivities": "No activities found",
    "noInquiries": "No inquiries found",
    "noComplaints": "No complaints found",
    "noLoyaltyHistory": "No loyalty history found",
    "noProducts": "No products found",
    "noDataFound": "No customer data found",
    "errorLoadingCustomer": "Error Loading Customer",
    "errorLoadingDetails": "Failed to load customer details",
    "exportOrders": "Export Orders",
    "exportOrdersSuccess": "Orders exported successfully",
    "exportOrdersError": "Failed to export orders. Please try again."
  },
  "sections": {
    "offerDetails": "Offer Details",
    "buyDetails": "Buy Details"
  },
  "form": {
    "offerFor": "Offer For",
    "offerForRequired": "Please select offer for",
    "selectOfferFor": "Select Offer For",
    "arabicName": "Arabic Name",
    "arabicNameRequired": "Arabic name is required",
    "arabicNamePlaceholder": "Enter Arabic name",
    "englishName": "English Name",
    "englishNameRequired": "English name is required",
    "englishNamePlaceholder": "Enter English name",
    "startDate": "Start Date",
    "startDateRequired": "Start date is required",
    "startDatePlaceholder": "Select start date",
    "expiredDate": "Expired Date",
    "expiredDateRequired": "Expired date is required",
    "expiredDatePlaceholder": "Select expired date",
    "totalOrderAmount": "Minimum Amount",
    "showInApp": "Show In App",
    "showInCrm": "Show In Crm",
    "allBranches": "All Branches",
    "products": "Products",
    "productsRequired": "Please select products",
    "type": "Type",
    "typeRequired": "Please select type",
    "selectType": "Select Type",
    "percentage": "Percentage",
    "amount": "Amount",
    "amountRequired": "Amount is required",
    "related": "Related",
    "selectProducts": "Select Products"
  },
  "types": {
    "amount": "Amount",
    "percentage": "Percentage",
    "buyOneGetOne": "Buy One Get One",
    "buyOneGetPercentage": "Buy One Get Percentage"
  },
  "saveAndAddMore": "Save And Add More",
  "createSuccess": "Offer created successfully",
  "createError": "Failed to create offer",
  "failedOfferImports": {
    "title": "Failed Offer Imports",
    "pageTitle": "All Failed Offer Imports",
    "columns": {
      "id": "ID",
      "fileName": "File Name",
      "batchId": "Batch ID",
      "errorType": "Error Type",
      "errorMessage": "Error Message",
      "date": "Date",
      "actions": "Actions"
    },
    "errorTypes": {
      "validation": "Validation",
      "processing": "Processing"
    },
    "statistics": {
      "totalFailures": "Total Failures",
      "validationErrors": "Validation Errors",
      "processingErrors": "Processing Errors",
      "filesWithErrors": "Files with Errors"
    },
    "filters": {
      "searchPlaceholder": "Search by file name or error message",
      "batchIdPlaceholder": "Filter by batch ID",
      "batchFilterActive": "Showing failures for batch: {{batchId}}",
      "errorTypePlaceholder": "Error Type",
      "dateRangePlaceholderStart": "Start Date",
      "dateRangePlaceholderEnd": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "export": "Export",
      "clearAll": "Clear All",
      "viewDetails": "View Details",
      "delete": "Delete"
    },
    "messages": {
      "deleteConfirm": "Delete Failed Import",
      "deleteConfirmContent": "Are you sure you want to delete this failed import?",
      "clearAllConfirm": "Clear All Failed Imports",
      "clearAllConfirmContent": "Are you sure you want to clear all failed imports? This action cannot be undone.",
      "deleteSuccess": "Failed import deleted successfully",
      "deleteError": "Failed to delete import",
      "clearAllSuccess": "All failed imports cleared successfully",
      "clearAllError": "Failed to clear imports",
      "exportNotAvailable": "Export functionality not available yet",
      "loadError": "Failed to fetch failed offer imports",
      "noData": "No failed imports found"
    },
    "details": {
      "title": "Failed Import Details",
      "importInformation": "Import Information",
      "errorDetails": "Error Details",
      "rowData": "Row Data",
      "fields": {
        "id": "ID",
        "fileName": "File Name",
        "errorType": "Error Type",
        "date": "Date",
        "rowNumber": "Row Number"
      }
    },
    "rowSummary": {
      "title": "Most Common Failed Rows",
      "noData": "No row number data available",
      "rowLabel": "Row",
      "failuresLabel": "failure",
      "description": "These Excel row numbers failed most frequently. Open your Excel file and check these specific rows first.",
      "failureCount": "Failure Count",
      "failure": "failure",
      "failures": "failures"
    }
  },
  "failedCategoryImports": {
    "title": "Failed Category Imports",
    "pageTitle": "All Failed Category Imports",
    "columns": {
      "id": "ID",
      "fileName": "File Name",
      "batchId": "Batch ID",
      "errorType": "Error Type",
      "errorMessage": "Error Message",
      "date": "Date",
      "actions": "Actions"
    },
    "errorTypes": {
      "validation": "Validation",
      "processing": "Processing"
    },
    "statistics": {
      "totalFailures": "Total Failures",
      "validationErrors": "Validation Errors",
      "processingErrors": "Processing Errors",
      "filesWithErrors": "Files with Errors"
    },
    "filters": {
      "searchPlaceholder": "Search by file name or error message",
      "errorTypePlaceholder": "Error Type",
      "dateRangePlaceholderStart": "Start Date",
      "dateRangePlaceholderEnd": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "export": "Export",
      "clearAll": "Clear All",
      "viewDetails": "View Details",
      "delete": "Delete",
      "readMore": "Read more",
      "copy": "Copy to clipboard",
      "close": "Close"
    },
    "messages": {
      "deleteConfirm": "Delete Failed Import",
      "deleteConfirmContent": "Are you sure you want to delete this failed import?",
      "clearAllConfirm": "Clear All Failed Imports",
      "clearAllConfirmContent": "Are you sure you want to clear all failed imports? This action cannot be undone.",
      "deleteSuccess": "Failed import deleted successfully",
      "deleteError": "Failed to delete import",
      "clearAllSuccess": "All failed imports cleared successfully",
      "clearAllError": "Failed to clear imports",
      "exportNotAvailable": "Export functionality not available yet",
      "loadError": "Failed to fetch failed category imports",
      "noData": "No failed imports found",
      "copySuccess": "Error message copied to clipboard",
      "copyError": "Failed to copy error message"
    },
    "details": {
      "title": "Failed Import Details",
      "importInformation": "Import Information",
      "errorDetails": "Error Details",
      "rowData": "Row Data",
      "fields": {
        "id": "ID",
        "fileName": "File Name",
        "errorType": "Error Type",
        "date": "Date",
        "rowNumber": "Row Number"
      }
    },
    "rowSummary": {
      "title": "Most Common Failed Rows",
      "noData": "No row number data available",
      "rowLabel": "Row",
      "failuresLabel": "failure",
      "description": "These Excel row numbers failed most frequently. Open your Excel file and check these specific rows first.",
      "failureCount": "Failure Count",
      "failure": "failure",
      "failures": "failures"
    }
  },
  "integrationMonitoring": {
    "title": "Integration Monitoring",
    "actions": {
      "refresh": "Refresh",
      "viewDetails": "View Details"
    },
    "summary": {
      "title": "Health Summary",
      "window": "Window",
      "hours": "{{count}} hours",
      "lastRun": "Last run",
      "showLogs": "Show logs",
      "empty": "No integration ran in this window. Types with no activity are absent, not zeroed."
    },
    "stuck": {
      "title": "Stuck Integrations",
      "threshold": "Pending longer than",
      "minutes": "{{count}} minutes",
      "alert": "{{count}} integration(s) stuck pending. Nothing will retry them.",
      "oldest": "Oldest",
      "capped": "Showing {{returned}} of {{count}} — the list is capped at 50 rows, oldest first.",
      "none": "No stuck integrations in this threshold."
    },
    "list": {
      "title": "Logs"
    },
    "filters": {
      "type": "Integration type",
      "status": "Status",
      "objectId": "Object ID (pair with a type)",
      "from": "From",
      "to": "To",
      "reset": "Reset"
    },
    "columns": {
      "id": "ID",
      "type": "Type",
      "status": "Status",
      "objectId": "Object ID",
      "companyId": "Company ID",
      "responsePreview": "Response Preview",
      "createdAt": "Started At",
      "updatedAt": "Finished At",
      "actions": "Actions"
    },
    "table": {
      "wholeRun": "run"
    },
    "statuses": {
      "pending": "Pending",
      "success": "Success",
      "failed": "Failed",
      "unknown": "Unknown"
    },
    "types": {
      "dms_order_integration": "Order push to shams DMS",
      "odoo_order_push_integration": "Order push to Odoo",
      "odoo_order_pull_integration": "Order import from Odoo",
      "odoo_order_status_push_integration": "Order status push to Odoo",
      "odoo_order_status_pull_integration": "Order status pull from Odoo",
      "odoo_customer_push_integration": "Customer push to Odoo",
      "odoo_customer_pull_integration": "Customer import from Odoo",
      "odoo_product_pull_integration": "Product and stock sync",
      "odoo_category_pull_integration": "Category sync",
      "odoo_store_pull_integration": "Branch sync",
      "odoo_location_pull_integration": "City / area / region sync"
    },
    "details": {
      "title": "Integration Log Details",
      "payload": "Response Payload",
      "wholeRun": "Whole run (no single record)",
      "personalDataWarning": "This payload is whatever the remote system returned. For customer and address pushes it can contain names, phone numbers and addresses — do not copy it into a less protected place.",
      "truncated": "This payload hit the 60 KB storage cap and is stored truncated.",
      "noPayload": "No payload yet — it is written when the remote call comes back."
    }
  },
  "failedProductImports": {
    "title": "Failed Product Imports",
    "pageTitle": "All Failed Product Imports",
    "columns": {
      "id": "ID",
      "fileName": "File Name",
      "errorType": "Error Type",
      "errorMessage": "Error Message",
      "date": "Date",
      "actions": "Actions"
    },
    "errorTypes": {
      "validation": "Validation",
      "processing": "Processing"
    },
    "statistics": {
      "totalFailures": "Total Failures",
      "validationErrors": "Validation Errors",
      "processingErrors": "Processing Errors",
      "filesWithErrors": "Files with Errors"
    },
    "filters": {
      "searchPlaceholder": "Search by file name or error message",
      "errorTypePlaceholder": "Error Type",
      "dateRangePlaceholderStart": "Start Date",
      "dateRangePlaceholderEnd": "End Date"
    },
    "actions": {
      "refresh": "Refresh",
      "export": "Export",
      "clearAll": "Clear All",
      "viewDetails": "View Details",
      "delete": "Delete"
    },
    "messages": {
      "deleteConfirm": "Delete Failed Import",
      "deleteConfirmContent": "Are you sure you want to delete this failed import?",
      "clearAllConfirm": "Clear All Failed Imports",
      "clearAllConfirmContent": "Are you sure you want to clear all failed imports? This action cannot be undone.",
      "deleteSuccess": "Failed import deleted successfully",
      "deleteError": "Failed to delete import",
      "clearAllSuccess": "All failed imports cleared successfully",
      "clearAllError": "Failed to clear imports",
      "exportSuccess": "Export completed successfully",
      "exportError": "Failed to export data",
      "loadError": "Failed to fetch failed product imports",
      "noData": "No failed imports found"
    },
    "details": {
      "title": "Failed Import Details",
      "importInformation": "Import Information",
      "errorMessage": "Error Message",
      "rowData": "Row Data",
      "validationErrors": "Validation Errors",
      "fields": {
        "id": "ID",
        "fileName": "File Name",
        "errorType": "Error Type",
        "date": "Date",
        "companyId": "Company ID",
        "field": "Field",
        "value": "Value"
      }
    },
    "rowSummary": {
      "title": "Most Common Failed Excel Row Numbers",
      "description": "These Excel row numbers failed most frequently. Open your Excel file and check these specific rows first.",
      "failureCount": "Failure Count",
      "failure": "failure",
      "failures": "failures"
    }
  },
  "tickets": {
    "fields": {
      "customerPhone": "Customer Phone",
      "customerName": "Customer Name",
      "orderId": "Order ID",
      "last_date": "Last Date",
      "agentName": "Agent Name"
    },
    "channels": "Channels",
    "reasons": "Reasons",
    "branches": "Branches",
    "validity": "Validity",
    "details": "Details",
    "createActivity": "Create Activity",
    "createComplaint": "Create Complaint",
    "createInquiry": "Create Inquiry",
    "savedSuccessfully": "Ticket saved successfully",
    "failedSave": "Failed to save ticket",
    "saveNotConfirmed": "The request took too long to confirm. Check the activities list before submitting again."
  },
  "activityReasons": {
    "tableTitle": "All Reasons",
    "sections": "Sections",
    "savedSuccessfully": "Activity Reasons Saved Successfully",
    "failedSave": "Failed to save the activity Reasons",
    "editActivityReasons": "Edit Activity Reasons",
    "addActivityReasons": "Create New Reasons",
    "noCreatePermission": "You don't have permission to create activity reasons"
  },
  "paymentSettings": {
    "savedSuccessfully": "Payment Settings Saved Successfully",
    "failedSave": "Failed to save the payment settings"
  },
  "notificationSounds": {
    "title": "Notification Sounds",
    "uploadFile": "Upload",
    "changeFile": "Change",
    "play": "Play",
    "playCurrent": "Play current sound",
    "noChanges": "No changes to save",
    "savedSuccessfully": "Notification sounds saved successfully",
    "saveFailed": "Failed to save notification sounds",
    "fetchFailed": "Failed to load notification sounds",
    "maxFileSizeHint": "Maximum allowed file size: 800 KB.",
    "fileTooLarge": "File size exceeds the maximum allowed size of 800 KB."
  },
  "deliveryManagement": {
    "title": "Delivery Management",
    "useShopper": "Use Shopper",
    "hasCustody": "Has Custody",
    "save": "Save",
    "savedSuccessfully": "Delivery management saved successfully",
    "failedSave": "Failed to save delivery management"
  },
  "exportReports": {
    "title": "Export Reports",
    "savedSuccessfully": "Export reports settings saved successfully",
    "saveFailed": "Failed to save export reports settings",
    "fetchFailed": "Failed to load export reports settings",
    "name": "Report Name",
    "id": "Report ID",
    "group": "Group",
    "status": "Status",
    "companySectionTitle": "Company Export Reports",
    "userSectionTitle": "Assign Reports to a User",
    "selectUserTitle": "Select User",
    "userReportsTitle": "User Export Reports",
    "selectAll": "Select All Reports",
    "deselectAll": "Deselect All",
    "selectUser": "User",
    "selectUserPlaceholder": "Select a user",
    "selectUserFirst": "Select a user to manage their report access",
    "userHelp": "Checked reports are the ones this user can access and export. Uncheck a report to block it for this user; all reports checked means full access.",
    "userSavedSuccessfully": "User report access saved successfully",
    "userSaveFailed": "Failed to save user report access",
    "userFetchFailed": "Failed to load user report access",
    "complaintResponses": {
      "title": "Complaint Responses Report",
      "dateRange": "Date Range",
      "search": "Search",
      "noData": "No data found for the selected date range",
      "selectDateFirst": "Please select a date range first",
      "fetchFailed": "Failed to load the Complaint Responses Report",
      "viewAttachment": "View",
      "columns": {
        "complaintId": "Complaint ID",
        "type": "Type",
        "agentName": "Agent Name",
        "customerPhone": "Customer Phone",
        "customerName": "Customer Name",
        "customerId": "Customer ID",
        "storeName": "Store Name",
        "activityType": "Activity Type",
        "callChannel": "Call Channel",
        "complaintDetails": "Complaint Details",
        "status": "Status",
        "section": "Section",
        "lastDate": "Last Date",
        "orderId": "Order ID",
        "isValid": "Is Valid",
        "productName": "Product Name",
        "productBarcode": "Product Barcode",
        "complaintCreatedAt": "Complaint Created At",
        "commentId": "Comment ID",
        "responseComment": "Response Comment",
        "responseAgentName": "Response Agent Name",
        "responseCreatedAt": "Response Created At",
        "responseUpdatedAt": "Response Updated At",
        "attachmentUrl": "Attachment"
      }
    },
    "chooseReportType": "Choose Type Of Report",
    "chooseReportTypePlaceholder": "Choose Type Of Report",
    "inquiryResponses": {
      "title": "Inquiry Responses Report",
      "selectDateLabel": "Date Range",
      "selectDate": "Please select a date range",
      "selectTypeAndDate": "Please select a report type and date range",
      "search": "Search",
      "searchCompleted": "Search completed",
      "searchFailed": "Search failed",
      "noDataFound": "No data found",
      "viewAttachment": "View",
      "inquiry_id": "Inquiry ID",
      "type": "Type",
      "agent_name": "Agent Name",
      "customer_phone": "Customer Phone",
      "customer_name": "Customer Name",
      "customer_id": "Customer ID",
      "store_name": "Store Name",
      "activity_type": "Activity Type",
      "call_channel": "Call Channel",
      "inquiry_details": "Inquiry Details",
      "status": "Status",
      "section": "Section",
      "last_date": "Last Date",
      "order_id": "Order ID",
      "is_valid": "Is Valid",
      "product_name": "Product Name",
      "product_barcode": "Product Barcode",
      "inquiry_created_at": "Inquiry Created At",
      "comment_id": "Comment ID",
      "response_comment": "Response Comment",
      "response_agent_name": "Response Agent Name",
      "response_created_at": "Response Created At",
      "response_updated_at": "Response Updated At",
      "attachment_url": "Attachment"
    }
  },
  "exportLogs": {
    "title": "Export Logs",
    "employeeName": "Employee Name",
    "allEmployees": "All Employees",
    "reportType": "Report Type",
    "selectReportType": "Select a report type",
    "downloadDate": "Download Date",
    "from": "From",
    "to": "To",
    "filter": "Filter",
    "employee": "Employee",
    "reportName": "Report Name",
    "dateFrom": "Date From",
    "dateTo": "Date To",
    "downloadedAt": "Downloaded At",
    "fetchFailed": "Failed to load download history"
  },
  "payment": {
    "edit": "Edit",
    "set": "Set",
    "createNewGateway": "Create New Payment Gateway",
    "editCredentials": "Edit {gateway}'s Credentials",
    "callbackInstruction": "* Please insert this link in {gateway}'s payment Integrations panel:",
    "apiKey": "API Key",
    "hmacSecret": "hmac Secret",
    "iframeId": "iFrame id",
    "integrationId": "Integration id",
    "enterApiKey": "Enter API key",
    "enterHmacSecret": "Enter hmac Secret",
    "enterIframeId": "Enter iFrame ID",
    "enterIntegrationId": "Enter Integration ID",
    "apiKeyRequired": "API Key is required",
    "hmacSecretRequired": "hmac Secret is required",
    "iframeIdRequired": "iFrame ID is required",
    "integrationIdRequired": "Integration ID is required",
    "credentialsSaved": "Credentials Saved Successfully",
    "credentialsSaveFailed": "Failed to save credentials",
    "gatewayCreated": "Payment Gateway Created Successfully",
    "gatewayCreateFailed": "Failed to create payment gateway",
    "uploadLogo": "Upload Logo",
    "clickOrDrag": "Click or drag file to this area to upload",
    "logoHint": "Support for a single file upload",
    "nameEn": "Name En",
    "nameAr": "Name Ar",
    "nameEnRequired": "Please enter English name",
    "nameArRequired": "Please enter Arabic name",
    "unsupportedGateway": "This gateway configuration is not supported yet.",
    "fieldRequired": "{field} is required",
    "enterField": "Enter {field}",
    "gatewayCredentials": "Gateway Credentials",
    "api_key": "API Key",
    "integration_id": "Integration ID",
    "iframe_id": "iFrame ID",
    "hmac_secret": "HMAC Secret",
    "entityId": "Entity ID",
    "access_token": "Access Token",
    "authorization": "Authorization",
    "logo": "Logo"
  },
  "reportsDashboard": {
    "title": "Dashboard",
    "dateRange": "Date Range",
    "store": "Store",
    "allStores": "All Stores",
    "applyFilters": "Apply Filters",
    "selectDateRange": "Please select a date range",
    "fetchError": "Failed to fetch dashboard data",
    "noData": "No data available",
    "congratulations": "Congratulations",
    "bestStoreSeller": "Best store seller of the period",
    "ordersThisPeriod": "{{count}} orders this period",
    "soldProducts": "Sold Products",
    "newCustomers": "New Customers",
    "salesByMonth": "Orders & Sales by Month",
    "salesByArea": "Sales by Area",
    "ordersCount": "Orders",
    "totalSales": "Total Sales",
    "ordersCountLabel": "{{count}} orders",
    "branchPerformance": "Branch Performance",
    "branchPerformanceSubtitle": "Real-time metrics for regional operations",
    "totalTickets": "Total Tickets",
    "inquiries": "Inquiries",
    "complaints": "Complaints",
    "activities": "Activities",
    "openTickets": "Open Tickets",
    "closedTickets": "Closed Tickets",
    "totalOrders": "Total Orders"
  },
  "reports": {
    "title": "Export Reports",
    "otherInsuranceCompany": "Other Insurance Company",
    "chooseReportType": "Choose Type Of Report",
    "chooseReportTypePlaceholder": "Select",
    "chooseReportTypeDescription": "Choose Type Of Report. The Data Is Processed Based On Your Choice",
    "noReportTypeFound": "No matching report",
    "selectDate": "Select Date",
    "store": "Store",
    "storePlaceholder": "All Stores",
    "search": "Search",
    "reportName": "Report Name",
    "exportPageToExcel": "Export Page To CSV",
    "exportAllToExcel": "Export All To CSV",
    "noDataFound": "No Data Found, Select The Filters Above And Search!",
    "yes": "Yes",
    "no": "No",
    "searchCompleted": "Search completed successfully!",
    "exportCompleted": "Export completed successfully!",
    "searchFailed": "Search failed. Please try again.",
    "exportFailed": "Export failed. Please try again.",
    "selectReportTypeAndDate": "Please select report type and date range",
    "notifyStatus": "Notify status",
    "notifyStatusPending": "Pending",
    "notifyStatusSent": "Sent",
    "notifyStatusAll": "All",
    "notifyMeSearchPlaceholder": "Search product (e.g. panadol)",
    "resetInquiry": "Reset inquiry",
    "resetInquirySuccess": "Inquiry reset successfully",
    "resetInquiryFailed": "Failed to reset inquiry",
    "resetInquiryInvalidRow": "Missing store or product in this row",
    "resetInquiryPendingConfig": "Reset inquiry API is not configured yet",
    "fileDownloaded": "File downloaded successfully",
    "fileEmpty": "The downloaded file is empty. Please try again.",
    "downloadFailed": "Download failed. Please try again.",
    "reportTypes": {
      "orderReport": "Order Report",
      "cancelOrders": "Cancel Orders",
      "orderItemsReport": "Order Items Report",
      "inquiryReport": "Inquiry Report",
      "complaintReport": "Complaint Report",
      "complaintResponsesReport": "Complaint Responses Report",
      "activityReport": "Activity Report",
      "allTicketReport": "All Ticket Report",
      "allAgentTicketCountReport": "All Agent Ticket Count Report",
      "masterDataReport": "Master Data Report",
      "offerReport": "Offer Report",
      "categoriesReport": "Categories Report",
      "brandsReport": "Brands Report",
      "customerOrdersReport": "Customer Orders Report",
      "itemSalesReport": "Item Sales Report",
      "itemSalesByStoreReport": "Item Sales By Store Report",
      "productsStockReport": "Products Stock Report",
      "orderItemsDiscountReport": "Order Items Discount Report",
      "promoCodeReport": "PromoCode Report",
      "promoCodeCountReport": "PromoCode Count Report",
      "newOrderItemsReport": "New Order Items Report",
      "transferReport": "Transfer Report",
      "inactiveCustomers": "Inactive Customers",
      "totalSupportQuestionsResponsesReport": "Total Support Questions & Responses Report",
      "supportQuestionsResponsesReport": "Support Questions & Responses Report",
      "notificationReport": "Notification Report",
      "customerReport": "Customer Report",
      "inquiryResponsesReport": "Inquiry Responses Report",
      "attributeReport": "Attribute Report",
      "extrasReport": "Extras Report",
      "trackNotifyProductRequests": "Lost Sales",
      "collectorPerformanceReport": "Collector Performance",
      "deliveryPerformanceReport": "Delivery Performance"
    },
    "companyReport": {
      "title": "Company report",
      "filter": "Filter",
      "loadError": "Could not load company report. Check the API route or try again.",
      "orders": "Orders",
      "customers": "Customers",
      "canceledOrders": "Canceled orders",
      "collectedOrders": "Collected orders",
      "soldProducts": "Sold products",
      "totalAmount": "Total amount",
      "complaints": "Complaints",
      "enquiries": "Enquiries",
      "mostSellingProducts": "Most selling products",
      "leastSellingProducts": "Least selling products",
      "avgTimeOrderComplete": "Average Time to Complete an Order",
      "avgTimeOrderCollected": "Average Time to Collect an Order",
      "avgTimeOrderToShopper": "Average delivery time",
      "topCustomers": "Top customers",
      "customersNoOrders": "Customers with no orders",
      "customer": "Customer",
      "phone": "Phone",
      "ordersNum": "Orders no.",
      "shoppers": "Shoppers",
      "agentActions": "Agent actions",
      "name": "Name",
      "branch": "Branch",
      "action": "Action",
      "date": "Date",
      "cancelledOrders": "Cancelled orders",
      "id": "ID",
      "agent": "Agent",
      "comment": "Comment",
      "deliveredToArea": "Delivered to area",
      "callChannel": "Call channel",
      "sales": "Sales",
      "noData": "No data",
      "scopeType": "Scope type",
      "scopeCompany": "Company",
      "scopeAgent": "Agent",
      "scopeStore": "Store",
      "scopeStorePlaceholder": "Select store",
      "scopeAgentPlaceholder": "Select agent",
      "scopeIdRequired": "Please select a store or an agent"
    },
    "storeCompare": {
      "title": "Store Compare",
      "filter": "Search",
      "loadError": "Failed to load store comparison.",
      "storesRequired": "Please select at least one branch.",
      "storesPlaceholder": "Select branches",
      "collectedOrders": "Collected Orders",
      "totalSalesPerBranch": "Total Sales per Branch",
      "mostSelling": "Most Selling",
      "leastSelling": "Least Selling",
      "callChannel": "Call Channel",
      "enquiries": "Enquiries",
      "complains": "Complaints",
      "branch": "Branch",
      "product": "Product",
      "quantity": "Quantity",
      "channel": "Channel",
      "count": "Count"
    },
    "growthReport": {
      "title": "Growth Report",
      "loadError": "Failed to load growth report.",
      "vsYear": "vs {{year}}",
      "totalOrders": "Total Orders {{year}}",
      "totalRevenue": "Total Revenue {{year}}",
      "avgBasket": "Average Order Value {{year}}",
      "basketSize": "Basket Size",
      "newCustomers": "New Customers {{year}}",
      "ordersMonthly": "Monthly Orders",
      "revenueMonthly": "Monthly Revenue",
      "basketMonthly": "Average Order Value (Basket Size) Monthly",
      "customersMonthly": "Monthly New Customers",
      "activitiesMonthly": "Activities & Inquiries Monthly",
      "notificationsMonthly": "Sent Notifications Monthly",
      "monthlySummary": "Comparative Monthly Summary",
      "activity": "Activity",
      "inquiry": "Inquiry",
      "complaint": "Complaint",
      "month": "Month",
      "orders": "Orders",
      "revenue": "Revenue",
      "avgOrder": "Avg. Order",
      "newCustomersShort": "New Customers",
      "notifications": "Notifications"
    },
    "productReport": {
      "title": "Products Report",
      "loadError": "Failed to load products report.",
      "allStores": "All Stores",
      "show": "Show",
      "uniqueProductsCard": "Unique Products",
      "totalItems": "Total Items",
      "totalRevenue": "Total Revenue",
      "avgQtyPerLine": "Avg. Qty / Line",
      "tabProducts": "Products",
      "tabBrands": "Brands",
      "tabCategories": "Categories",
      "mostOrdered": "Most Ordered",
      "leastOrdered": "Least Ordered",
      "topRevenue": "Top Revenue",
      "topBrands": "Top Brands",
      "brandRevenue": "Brand Revenue",
      "topCategories": "Top Categories",
      "categoryRevenue": "Category Revenue",
      "name": "Name",
      "barcode": "Barcode",
      "ordersCount": "Orders",
      "totalQty": "Total Qty",
      "avgQty": "Avg. Qty",
      "revenue": "Revenue",
      "uniqueProducts": "Unique Products",
      "brand": "Brand",
      "category": "Category"
    },
    "customerReport": {
      "title": "Customers Report",
      "loadError": "Failed to load customers report.",
      "allStores": "All Stores",
      "show": "Show",
      "days": "days",
      "uniqueCustomers": "Unique Customers",
      "totalOrders": "Total Orders",
      "avgOrder": "Avg. Order Value",
      "dormant": "Dormant",
      "dormantHint": "Customers whose last order is older than {{days}} days.",
      "tabTop": "Top Customers",
      "tabDormant": "Dormant",
      "tabNewVsReturning": "New vs Returning",
      "name": "Name",
      "phone": "Phone",
      "ordersCount": "Orders",
      "totalSpent": "Total Spent",
      "lastOrder": "Last Order",
      "month": "Month",
      "newCustomers": "New Customers",
      "returningCustomers": "Returning Customers"
    },
    "orderAnalytics": {
      "title": "Order Analytics",
      "loadError": "Failed to load order analytics.",
      "allStores": "All Stores",
      "show": "Show",
      "totalOrders": "Total Orders",
      "cancelledOrders": "Cancelled Orders",
      "cancelRate": "Cancel Rate",
      "lostRevenue": "Lost Revenue",
      "tabCancellations": "Cancellations",
      "tabPeak": "Peak Hours",
      "tabTrend": "Daily Trend",
      "byReason": "Cancellations by Reason",
      "byStore": "Cancellations by Branch",
      "reason": "Reason",
      "count": "Count",
      "store": "Branch",
      "cancelled": "Cancelled",
      "total": "Total",
      "revenue": "Revenue",
      "peakHint": "Orders by weekday and hour",
      "intensity": "Intensity",
      "days": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      }
    },
    "revenueReport": {
      "title": "Revenue Report",
      "loadError": "Failed to load revenue report.",
      "allStores": "All Stores",
      "show": "Show",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "currentRevenue": "Revenue (current)",
      "currentOrders": "Orders (current)",
      "aov": "Avg. Order Value",
      "prevRevenue": "Revenue (previous)",
      "vsPrev": "vs previous period",
      "trendTitle": "Revenue Trend",
      "paymentMethods": "Revenue by Payment Method",
      "detailTable": "Detailed Breakdown",
      "method": "Method",
      "count": "Orders",
      "revenue": "Revenue",
      "orders": "Orders",
      "period": "Period"
    }
  },
  "addOrder": {
    "enterText": "Enter text",
    "enterNumber": "Enter number",
    "selectOption": "Select option",
    "date": "Date",
    "time": "Time",
    "cashOnDelivery": "Cash On Delivery",
    "visaOnDelivery": "Visa On Delivery",
    "paymentLink": "Payment Link",
    "deliveryTitleAndTime": "Delivery Date & Time",
    "selectCustomerFirst": "No Selected Customer to Make Order",
    "staleOrderTitle": "Agent, Take care!",
    "staleOrderMessage": "{{name}} has an order created today.",
    "selectCustomerToViewProducts": "Please select a customer to view products and start creating an order",
    "selectAddressFirst": "Please Select Address",
    "selectAddressToViewProducts": "Please select an address to view products for delivery",
    "selectStoreFirst": "Please Select Store",
    "selectStoreToViewProducts": "Please select a store to view products",
    "loadingProducts": "Loading Products...",
    "loadingProductsDescription": "Loading products and applying filters, please wait...",
    "stockLimitReached": "Stock limit reached",
    "quantityInvalid": "Enter a valid quantity",
    "quantityBelowMinimum": "Quantity must be at least {{count}} (configured minimum)",
    "offerQuantityAdjusted": "Offer quantity adjusted to {{quantity}}",
    "offerQuantityEditInModal": "This product has an offer applied. Please open the product to edit its quantity.",
    "qtyLabel": "QTY",
    "cartItemOutOfStock": "Out of stock",
    "cartItemExceedsStock": "Quantity exceeds available stock ({{stock}})",
    "insufficientStock": "Insufficient stock for this product",
    "emptyCart": "No Items in Cart",
    "emptyCartDescription": "Add products to the cart to see them here",
    "loadingCart": "Loading Cart...",
    "loadingCartDescription": "Loading cart items, please wait...",
    "searchByProductName": "Search by product name",
    "allCategories": "All Categories",
    "offers": "Offers",
    "noImage": "No Image",
    "offer": "Offer",
    "inStock": "In Stock",
    "outOfStock": "Out of Stock",
    "notifyMe": "Notify Me",
    "notifyMeSubscribed": "Subscribed",
    "notifyMeSuccess": "You will be notified when this product is back in stock",
    "notifyMeFailed": "Failed to subscribe for stock notification",
    "noProductsFound": "No products found",
    "noProductsAvailable": "No products available",
    "tryDifferentFilter": "Try adjusting your filters or search terms",
    "proceedToPay": "Proceed To Pay",
    "backToOrder": "← Back To Order",
    "originalPrice": "Original Price",
    "discount": "Discount",
    "editCustomer": "Edit Customer",
    "updateChanges": "Update Changes",
    "cancel": "Cancel",
    "name": "Name",
    "gender": "Gender",
    "nameRequired": "Please enter customer name",
    "genderRequired": "Please select gender",
    "enterName": "Enter customer name",
    "selectGender": "Select gender",
    "male": "Male",
    "female": "Female",
    "phoneInvalid": "Please enter a valid phone number",
    "customerUpdatedSuccessfully": "Customer updated successfully",
    "customerUpdateFailed": "Failed to update customer",
    "selectAddress": "Select Address",
    "addNewCustomer": "Add New Customer",
    "addCustomer": "Add Customer",
    "customerInformation": "Customer Information",
    "writeCustomerName": "Write Customer Name",
    "chooseGender": "Choose Gender",
    "writePhoneNumber": "Write Phone Number",
    "additionalPhone": "Additional Phone",
    "area": "Area",
    "region": "Region",
    "areaRequired": "Please select area",
    "regionRequired": "Please select region",
    "chooseArea": "Choose Area",
    "chooseRegion": "Choose Region",
    "downtown": "Downtown",
    "suburbs": "Suburbs",
    "industrial": "Industrial",
    "north": "North",
    "south": "South",
    "east": "East",
    "west": "West",
    "free": "Free",
    "comment": "Comment",
    "addComment": "Add a comment...",
    "totalItems": "Total Items",
    "clearAll": "Clear All",
    "cartCleared": "Cart cleared successfully",
    "errorClearingCart": "Failed to clear cart",
    "subTotal": "Sub Total",
    "deliveryFees": "Delivery Fees",
    "deliveryFeePending": "Select delivery time",
    "deliveryFeeResolving": "Calculating…",
    "deliveryFeeNotResolved": "Please select a delivery time to calculate delivery fees",
    "products": "Products",
    "items": "Items",
    "delivery": "Delivery",
    "pickup": "Pickup",
    "storePickupOnly": "This store is pickup only. Delivery is not available.",
    "storeDeliveryOnly": "This store is delivery only. Pickup is not available.",
    "fulfillmentTypeMismatch": "The selected fulfillment type is not allowed for this store.",
    "paymentMethod": "Payment Method",
    "deliveryTime": "Delivery Time",
    "pickupTime": "Pickup Time",
    "notes": "Notes",
    "customerRequired": "Please select a customer",
    "phoneRequired": "Please enter phone number",
    "addressRequired": "Please enter address",
    "pickupLocationRequired": "Please enter pickup location",
    "paymentMethodRequired": "Please select payment method",
    "noPaymentMethodsEnabled": "No payment methods are enabled for checkout. Enable at least one in Company → Payment Settings.",
    "apartmentNumberRequired": "Please enter apartment number",
    "floorRequired": "Please enter floor number",
    "selectCustomer": "Select Customer",
    "noCustomersFound": "No customers found",
    "enterPhone": "Enter phone number",
    "enterAddress": "Enter delivery address",
    "enterPickupLocation": "Enter pickup location",
    "selectPaymentMethod": "Select payment method",
    "enterDeliveryTime": "Enter delivery time",
    "enterPickupTime": "Enter pickup time",
    "enterNotes": "Enter any additional notes",
    "cash": "Cash",
    "card": "Card",
    "online": "Online",
    "customerCart": "Customer Cart",
    "addToCart": "Add to Cart",
    "item": "Item",
    "quantity": "Quantity",
    "total": "Total",
    "remove": "Remove",
    "orderSummary": "Order Summary",
    "itemsCount": "Items Count",
    "createOrder": "Create Order",
    "orderCreatedSuccessfully": "Order created successfully",
    "checkoutSuccessTitle": "Order #<orderId>{{orderId}}</orderId> has been made successfully!",
    "checkoutSuccessTitleNoId": "Order has been made successfully!",
    "checkoutSuccessSubtitle": "Does the customer want to make another order?",
    "anotherOrder": "Another Order",
    "newOrder": "New Order",
    "orderCreationFailed": "Failed to create order",
    "buy4Get2Offer": "Buy 4 Get 2 Offer Applied",
    "currency": "EGP",
    "pieces": "pieces",
    "specialOffer": "Special Offer",
    "specialOfferDescription": "This product is currently on offer!",
    "productId": "Product ID",
    "buy4Get2OfferApplied": "Buy 4 Get 2 Offer Applied",
    "selectPointOnMap": "Select Point On Map",
    "buildingNumber": "Building Number",
    "street": "Street",
    "floor": "Floor",
    "apartmentNumber": "Apartment Number",
    "buildingNumberRequired": "Please enter building number",
    "streetRequired": "Please enter street name",
    "writeBuildingNumber": "Write Building Number",
    "writeStreetName": "Write Street Name",
    "writeFloorNumber": "Write Floor Number",
    "writeApartmentNumber": "Write Apartment Number",
    "landmark": "Landmark",
    "writeLandmark": "Write Landmark",
    "notifications": "Notifications",
    "addNewAddress": "Add New Address",
    "addAddress": "Add Address",
    "editAddress": "Edit Address",
    "updateAddress": "Update Address",
    "addressName": "Address Name",
    "addressNameRequired": "Please enter address name",
    "writeAddressName": "Write Address Name",
    "location": "Location",
    "default": "Default",
    "selectDefault": "Select Default",
    "yes": "Yes",
    "no": "No",
    "map": "Map",
    "searchPlaceholder": "Search for a location...",
    "noResultsFound": "No results found",
    "selectStore": "Select Store",
    "storeSelected": "Store selected successfully",
    "pleaseCompleteAllFields": "Please complete all required fields",
    "formValidatedSuccessfully": "Form validated successfully",
    "formValidationFailed": "Form validation failed",
    "formValidationErrors": "Form Validation Errors",
    "formReady": "Form Ready",
    "allRequiredFieldsCompleted": "All required fields have been completed",
    "validateForm": "Validate Form",
    "customerLoadedSuccessfully": "Customer data loaded successfully",
    "customerLoadFallback": "Using local customer data",
    "customerLoadError": "Failed to load customer data from server",
    "stockInformation": "Stock Information",
    "stockDescription": "Number of products in branches",
    "totalStock": "All Stock",
    "yourCart": "Your Cart",
    "itemsCountShort": "items",
    "totalDue": "Total Due",
    "uncompleted": "Uncompleted",
    "selectChannel": "Select Channel",
    "chooseChannel": "Choose Channel",
    "customerSegment": "Customer Segment",
    "chooseCustomerSegment": "Choose Customer Segment",
    "customerNote": "Customer Note",
    "writeNote": "Write Note",
    "attachments": "Attachments",
    "attachFiles": "Attach files",
    "shoppingCart": "Shopping cart",
    "expandCart": "Show cart details",
    "collapseCart": "Hide cart details",
    "showCart": "Show cart",
    "hideCart": "Hide cart",
    "dateRequired": "Please select a date",
    "selectDate": "Select Date",
    "timeRequired": "Please select a time",
    "selectTime": "Select Time",
    "noDeliveryTimes": "No delivery times available",
    "maxAttachments": "Max 5 attachments",
    "errorLoadingAddress": "Failed to load address",
    "viewCustomerInfo": "View Customer Info",
    "loadingCustomer": "Loading customer info...",
    "noPermission": "You don't have permission",
    "stockByBranch": "Stock by Branch",
    "loadingStockInfo": "Loading stock information...",
    "noStockInfo": "No stock information available",
    "stockInfoError": "Failed to load stock information",
    "numberOfProductInBranches": "Number of product in branches",
    "allStock": "All Stock",
    "productStockInformation": "Product Stock Information in each branch",
    "info": "Info",
    "ordersNo": "Orders No.",
    "lastOrderDate": "Last Order Date",
    "lastOrderStatus": "Last Order Status",
    "totalOrdersAmounts": "Total Orders Amounts",
    "loadingOrdersInfo": "Loading orders info...",
    "ordersHistory": "Orders History",
    "loading": "Loading...",
    "noDataAvailable": "No data available",
    "mostRequestedProducts": "Most Requested Products",
    "notAvailableProducts": "Not Available Products",
    "lastComplains": "Complains",
    "lastInquiries": "Inquiries",
    "lastOrders": "Last 5 Orders",
    "complain": "Complain",
    "response": "Response",
    "inquiry": "Inquiry",
    "description": "Description",
    "subject": "SUBJECT",
    "complainType": "COMPLAIN TYPE",
    "status": "STATUS",
    "createdAt": "CREATED AT",
    "activityType": "ACTIVITY TYPE",
    "details": "DETAILS",
    "orderId": "ORDER ID",
    "orderCreatedAt": "ORDER CREATED AT",
    "orderStatus": "ORDER STATUS",
    "storeName": "STORE",
    "action": "ACTION",
    "view": "View",
    "close": "Close",
    "errorLoadingCustomerInfo": "Failed to load customer information",
    "buyThisProduct": "Buy this product",
    "buy": "Buy",
    "get": "Get",
    "at": "at",
    "off": "OFF",
    "fromGroupOfOtherProducts": "from the group of other products",
    "loseOffer": "Lose Offer",
    "addProductWithoutOffer": "Add product without offer",
    "productUpdatedSuccessfully": "Product updated successfully",
    "failedToRemoveOfferFromCart": "Failed to remove offer from cart",
    "productsRelatedToOffer": "Products Related To The Offer",
    "chooseOneProductFromThese": "Choose one product from these products to apply the offer",
    "groupOffer": "Group Offer",
    "selectFromMainAndRelated": "Select products from main group and related products",
    "mainProducts": "Main Products",
    "selectMainProductsInstruction": "Select main products",
    "relatedProductsFree": "Related Products (Free)",
    "selectRelatedProductsInstruction": "Select free products",
    "buyMinProducts": "Buy {{count}} product(s)",
    "getFreeProducts": "Get {{count}} free product(s)",
    "getDiscountProducts": "Get {{count}} product(s) at {{discount}}% OFF",
    "selectMainFirst": "Select {{count}} product(s) from main products first",
    "mustChooseToGetOffer": "You must choose {{count}} product(s) from the above to get the offer",
    "chooseProductsUpToQuantity": "Choose products with total quantity {{current}}/{{max}} (you can distribute across multiple products)",
    "lowestPriceDiscount": "Applied to lowest price",
    "units": "units",
    "relatedProductsDiscount": "Related Products ({{discount}}% OFF)",
    "addOffer": "Add Offer",
    "updateOffer": "Update Offer",
    "productAddedToCart": "Product added to cart successfully",
    "freeTextItemAdded": "Free text item added to cart successfully",
    "freeTextItemAddFailed": "Failed to add free text item to cart",
    "freeTextItemUpdated": "Free text item updated successfully",
    "freeTextItemUpdateFailed": "Failed to update free text item",
    "freeText": {
      "title": "Add New Free Text Item",
      "editTitle": "Edit Free Text Item",
      "productName": "Product Name",
      "productNameRequired": "Please enter product name",
      "productNamePlaceholder": "Write Product Name",
      "price": "Price",
      "priceRequired": "Please enter price",
      "priceInvalid": "Please enter valid price",
      "pricePlaceholder": "Write Product Price",
      "measureUnit": "Measure Unit",
      "measureUnitRequired": "Please select measure unit",
      "measureUnitQuantity": "Quantity",
      "measureUnitWeight": "Weight",
      "gram": "Gram",
      "gramHint": "1 KG = 1000 Gram",
      "gramRequired": "Please enter weight in grams",
      "gramInvalid": "Please enter a valid number",
      "gramPlaceholder": "Enter grams",
      "menuQuantity": "Menu Quantity",
      "menuQuantityRequired": "Please enter menu quantity",
      "menuQuantityInvalid": "Please enter valid quantity",
      "menuQuantityPlaceholder": "Write Menu Quantity",
      "note": "Note",
      "notePlaceholder": "Write Note",
      "close": "Close",
      "addItem": "Add Item",
      "saveItem": "Save"
    },
    "offerAddedToCart": "Offer added to cart successfully",
    "offerUpdatedInCart": "Offer updated in cart successfully",
    "errorAddingToCart": "Failed to add product to cart",
    "errorAddingOffer": "Failed to add offer to cart",
    "quantityMismatch": "Related products quantity must match main product quantity",
    "groupOfferMinCountError": "Please select at least {{count}} product(s) to get this offer",
    "minCountRequired": "You need to buy at least {{count}} product(s) to get this offer",
    "relatedQuantityMismatch": "Please select {{count}} related product(s) for this offer",
    "buyMinToGetOffer": "Buy at least {{min}} to get {{get}} free",
    "productUpdatedInCart": "Product updated in cart successfully",
    "commentUpdatedSuccessfully": "Comment updated successfully!",
    "commentUpdateFailed": "Failed to update comment. Please try again.",
    "addressUpdatedSuccessfully": "Address updated successfully!",
    "addressCreatedSuccessfully": "Address created successfully!",
    "addressUpdateFailed": "Failed to update address",
    "addressCreateFailed": "Failed to create address",
    "addressSaveFailed": "Failed to save address. Please try again.",
    "customerCreatedSuccessfully": "Customer created successfully!",
    "customerCreateFailed": "Failed to create customer",
    "customerSelectFailed": "Failed to select the newly created customer. Please try selecting it manually.",
    "networkError": "Network error. Please check your connection and try again.",
    "unexpectedError": "An unexpected error occurred. Please try again.",
    "missingRequiredFields": "Please select customer and store",
    "companyIdRequired": "Company ID is required",
    "offerIdRequired": "Offer ID is required",
    "cartEmpty": "Cart is empty",
    "fillRequiredFields": "Please fill all required fields",
    "fieldRequired": "Please fill all required fields",
    "extras": "Extras",
    "categories": "Categories",
    "title": "Add New Order",
    "orderDetails": "Order Details",
    "customer": "Customer",
    "phone": "Phone",
    "address": "Address",
    "pickupLocation": "Pickup Location",
    "filterByCategory": "Filter by Category",
    "selectCategory": "Select Category",
    "product": "Product",
    "productName": "Product Name",
    "price": "Price",
    "stock": "Stock",
    "selectUnit": "Select Unit",
    "unitRequired": "Please select a unit",
    "inCart": "In Cart",
    "totalAttributes": "Total Attributes",
    "totalExtras": "Total Extras",
    "attributes": "Attributes",
    "unit": "Unit",
    "summary": "Summary",
    "saveAndAddMore": "Save and Add More",
    "mainQuantityMustBeMultiple": "Main products quantity must be a multiple of {{count}} (e.g., {{count}}, {{double}}, {{triple}}, etc.)"
  },
  "cancelOrder": {
    "title": "Hold Order Reason",
    "customerName": "Customer Name",
    "customerPhone": "Customer Phone",
    "reasonToCancel": "Reason to Hold",
    "holdOrder": "Hold Order",
    "comment": "Comment",
    "selectReason": "Select a Reason",
    "customerNamePlaceholder": "Customer Name",
    "customerPhonePlaceholder": "Customer Phone",
    "commentPlaceholder": "Enter your comment here...",
    "reasonRequired": "Please select a reason",
    "missingRequiredFields": "Customer ID or Store ID is missing",
    "successMessage": "Order cancelled successfully",
    "errorMessage": "Failed to cancel order",
    "noReasonsFound": "No reasons found"
  },
  "activitySections": {
    "tableTitle": "All Sections",
    "savedSuccessfully": "Activity sections saved successfully",
    "failedSave": "Failed to save activity sections",
    "editActivitySections": "Edit Activity Sections",
    "addActivitySections": "Add Activity Sections",
    "noCreatePermission": "You don't have permission to create activity sections"
  },
  "aiDistribution": {
    "AIDistribution": "AI distribution",
    "priority1": "priority #1",
    "priority2": "priority #2",
    "priority3": "priority #3",
    "priority4": "priority #4",
    "priority5": "priority #5",
    "vipCustomer": "Vip Customer",
    "nearestLocation": "Nearest location",
    "orderTotalCash": "Order total cash",
    "maxOrderCount": "max order count",
    "oldestOrder": "oldest order"
  },
  "skillsList": {
    "tableTitle": "All Skills",
    "addModalTitle": "Add Skill",
    "editModalTitle": "Edit Skill",
    "noCreatePermission": "You don't have permission to create skills",
    "savedSuccessfully": "Skill saved successfully",
    "createdSuccessfully": "Skill created successfully",
    "failedSave": "Failed to save the skill",
    "writeNameEn": "Write name in English...",
    "writeNameAr": "Write name in Arabic...",
    "writePoints": "Enter points...",
    "columns": {
      "nameEn": "Name En",
      "nameAr": "Name Ar",
      "points": "Points",
      "status": "Status"
    }
  },
  "serviceTypesList": {
    "tableTitle": "All Service Types",
    "addModalTitle": "Add Service Type",
    "editModalTitle": "Edit Service Type",
    "noCreatePermission": "You don't have permission to create service types",
    "savedSuccessfully": "Service type saved successfully",
    "createdSuccessfully": "Service type created successfully",
    "failedSave": "Failed to save the service type",
    "writeNameEn": "Write name in English...",
    "writeNameAr": "Write name in Arabic...",
    "writeDescriptionEn": "Write description in English...",
    "writeDescriptionAr": "Write description in Arabic...",
    "writePrice": "Enter price...",
    "columns": {
      "nameEn": "Name En",
      "nameAr": "Name Ar",
      "descriptionEn": "Description En",
      "descriptionAr": "Description Ar",
      "price": "Price",
      "status": "Status"
    }
  },
  "tripTypesList": {
    "tableTitle": "All Trip Types",
    "addModalTitle": "Add Trip Type",
    "editModalTitle": "Edit Trip Type",
    "noCreatePermission": "You don't have permission to create trip types",
    "savedSuccessfully": "Trip type saved successfully",
    "createdSuccessfully": "Trip type created successfully",
    "failedSave": "Failed to save the trip type",
    "writeNameEn": "Write name in English...",
    "writeNameAr": "Write name in Arabic...",
    "columns": {
      "nameEn": "Name En",
      "nameAr": "Name Ar"
    }
  },
  "shoppersList": {
    "tableTitle": "All Shoppers",
    "addModalTitle": "Add Shopper",
    "editModalTitle": "Edit Shopper",
    "noCreatePermission": "You don't have permission to create shoppers",
    "savedSuccessfully": "Shopper saved successfully",
    "createdSuccessfully": "Shopper created successfully",
    "failedSave": "Failed to save the shopper",
    "writeName": "Enter name...",
    "writeUserName": "Enter username...",
    "writePassword": "Enter password...",
    "writeFCM": "Enter FCM token...",
    "writeMaxOrder": "Enter max order...",
    "writeSalary": "Enter salary...",
    "writeShipmentCommission": "Enter shipment commission...",
    "writeRejectDeduct": "Enter reject deduct...",
    "writeLatitude": "Enter latitude...",
    "writeLongitude": "Enter longitude...",
    "password": "Password",
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least 6 characters",
    "fcm": "FCM Token",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "skills": "Skills",
    "stores": "Stores",
    "selectType": "Select type...",
    "selectSkills": "Select skills...",
    "selectStores": "Select stores...",
    "show": "Show",
    "viewModalTitle": "View Shopper",
    "columns": {
      "id": "Id",
      "name": "Name",
      "userName": "Username",
      "type": "Type",
      "status": "Status",
      "active": "Active",
      "online": "Online",
      "maxOrder": "Max Order",
      "salary": "Salary",
      "shipmentCommission": "Shipment Commission",
      "rejectDeduct": "Reject Deduct"
    },
    "type": {
      "collector": "Collector",
      "driver": "Driver",
      "joker": "Joker"
    }
  },
  "shopperOrderStatusList": {
    "tableTitle": "All Shopper Order Statuses",
    "addModalTitle": "Add Shopper Order Status",
    "editModalTitle": "Edit ",
    "viewModalTitle": "View ",
    "noCreatePermission": "You don't have permission to create shopper order statuses",
    "savedSuccessfully": "Shopper order status saved successfully",
    "createdSuccessfully": "Shopper order status created successfully",
    "failedSave": "Failed to save the shopper order status",
    "writeName": "Enter name...",
    "writeSort": "Enter sort order...",
    "duplicateSort": "This sort value is already used by another status",
    "selectOrderStatus": "Select order status...",
    "show": "Show",
    "confirmUnlink": "Are you sure you want to unlink these statuses?",
    "unlinkedSuccess": "Statuses unlinked successfully",
    "linkedSuccess": "Statuses linked successfully",
    "alreadyLinked": "These statuses are already linked",
    "alreadyHasLink": "This status is already linked to another status. Please unlink it first.",
    "unlinkedStatuses": "Unlinked Statuses",
    "selectSecondNode": "Click on another status to link them",
    "linkedSteps": "Linked Steps",
    "howToLink": "To link: Click on one status, then click on another. To unlink: Click on a connection line. To edit: Click the edit icon on a status.",
    "removeFromGraph": "Remove from graph",
    "cannotRemoveWithConnections": "Cannot remove status from graph. Please unlink all connections first.",
    "removedFromGraph": "Status removed from graph. You can add it back by dragging it from the unlinked list.",
    "columns": {
      "name": "Name",
      "orderStatus": "Order Status",
      "sort": "Sort",
      "isCollector": "Is Collector",
      "forShopper": "For Shopper",
      "startCollect": "Start Collect",
      "markCollectedItems": "Mark Collected Items",
      "collectItemsBtn": "Collect Items Button",
      "paidForBtn": "Paid For Button",
      "startDeliveryBtn": "Start Delivery Button",
      "reportMissingBtn": "Report Missing Button",
      "delivedBtn": "Delivered Button",
      "returnBtn": "Return Button",
      "notDeliveredBtn": "Not Delivered Button",
      "confirmedBtn": "Confirmed Button",
      "isDone": "Is Done",
      "isMissing": "Is Missing",
      "isNotDelivered": "Is Not Delivered",
      "isReturned": "Is Returned",
      "pushToOdoo": "Push To Odoo"
    }
  },
  "dmsDashboard": {
    "title": "DMS Dashboard",
    "dateRange": "Date Range",
    "store": "Store",
    "allStores": "All Stores",
    "applyFilters": "Apply Filters",
    "selectDateRange": "Please select a date range",
    "fetchError": "Failed to fetch dashboard data",
    "noData": "No data available. Please apply filters.",
    "totalShopperOrders": "Total Shopper Orders",
    "totalShopperSales": "Total Shopper Sales",
    "totalAreaOrders": "Total Area Orders",
    "totalAreaSales": "Total Area Sales",
    "shopperOrders": "Shopper Orders",
    "shopperSales": "Shopper Sales",
    "areaOrders": "Area Orders",
    "areaSales": "Area Sales",
    "shopper": "Shopper",
    "area": "Area",
    "ordersCount": "Orders Count",
    "totalSales": "Total Sales"
  },
  "dmsReports": {
    "title": "DMS Reports",
    "dashboardTab": "Dashboard",
    "top10DriversTab": "Top 10 Drivers",
    "driverName": "Agent Name",
    "shopperId": "Shopper ID",
    "username": "Username",
    "status": "Status",
    "active": "Active",
    "online": "Online",
    "ordersCount": "Orders Count",
    "noDataFound": "No drivers found for the selected criteria",
    "averageOrders": "Average Number of Orders",
    "avgDeliveryTimeDaily": "Average Daily Delivery Time",
    "avgDeliveryTimeWeekly": "Average Weekly Delivery Time",
    "avgDeliveryTimeMonthly": "Average Monthly Delivery Time",
    "avgDeliveryTimeYearly": "Average Annual Delivery Time",
    "avgDeliveryTimePerOrder": "Average Delivery Time per Order",
    "avgRejectedOrdersDaily": "Average Daily Rejected Orders",
    "avgRejectedOrdersWeekly": "Average Weekly Rejected Orders",
    "avgRejectedOrdersMonthly": "Average Monthly Rejected Orders",
    "avgRejectedOrdersYearly": "Average Annual Rejected Orders",
    "avgDistance": "Average Distance Traveled",
    "avgIncentiveDaily": "Average Daily Incentive",
    "avgIncentiveWeekly": "Average Weekly Incentive",
    "avgIncentiveMonthly": "Average Monthly Incentive",
    "avgDiscountDaily": "Average Daily Discount",
    "avgDiscountWeekly": "Average Weekly Discount",
    "avgDiscountMonthly": "Average Monthly Discount",
    "ratingDaily": "Daily Rating",
    "ratingWeekly": "Weekly Rating",
    "ratingMonthly": "Monthly Rating",
    "avgComplaints": "Average Number of Complaints"
  },
  "prediction": {
    "title": "Prediction",
    "from": "From",
    "to": "To",
    "search": "Search",
    "perOrder": "Per Order",
    "perAgent": "Per Agent",
    "perCollector": "Per Collector",
    "perDriver": "Per Driver",
    "predictNextMonth": "Predict Next Month",
    "totalOrders": "Total Orders",
    "lastYear": "Last Year",
    "totalAgent": "Total Agent",
    "drivers": "Drivers",
    "order": "Order",
    "agents": "Agents",
    "collector": "Collector",
    "store": "Store",
    "allStores": "All Stores",
    "noData": "No data. Select a date range and click Search.",
    "growthRate": "Growth Rate",
    "growthRateTrend": "Growth Rate Trend",
    "avgOrdersPerMonth": "Avg Orders / Month",
    "cancellationRate": "Cancellation Rate",
    "cancellationRateTrend": "Cancellation Rate Trend",
    "avgDeliveryTime": "Avg Delivery Time",
    "avgDeliveryTimeTrend": "Avg Delivery Time Trend",
    "totalRevenue": "Total Revenue",
    "min": "min",
    "minUnit": "m"
  },
  "purchasing": {
    "predict": {
      "title": "Predict Products Purchasing",
      "subtitle": "in page below products will be out of stock soon",
      "selectCustomer": "Select Customer",
      "selectCustomerPlaceholder": "Select customer",
      "noCustomerSelected": "Select a customer to see predicted products.",
      "submitRequest": "Create Purchase Request",
      "submitSuccess": "Purchase request created successfully",
      "submitError": "Failed to create purchase request",
      "noProductsSelected": "Toggle Make Request for at least one product first.",
      "updateNeededStockError": "Failed to update needed stock",
      "columns": {
        "index": "#",
        "productName": "Product Name",
        "sku": "SKU",
        "currentStock": "Current Stock",
        "price": "Price",
        "count": "Count",
        "makeRequest": "Make Request"
      }
    },
    "requests": {
      "title": "Purchasing Requests",
      "columns": {
        "index": "#",
        "createdAt": "Created At",
        "company": "Company",
        "status": "Status",
        "view": "View"
      },
      "viewBtn": "View",
      "noData": "No purchasing requests yet.",
      "detail": {
        "title": "Request Details",
        "summary": "Request Summary",
        "products": "Products",
        "productName": "Product Name",
        "neededStock": "Needed Stock",
        "complete": "Complete",
        "cancel": "Cancel",
        "completeConfirm": "Mark this request as completed?",
        "cancelConfirm": "Cancel this request?",
        "completeSuccess": "Request completed",
        "cancelSuccess": "Request cancelled",
        "actionError": "Action failed. Please try again."
      }
    },
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "unknown": "Unknown"
    }
  },
  "agentKpi": {
    "title": "Drivers KPI",
    "from": "From",
    "to": "To",
    "search": "Search",
    "fetchError": "Failed to fetch agent KPI data",
    "noData": "No data available. Please apply filters.",
    "noDataFound": "No agents found for the selected criteria",
    "agentName": "Agent Name",
    "averageOrders": "Avg # Orders",
    "avgDeliveryTimeDaily": "Avg Daily Delivery Time",
    "avgDeliveryTimeWeekly": "Avg Weekly Delivery Time",
    "avgDeliveryTimeMonthly": "Avg Monthly Delivery Time",
    "avgDeliveryTimeYearly": "Avg Yearly Delivery Time",
    "avgDeliveryTimePerOrder": "Avg Delivery Time Per Order",
    "avgRejectedOrdersDaily": "Avg Daily Rejected Orders",
    "avgRejectedOrdersWeekly": "Avg Weekly Rejected Orders",
    "avgRejectedOrdersMonthly": "Avg Monthly Rejected Orders",
    "avgRejectedOrdersYearly": "Avg Yearly Rejected Orders",
    "avgDistance": "Avg Distance Traveled",
    "avgIncentiveDaily": "Avg Daily Incentive",
    "avgIncentiveWeekly": "Avg Weekly Incentive",
    "avgIncentiveMonthly": "Avg Monthly Incentive",
    "avgDiscountDaily": "Avg Daily Discount",
    "avgDiscountWeekly": "Avg Weekly Discount",
    "avgDiscountMonthly": "Avg Monthly Discount",
    "ratingDaily": "Daily Rating",
    "ratingWeekly": "Weekly Rating",
    "ratingMonthly": "Monthly Rating",
    "avgComplaints": "Avg Complaints Count"
  },
  "dmsTop10Shoppers": {
    "title": "Top 10 Shoppers",
    "dateRange": "Date Range",
    "store": "Store",
    "allStores": "All Stores",
    "applyFilters": "Apply Filters",
    "selectDateRange": "Please select a date range",
    "fetchError": "Failed to fetch top 10 shoppers data",
    "noData": "No data available. Please apply filters.",
    "noDataFound": "No shoppers found for the selected criteria",
    "shopperId": "Shopper ID",
    "shopperName": "Shopper Name",
    "username": "Username",
    "status": "Status",
    "active": "Active",
    "online": "Online",
    "ordersCount": "Orders Count",
    "from": "From",
    "to": "To",
    "viewShopper": "View Shopper Details"
  },
  "sallaOrders": {
    "title": "Salla Orders",
    "orders": "Orders",
    "purchasedOrders": "Purchased Orders",
    "orderNumber": "Order Number",
    "printTitle": "Purchase Order",
    "purchaseOrder": "PURCHASE ORDER",
    "supplierName": "Name",
    "supplierPhone": "Phone",
    "supplierAddress": "Address",
    "supplierWhatsapp": "Whatsapp",
    "paymentMethod": "Payment Method",
    "selectMethod": "Select Method",
    "selectStatus": "Select Status",
    "createdFrom": "Created from",
    "createdTo": "Created to",
    "selectDate": "mm / dd / yyyy",
    "pending": "Pending",
    "processing": "Processing",
    "shipped": "Shipped",
    "delivered": "Delivered",
    "canceled": "Canceled",
    "status": "Status",
    "total": "Total",
    "createdAt": "Created At",
    "orderId": "Order ID",
    "supplier": "Supplier",
    "quantity": "Quantity",
    "subTotal": "Sub Total",
    "totalDiscount": "Total Discount",
    "purchase": "Purchase",
    "purchased": "Purchased",
    "purchaseSuccess": "Order purchased successfully",
    "purchaseError": "Failed to purchase order",
    "bulkPurchase": "Purchase Selected",
    "bulkPurchaseSuccess": "Orders purchased successfully",
    "bulkPurchaseError": "Failed to purchase orders",
    "selectOrders": "Please select orders to purchase",
    "confirmPurchase": "Are you sure you want to purchase this order?",
    "confirmBulkPurchase": "Are you sure you want to purchase selected orders?",
    "orderDetails": "Order Details",
    "fetchError": "Failed to fetch order details"
  },
  "suppliers": {
    "tableTitle": "All Suppliers",
    "modalTitle": "Add Supplier",
    "editModalTitle": "Edit Supplier",
    "name": "Name",
    "nameAr": "Name (Arabic)",
    "nameEn": "Name (English)",
    "nameArPlaceholder": "Enter name in Arabic",
    "nameEnPlaceholder": "Enter name in English",
    "addressAr": "Address (Arabic)",
    "addressEn": "Address (English)",
    "addressArPlaceholder": "Enter address in Arabic",
    "addressEnPlaceholder": "Enter address in English",
    "phone": "Phone",
    "phonePlaceholder": "Enter phone number",
    "whatsapp": "WhatsApp",
    "whatsappPlaceholder": "Enter WhatsApp number",
    "email": "Email",
    "emailPlaceholder": "Enter email address",
    "logo": "Logo",
    "uploadLogo": "Upload Logo",
    "status": "Status",
    "required": "This field is required",
    "invalidEmail": "Please enter a valid email",
    "uploadImageOnly": "You can only upload image files!",
    "imageSizeLimit": "Image must be smaller than 2MB!",
    "createSuccess": "Supplier created successfully",
    "updateSuccess": "Supplier updated successfully",
    "saveError": "Failed to save supplier. Please try again.",
    "noCreatePermission": "You don't have permission to create suppliers"
  },
  "custody": {
    "title": "Shopper Custody",
    "subtitle": "Manage and monitor custodial fund flows across the organization.",
    "giveMoney": "Give Money",
    "columns": {
      "date": "Date",
      "total": "Total",
      "byWho": "By Who",
      "notes": "Notes"
    },
    "tabs": {
      "all": "All",
      "given": "Given",
      "received": "Received"
    },
    "stats": {
      "totalReceived": "Total Received",
      "totalGiven": "Total Given",
      "remainingBalance": "Remaining Balance",
      "liquidity": "Liquidity: High"
    },
    "orders": {
      "title": "Orders Summary",
      "totalOrders": "Total Orders",
      "cashOrders": "Cash Orders",
      "codOrders": "COD Orders",
      "returnedOrders": "Returned Orders",
      "totalOrdersAmount": "Total Orders Amount",
      "cashOrdersAmount": "Cash Orders Amount"
    },
    "modal": {
      "title": "Give Money",
      "amount": "Amount",
      "amountPlaceholder": "Enter amount...",
      "amountMin": "Amount must be greater than 0",
      "type": "Type",
      "notes": "Notes",
      "notesPlaceholder": "Optional notes...",
      "successMessage": "Transaction recorded successfully",
      "errorMessage": "Failed to process transaction"
    }
  },
  "notifications": {
    "slaBreach": {
      "title": "Closing time passed",
      "body": "{{type}} #{{id}}{{priority}} is still open after its closing time"
    },
    "slaWarning": {
      "title": "Closing time approaching",
      "body": "{{type}} #{{id}}{{priority}} must be closed soon"
    },
    "slaAutoClosed": {
      "title": "Ticket closed automatically",
      "body": "{{type}} #{{id}}{{priority}} reached its closing time and was closed automatically"
    },
    "unknown": "Unknown",
    "customer": "Customer",
    "openTicket": "Open ticket",
    "copyId": "Copy ID",
    "activityType": {
      "activity": "Activity",
      "inquiry": "Inquiry",
      "complaint": "Complaint"
    },
    "newOrder": {
      "title": "New order",
      "body": "Store has new order: #{{id}}"
    },
    "orderMissing": {
      "title": "Missing order",
      "body": "Order #{{id}} is missing"
    },
    "changeOrderPay": {
      "title": "Change order payment",
      "body": "Payment changed in order: #{{id}}"
    },
    "cancelOrder": {
      "title": "Cancel order",
      "body": "Order #{{id}} has been canceled"
    },
    "returnOrder": {
      "title": "Returned order",
      "body": "Order #{{id}} has been returned"
    },
    "newActivity": {
      "title": "New {{type}}",
      "body": "New {{type}} #{{id}} created by {{by}}",
      "bodyBeforeId": "New {{type}} ",
      "bodyAfterId": " created by {{by}}"
    },
    "activityReply": {
      "title": "New Reply",
      "body": "New reply on {{type}} #{{id}} by {{by}}",
      "bodyBeforeId": "New reply on {{type}} ",
      "bodyAfterId": " by {{by}}"
    },
    "statusChanged": {
      "title": "Status Changed",
      "body": "{{type}} #{{id}} status changed by {{by}}",
      "bodyBeforeId": "{{type}} ",
      "bodyAfterId": " status changed by {{by}}"
    },
    "center": {
      "title": "Notifications",
      "empty": "No notifications yet",
      "markAllRead": "Mark all read",
      "clearAll": "Clear all",
      "copyId": "Copy ID {{id}}",
      "idCopied": "ID copied: {{id}}",
      "idCopyFailed": "Failed to copy ID"
    },
    "import": {
      "file": "file",
      "entity": {
        "product": "Products",
        "category": "Categories",
        "offer": "Offers",
        "attribute": "Attributes",
        "extra": "Extras",
        "productUnit": "Product units",
        "productAttribute": "Product attributes",
        "productExtra": "Product extras"
      },
      "completedTitle": "{{entity}} import completed",
      "completedBody": "{{file}}: {{rows}} rows imported in {{jobs}} batches",
      "partialTitle": "{{entity}} import finished with errors",
      "partialBody": "{{file}}: {{failed}} of {{jobs}} batches failed ({{rows}} rows)"
    }
  },
  "driverTracker": {
    "ready": "Ready",
    "outForDelivery": "Out for Delivery",
    "blocked": "Blocked",
    "break": "Break",
    "drivers": "Drivers",
    "noDrivers": "No drivers found",
    "orders": "Orders",
    "stores": "Stores",
    "noStores": "No stores found",
    "lastUpdate": "Last update",
    "phone": "Phone",
    "status": "Status",
    "fetchError": "Failed to fetch tracking data",
    "showAll": "Show All Stores with Drivers",
    "location": "Location"
  },
  "shippingDetails": {
    "success": "Shipping info updated successfully",
    "error": "Failed to update shipping info",
    "noMapLocation": "No location is available for this address.",
    "viewOnMap": "View on Map",
    "address": "Address",
    "selectAddress": "Select delivery address",
    "deliveryDateDetails": "Delivery Date Details",
    "deliveryDate": "Delivery Date",
    "deliveryTime": "Delivery Time",
    "timeSlot": "From {{from}} To {{to}} - Price {{fees}} {{currency}}",
    "selectDeliveryTime": "Select delivery time",
    "customerServiceComment": "Customer Service Comment",
    "branchComment": "Branch Comment",
    "enterComment": "Enter comment",
    "enterBranchComment": "Enter branch comment",
    "updateChanges": "Update Changes",
    "apartment": "Apartment {{value}}",
    "street": "{{value}} Street",
    "building": "Building {{value}}",
    "floor": "Floor {{value}}",
    "am": "AM",
    "pm": "PM"
  },
  "home": {
    "welcome": "Welcome",
    "orders": "Orders",
    "customers": "Customers",
    "reports": "Reports",
    "stores": "Stores"
  },
  "pharmacistWorkspace": {
    "title": "Pharmacist Workspace",
    "queueTitle": "Prescription review",
    "reviewTitle": "Prescription review",
    "open": "Open",
    "claim": "Claim",
    "claimed": "Prescription claimed",
    "claimFailed": "Failed to claim",
    "decisionSaved": "Decision saved",
    "decisionFailed": "Failed to save decision",
    "decision": "Decision",
    "approve": "Approve",
    "reject": "Reject",
    "requestClarification": "Request clarification",
    "proposeAlternative": "Propose alternative",
    "rejectReason": "Reject reason",
    "note": "Note",
    "saveDecision": "Save decision",
    "images": "Prescription images",
    "lines": "OCR / medication lines",
    "noLines": "No OCR lines yet (filled by mobile upload later)",
    "lineName": "Name",
    "lineQty": "Qty",
    "lineNotes": "Notes",
    "events": "Audit events",
    "actor": "Actor",
    "comment": "Comment",
    "filters": {
      "status": "Status",
      "store": "Store",
      "unclaimed": "Unclaimed",
      "unclaimedOnly": "Unclaimed only"
    },
    "columns": {
      "customer": "Customer",
      "phone": "Phone",
      "store": "Store",
      "status": "Status",
      "age": "Age (min)",
      "claimedBy": "Claimed by",
      "actions": "Actions"
    }
  },
  "refunds": {
    "title": "Refunds",
    "tableTitle": "Refunds",
    "requestRefund": "Request Refund",
    "refundableAmount": "Refundable amount",
    "refundedTotal": "Refunded",
    "pendingTotal": "Pending",
    "fullRefund": "Full refund",
    "partialRefund": "Partial refund",
    "amountRange": "Amount must be between 0.01 and {{max}}",
    "requestedAwaitingApproval": "Refund requested and waiting for approval",
    "requestedApproved": "Refund requested and approved",
    "requestFailed": "Refund request failed",
    "empty": "No refunds yet",
    "searchPlaceholder": "Order ID",
    "autoApproved": "auto",
    "awaitingApproval": "Awaiting approval",
    "toSettle": "To settle",
    "closedUnpaid": "Failed / rejected",
    "countLabel": "{{count}} refunds",
    "approve": "Approve",
    "approveConfirm": "Approve this refund?",
    "approved": "Refund approved",
    "reject": "Reject",
    "rejectTitle": "Reject refund",
    "rejected": "Refund rejected",
    "markProcessing": "Processing",
    "processingConfirm": "Mark this refund as processing?",
    "markedProcessing": "Refund marked as processing",
    "markSucceeded": "Mark as succeeded",
    "markedSucceeded": "Refund marked as succeeded",
    "markFailed": "Mark as failed",
    "markedFailed": "Refund marked as failed",
    "actionFailed": "Action failed",
    "fields": {
      "amount": "Amount",
      "mode": "Refund method",
      "status": "Status",
      "reason": "Reason",
      "order": "Order",
      "requestedBy": "Requested by",
      "approvedBy": "Approved / rejected by",
      "gatewayReference": "Gateway / receipt reference",
      "rejectionReason": "Rejection reason",
      "failureReason": "Failure reason",
      "actions": "Actions",
      "processedBy": "Processed by",
      "paymentReference": "Payment reference",
      "approvalRule": "Approval rule"
    },
    "filters": {
      "from": "From date",
      "to": "To date"
    },
    "modes": {
      "gateway": "Payment gateway",
      "wallet": "Wallet",
      "cash": "Cash"
    },
    "statuses": {
      "requested": "Requested",
      "approved": "Approved",
      "rejected": "Rejected",
      "processing": "Processing",
      "succeeded": "Succeeded",
      "failed": "Failed"
    },
    "details": "Refund details",
    "viewDetails": "View details"
  },
  "refundApprovalRules": {
    "tableTitle": "Refund Approval Rules",
    "create": "Create Approval Rule",
    "edit": "Edit Approval Rule",
    "saved": "Approval rule saved",
    "saveFailed": "Failed to save approval rule",
    "noCreatePermission": "You don't have permission to create approval rules",
    "allModes": "All methods",
    "modeHint": "Refunds of this method and within the amount range need a second user to approve.",
    "maxBelowMin": "Must be greater than or equal to the from amount",
    "fields": {
      "title": "Title",
      "minAmount": "From amount",
      "maxAmount": "To amount (empty = no limit)",
      "range": "Amount range"
    }
  }
}
